import angular from 'angular';
import ngRoute from 'angular-route';
import { oneLineTrim, oneLine } from 'common-tags';
import ThreepioLib from 'gitlab:translations/threepio-browser@v1.2.21';
import { cookieBase, flnBillingBaseUrl, cdnUrls, facebookAppId, recaptchaPublicKey, languageCode, cookieDomain } from 'server-data/flconfigs';
import 'npm:angular-component@0.0.8';
import ngResource from 'angular-resource';
import md5Provider from 'npm:angular-md5@0.1.10';
import Raven from 'github:getsentry/sentry-javascript@2.3.0';
import ThreepioLib$1 from 'gitlab:translations/threepio-browser@v1.2.20';
import jq from 'jquery';
import 'css/flux/modules/Modal.less';
import 'npm:angular-easyfb@1.5.2';
import ngMessages from 'angular-messages';
import 'css/flux/modules/ModalLoginSignup.less';
import GoogleMapsLoader from 'google-maps';

var _classCallCheck = (function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
});

var _createClass = (function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

var _taggedTemplateLiteral = (function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
});

/**
* @ngdoc overview
* @name flTranslate
* @module flTranslate
* @description
*
* # flTranslate
* [flTranslate](https://gitlab.freelancer.com/angular/fl-translate) is a Web
* application translation framework using an innovating approach to extract the
* translatable strings JS templates, which mean that you should no longer need
* to annotate your application for translation. If the default extraction
* strategy is failing or returning unexpecting results, check the
* [documentation](https://gitlab.freelancer.com/angular/fl-translate) to learn
* how to handle them.
*
* This specific `flAngular` module is the client side component of that
* framework: once that the strings extracted from the HTML views & JavaScript
* source files have been translated,  
*/
var threepio = angular.module('threepio', [ngRoute]).name;

angular.module(threepio)
/**
 * @ngdoc directive
 * @name threepio.directive:i18nId
 * @element A
 * @function
 *
 * @description
*/
.directive('i18nId', ['$rootScope', '$compile', '$interpolate', 'Translation', 'Localization', function ($rootScope, $compile, $interpolate, Translation, Localization) {
  return {
    restrict: 'A',
    priority: -1,
    link: function link(scope, element) {
      function escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }

      function translate(language) {
        $rootScope.$broadcast('threepio:beforeTranslate');
        Translation.loadTranslations(language).then(function () {
          Translation.translate(element[0]);
        }).finally(function () {
          // Only recompile element if it contains an interpolated expression
          if (scope && element.html() && element.html().match(escapeRegExp($interpolate.startSymbol()))) {
            $compile(element, null, 0)(scope);
          }
          element.removeAttr('i18n-cloak');
          $rootScope.$broadcast('threepio:afterTranslate');
        });
      }

      // Re-translate if the language has changed
      var unsub = $rootScope.$on('TranslationLanguageChange', function () {
        element.data('lang', Localization.language());
        translate(Localization.language());
      });
      scope.$on('$destroy', unsub);

      // Translate at link time if needed
      var lang = Localization.language();
      if (element.data('lang') !== lang) {
        element.data('lang', lang);
        translate(lang);
      }
    }
  };
}]);

angular.module('threepio')
/**
 * @ngdoc directive
 * @name threepio.directive:i18nId
 * @element A
 * @function
 *
 * @description
*/
.directive('i18nSrc', ['$rootScope', 'Localization', function ($rootScope, Localization) {
  return {
    restrict: 'A',
    link: function link(scope, element, attr) {
      function selectSrc() {
        var lang = Localization.language();
        if (lang !== Localization.defaultLanguage()) {
          attr.$set('src', attr.i18nSrc.replace(/\.[^.]*$/, '.' + lang + '$&'));
        } else {
          attr.$set('src', attr.i18nSrc);
        }
      }
      selectSrc();
      // Re-download if the language has changed
      $rootScope.$on('LocalizationLanguageChange', function () {
        selectSrc();
      });
    }
  };
}]);

angular.module('threepio')
/**
 * @ngdoc directive
 * @name threepio.directive:script
 * @restrict E
 *
 * @description
 * Load the content of a `<script>` element with a 'text/threepio'
 * type into the {@link threepio.translationCache `translationCache`}, so
 * that the catalog can be used by the
 * {@link threepio.service:translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/threepio'`.
 * @param {string} lang Language of catalog
 */
.directive('script', ['TranslationsCache', function (TranslationsCache) {
  return {
    restrict: 'E',
    terminal: true,
    compile: function compile(element, attr) {
      if (attr.type === 'text/threepio') {
        var lang = attr.lang;
        // IE is not consistent, in scripts we have to read .text but in
        // other nodes we have to read .textContent
        var text = element[0].textContent.trim();
        TranslationsCache.put(lang, text);
      }
    }
  };
}]);

// FIXME: this is imported from flAngular to make threepio work with

/**
 *
 *
 * @param {any} expires   expiration in seconds
 * @returns               UTC string representation of the date
 *                        plus "expires" seconds
 */
function todayUTCString(expires) {
  var today = new Date();

  today.setTime(today.getTime() + expires * 1000);
  return today.toUTCString();
}

/**
* @ngdoc overview
* @name flCookies
* @module flCookies
* @description
*
* # flCookies
* The `flCookies` module provides a single
* {@link flCookies.CookieStore CookieStore} service that
* streamlines the interaction with the browser's cookies.
* AngularJS has
* {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
* its own $cookieStore implementation} but it doesn't support setting any
* cookie option (e.g. *path*, *domain*, *secure*,
* and *expiration*) as of today. The APIs are the same than Angular's
* {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
* $cookieStore} with an extra parameter (an object with
* ``expires``, ``path``, ``domain`` and ``secure`` as keys, ``expires``
* accepting different formats).
* It is currently used by ``flAuth`` (auth cookies) and ``flAnalytics``
* (tracking cookies), but you can easily use it in a custom service:
*
* ```
  angular.module('myApp')
  .factory('myAwesomeService', function(CookieStore) {
    return {
      setMagicCookie: function(magicNumber) {
        CookieStore.put('CHUCK_NORRIS', magicNumber, {
          expires: Infinity
        });

      ...
    }
  }
* ```
*/
angular.module('threepio')
/**
 * @ngdoc service
 * @name flCookies.CookieStore
 *
 * @description
 * A factory which creates a service that lets you interact with the browser's
 * cookies.
 *
 * The returned object has action methods which provide high-level behaviors
 * without the need to interact with the low level cookies implementation.
 */
.factory('ThreepioCookieStore', ['$document', function ($document) {
  return {
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#get
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Returns the value of given cookie key
     *
     * @param {String} key Id to use for lookup.
     * @returns {Object} Deserialized cookie value.
     */
    get: function get(key) {
      var re = new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$');
      var value = $document[0].cookie.replace(re, '$1');

      return decodeURIComponent(value) || null;
    },

    /**
     * @ngdoc method
     * @name flCookies.CookieStore#put
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Sets a value for given cookie key
     *
     * @param {String} key Id for the `value`.
     * @param {Object} value The value you want to store in this cookie
     * @param {Object} options Additional settings for the cookie (optional):
     *
     * - expires: expiration date for the cookie
     * - domain: the domain for which the cookie is valid
     * - path: the path for which the cookie is valid
     * - secure: is cookie HTTPS only?
     */
    put: function put(key, value, options) {
      // Set cookie
      var cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value);
      // See options
      if (options) {
        // Expiration date
        if (options.expires) {
          var date = void 0;

          switch (options.expires.constructor) {
            case Number:
              {
                if (options.expires === Infinity) {
                  date = 'Fri, 31 Dec 9999 23:59:59 GMT';
                } else {
                  // Note: we don't use max-age here because it's
                  // not supported in IE8.
                  date = todayUTCString(options.expires);
                }
                break;
              }
            case String:
              {
                date = options.expires;
                break;
              }
            case Date:
              {
                date = options.expires.toUTCString();
                break;
              }
            default:
              {
                date = todayUTCString(0);
                break;
              }
          }

          cookie += ';expires=' + date;
        }
        // Domain
        cookie += options.domain ? ';domain=' + options.domain : '';
        // Path
        cookie += options.path ? ';path=' + options.path : ';path=/';
        // HTTPS Only
        cookie += options.secure ? ';secure' : '';
      }
      // Save the cookie
      // Note: $document is a jqLite wrapper
      $document[0].cookie = cookie;
    },

    /**
     * @ngdoc method
     * @name flCookies.CookieStore#remove
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Remove given cookie
     *
     * @param {String} key Id of the key-value pair to delete.
     * @param {Object} options Additional settings for the cookie (optional)
     */
    remove: function remove(key, options) {
      var opt = options || {};
      // Setting expiry date to a past date deletes a cookie
      opt.expires = new Date(0);
      this.put(key, '', opt);
    }
  };
}]);

angular.module('threepio')
/**
 * @ngdoc service
 * @name flTranslate.service:TranslationCache
 *
 * @description
 * Load the content of a `<script>` element with a 'text/fl-translate-catalog'
 * type into the {@link flTranslate.TranslationCache `TranslationCache`}, so
 * that the catalog can be used by the
 * {@link flTranslate.service:Translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/fl-translate-catalog'`.
 * @param {string} lang Language of catalog
 */
.factory('TranslationsCache', ['$cacheFactory', function ($cacheFactory) {
  return $cacheFactory('translationscache');
}]);

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function replaceVariables(message, variables) {
  var fixedMessage = message;

  angular.forEach(variables, function (val, name) {
    fixedMessage = fixedMessage.replace(new RegExp(escapeRegExp('${' + name + '}'), 'g'), val);
  });
  return fixedMessage;
}

angular.module('threepio')
/**
 * @ngdoc service
 * @name threepio.service:i18n
 *
 * @description
 */
.factory('i18n', function () {
  return function (message, variables) {
    if (angular.isObject(message)) {
      // plural form
      if (variables.count === 1) {
        return replaceVariables(message.one, variables);
      }
      if (angular.isDefined(message[variables.count])) {
        return replaceVariables(message[variables.count], variables);
      }
      return replaceVariables(message.other, variables);
    }
    return replaceVariables(message, variables);
  };
});

angular.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.LocalizationProvider
 *
 * @description
 */
.provider('Localization', function LocalizationProvider() {
  var _defaultLanguage = 'en'; /* language of the site */
  var languageCookie = void 0;
  var languageCode$$1 = void 0;
  var cookieOptions = void 0;

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#defaultLanguage
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language without a dedicated
  * ccTLD or subdomain (retrieved from the LocalizationProvider).
  */
  this.defaultLanguage = function (code) {
    if (code) {
      _defaultLanguage = code;
    }
    return _defaultLanguage;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#setLanguageCookie
  *
  * @description
  * Set the name of the language cookie used to store the current
  * language of the user
  *
  * @param {String} Name of the language cookie
  */
  this.setLanguageCookie = function (name, options) {
    languageCookie = name;
    cookieOptions = options;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizationProvider#setLanguage
  *
  * @description
  * Sets the language code - will be the selected language
  * if the language cookie is not set
  *
  * @param {String} code ISO 639‑1 language code
  */
  this.setLanguage = function (code) {
    languageCode$$1 = code;
  };

  /**
  * @ngdoc service
  * @name threepio.Localization
  *
  * @description
  */
  this.$get = ['$q', '$injector', '$timeout', '$rootScope', 'ThreepioCookieStore', function ($q, $injector, $timeout, $rootScope, ThreepioCookieStore) {
    var _language = ThreepioCookieStore.get(languageCookie) || languageCode$$1 || _defaultLanguage;

    return {
      /**
      * @ngdoc method
      * @name threepio.Localization#language
      *
      * @description
      * Get/set the current language
      *
      * @param {String} ISO 639‑1 language code
      * @param {String} ifDefault Only set the language is the current
      * language is the default one
      * @return {String} When used as a getter, the current language code
      */
      language: function language(code, ifDefault) {
        var d = $q.defer();
        if (code && (!ifDefault || ifDefault && !ThreepioCookieStore.get(languageCookie))) {
          _language = code;
          ThreepioCookieStore.put(languageCookie, _language, cookieOptions);
          $injector.invoke(['Translation', function (Translation) {
            Translation.loadTranslations(_language).then(function () {
              d.resolve();
              $rootScope.$broadcast('LocalizationLanguageChange');
            }).catch(function () {
              d.reject();
            });
          }]);
          return d.promise;
        }
        return _language;
      },
      /**
      * @ngdoc method
      * @name threepio.Localization#defaultLanguage
      *
      * @description
      */
      defaultLanguage: function defaultLanguage() {
        return _defaultLanguage;
      }
    };
  }];
});

var _templateObject = _taggedTemplateLiteral(['', '://', '\n            ', '', '\n            ', ''], ['', '://', '\n            ', '', '\n            ', '']);

angular.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.provider:LocalizedRouteProvider
 *
 * @description
 * Angular $routeProvider wrapper creating language-specific subdirectories
 * for each language without a dedicated ccTLD or subdomain.
 */
.provider('LocalizedRoute', ['$provide', '$routeProvider', 'LocalizationProvider', function LocalizedRouteProvider($provide, $routeProvider, LocalizationProvider) {
  var _this = this;

  var _languages = void 0;
  var localDomains = void 0;
  var primaryDomain = void 0;

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#languages
  *
  * @description
  * Set the supported languages
  *
  * @param arr {object} Map (3-letters ISO code -> Language name) of the
  * supported languages
  */
  this.languages = function (arr) {
    _languages = arr;
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#localDomains
  *
  * @description
  * Set the ccTLDs used (if any) and their default language
  *
  * @param arr {object} Map (domain name -> 3-letters ISO code) of the
  * supported ccTLDs
  */
  this.localDomains = function (def, arr) {
    primaryDomain = def;
    localDomains = arr;
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#when
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language without a dedicated
  * ccTLD or subdomain (retrieved from the LocalizationProvider).
  */
  this.when = function (path, route) {
    $routeProvider.when(path, route);
    angular.forEach(_languages, function (name, code) {
      if (code !== LocalizationProvider.defaultLanguage()) {
        $routeProvider.when('/' + code + path, route);
      }
    });
    return _this;
  };

  /**
  * @ngdoc method
  * @name threepio.LocalizedRouteProvider#when
  *
  * @description Wrapper around Angular $routeProvider.when() method
  * acception the same parameters and returning the same value, creating
  * language-specific subdirectories for each language (retrieved from the
  * LocalizationProvider).
  */
  this.otherwise = function (params) {
    $routeProvider.otherwise(params);
    return _this;
  };

  this.$get = ['$window', '$location', '$rootScope', 'Localization', function ($window, $location, $rootScope, Localization) {

    function isValidLanguage(code) {
      return angular.isDefined(_languages[code]);
    }

    // Get the language code from a specified url or from the current url
    function urlToLangCode(url) {
      var langCode = void 0;
      if (url) {
        // Url rewriting
        var urlEl = $window.document.createElement('a');
        urlEl.href = url;
        // Fix IE inconsistency
        urlEl.pathname = urlEl.pathname[0] !== '/' ? '/' + urlEl.pathname[0] : urlEl.pathname;
        langCode = isValidLanguage(urlEl.pathname.split('/')[1]) ? urlEl.pathname.split('/')[1] : null;
      } else {
        langCode = localDomains[$location.host()] ? localDomains[$location.host()].split('-')[0] : null;

        if (!langCode) {
          langCode = isValidLanguage($location.path().split('/')[1]) ? $location.path().split('/')[1] : null;
        }
      }

      return langCode;
    }

    function unlocalizedPath() {
      var path = $location.path();
      var languageCode$$1 = path.split('/')[1];
      if (isValidLanguage(languageCode$$1)) {
        return path.replace('/' + languageCode$$1, '');
      }
      return path;
    }

    var langCode = urlToLangCode();
    if (isValidLanguage(langCode)) {
      Localization.language(langCode, true);
    }

    $rootScope.$on('$locationChangeStart', function (e, current, previous) {
      // hreflang
      function setHrefLang(lang, baseUrl) {
        // Remove the previous link element if any
        var oldHrefLand = $window.document.querySelector('link[hreflang=' + lang + ']');
        if (oldHrefLand) {
          angular.element(oldHrefLand).remove();
        }
        // Create a new link element for the locale
        var hrefLang = angular.element('<link></link>');
        hrefLang.attr('ref', 'alternate');
        hrefLang.attr('hreflang', lang);
        // Set href value
        var href = oneLineTrim(_templateObject, $location.protocol(), baseUrl, unlocalizedPath(), $window.location.search, $window.location.hash);
        hrefLang.attr('href', href);
        // Add it to the document head
        angular.element($window.document).find('head').append(hrefLang);
      }
      // Write the hreflang tags for the generic language pages, i.e. not
      // specific to a region, using a
      // https://<primary_domain>/<lang_code>/<path> url scheme
      angular.forEach(_languages, function (languageName, lang) {
        var baseUrl = primaryDomain;
        if (lang !== Localization.defaultLanguage()) {
          baseUrl += '/' + lang;
        }
        setHrefLang(lang, baseUrl);
      });
      // Write the hreflang tags for local domains (ccTLDs)
      angular.forEach(localDomains, function (lang, domain) {
        setHrefLang(lang, domain);
      });
      // Keep the language code if any and if the current language is not the
      // default one
      var prevLangCode = urlToLangCode(previous);
      var curLangCode = urlToLangCode(current);
      if (isValidLanguage(curLangCode)) {
        Localization.language(curLangCode);
      }
      if (prevLangCode && curLangCode !== prevLangCode && Localization.language() !== Localization.defaultLanguage()) {
        $location.path('/' + prevLangCode + $location.path());
        $location.replace();
      }
    });

    $rootScope.$on('LocalizationLanguageChange', function () {
      var lang = Localization.language();
      var urlLang = isValidLanguage($location.path().split('/')[1]) ? $location.path().split('/')[1] : null;
      if (lang === Localization.defaultLanguage() && urlLang) {
        $location.path($location.path().split('/')[2]);
      }
    });

    return {
      /**
       * @ngdoc method
       * @name threepio.Localization#languageList
       *
       * @description
       */
      languages: function languages() {
        return _languages;
      }
    };
  }];
}]);

angular.module('threepio')
/**
 * @ngdoc service
 * @name flTranslate.service:TranslationCache
 *
 * @description
 * Load the content of a `<script>` element with a 'text/fl-translate-catalog'
 * type into the {@link flTranslate.TranslationCache `TranslationCache`}, so
 * that the catalog can be used by the
 * {@link flTranslate.service:Translation `Translation Service`}.
 *
 * @param {string} type Must be set to `'text/fl-translate-catalog'`.
 * @param {string} lang Language of catalog
 */
.factory('TemplateCache', ['$cacheFactory', function ($cacheFactory) {
  return $cacheFactory('templatecache');
}]);

/* global document */

angular.module('threepio')
/**
 * @ngdoc service
 * @name threepio.service:ThreepioLib
 *
 * @description
 * Angular wrapper from Threepio translation library
 */
.factory('ThreepioLib', ['$interpolate', function ($interpolate) {
  return new ThreepioLib(document, {
    startExpr: $interpolate.startSymbol(),
    endExpr: $interpolate.endSymbol(),
    // FIXME: ngPluralize plugin is broken for now
    /*
    attributes: {
      when: isGlobal ? $window.Threepio.Plugins.ngPluralize :
        require('Threepio.Plugins.ngPluralize')
    },
    */
    missing: true
  });
}]);

angular.module(threepio)
/**
 * @ngdoc provider
 * @name threepio.TranslationProvider
 *
 * @description
 * Configure the Translation service by setting the translation domain &
 * preparing the DOM & HTML template for dynamic translation
 */
.provider('Translation', ['$provide', function TranslationProvider($provide) {

  var translationsRequest = void 0;

  /**
  * @ngdoc method
  * @name threepio.TranslationProvider#setDomain
  *
  * @description
  * Set the translation domain of the application (namespace used to
  * retrieve the translation catalogs).
  *
  * @param {String} Name of the translation domain
  */
  this.setTranslationsRequest = function (fn) {
    translationsRequest = fn;
  };

  // Angular $compile service decorator tagging the compiled element for
  // translation
  this.translateRootElement = function () {
    var first = false;
    $provide.decorator('$compile', ['$delegate', 'ThreepioLib', function ($delegate, ThreepioLib$$1) {
      function clone(func) {
        var temp = function temporary() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (!first) {
            first = true;
            var el = args[0];
            ThreepioLib$$1.prepare(el);
          }
          return func.apply(this, args);
        };
        Object.keys(func).forEach(function (key) {
          if (Object.prototype.hasOwnProperty.call(func, key)) {
            temp[key] = func[key];
          }
        });
        return temp;
      }
      var compile = clone($delegate);
      return compile;
    }]);
  };

  // Angular $templateRequest service decorator tagging the HTML templates for
  // translation
  $provide.decorator('$templateRequest', ['$delegate', '$q', 'ThreepioLib', 'TemplateCache', function ($delegate, $q, ThreepioLib$$1, TemplateCache) {
    return function (url, ignoreError) {
      var cachedTemplate = TemplateCache.get(url);
      if (cachedTemplate) {
        return $q.when(cachedTemplate);
      }
      return $delegate(url, ignoreError).then(function (template) {
        ThreepioLib$$1.prepare(template);
        var processedTemplate = ThreepioLib$$1.serialize();
        TemplateCache.put(url, processedTemplate);
        return processedTemplate;
      });
    };
  }]);

  /**
  * @ngdoc service
  * @name threepio.Translation
  *
  * @description
  * Translate the application between multiple languages
  */
  this.$get = ['$document', '$rootScope', '$q', '$injector', 'ThreepioLib', 'TranslationsCache', 'Localization', function ($document, $rootScope, $q, $injector, ThreepioLib$$1, TranslationsCache, Localization) {
    var catalog = {};
    var hasBeenTranslated = false;

    function getTranslations(language) {
      var cachedCatalog = TranslationsCache.get(language);
      if (cachedCatalog) {
        return $q.when(cachedCatalog);
      }
      return $injector.invoke(translationsRequest)(language).then(function (newCatalog) {
        TranslationsCache.put(language, newCatalog);
        return newCatalog;
      });
    }

    function _loadTranslations(language) {
      return getTranslations(language).then(function (newCatalog) {
        catalog = newCatalog;
        return catalog;
      });
    }

    /* Preload the translations in the current language before that the
       translate method gets called */
    var currentLanguage = Localization.language();
    if (currentLanguage !== Localization.defaultLanguage()) {
      _loadTranslations(currentLanguage).then(function () {
        $rootScope.$broadcast('TranslationLanguageChange');
      });
    }

    /* Add cloaking CSS style to prevent flash of untranslated content */
    var css = '[i18n-cloak] { display: none !important; }';
    var style = $document[0].createElement('style');
    style.type = 'text/css';
    style.appendChild($document[0].createTextNode(css));
    $document[0].head.appendChild(style);

    $rootScope.$on('LocalizationLanguageChange', function () {
      var language = Localization.language();
      if (language !== Localization.defaultLanguage()) {
        _loadTranslations(language).then(function () {
          $rootScope.$broadcast('TranslationLanguageChange');
        });
      } else {
        $rootScope.$broadcast('TranslationLanguageChange');
      }
    });

    return {
      /**
       * Used by the i18n service for JS translations
       */
      translations: catalog,
      /**
       * @ngdoc method
       * @name threepio.Translation#translate
       *
       * @description
       * Translate an element to the current language
       *
       * @param {HTMLElement} HTML element to translate
       * @param {String} Message ID of the element
       * @return {Promise} Promise resolve or rejected when the translation is
       * done
       */
      translate: function translate(el) {
        var language = Localization.language();
        if (language !== Localization.defaultLanguage()) {
          hasBeenTranslated = true;
          ThreepioLib$$1.process(el, function (message, replace) {
            var translation = catalog.translations[message.getId()] ? catalog.translations[message.getId()] : null;
            if (!translation) {
              /* Use the original message if the translation is missing */
              translation = message.text;
            }
            replace(translation);
          });
        } else if (hasBeenTranslated) {
          // Restore original text
          ThreepioLib$$1.process(el, function (message, replace) {
            replace(message.text);
          });
        }
      },

      /**
       * Load translations
       */
      loadTranslations: function loadTranslations(language) {
        if (language !== Localization.defaultLanguage()) {
          return _loadTranslations(language);
        }
        return $q.when();
      },

      /**
       * @ngdoc method
       * @name threepio.Translation#annotateTemplate
       *
       * @description
       * Annotate an inline template for translation
       *
       * @param {String} HTML template string to annotate for translation
       * @return {String} Annotated template
       */
      annotateTemplate: function annotateTemplate(template) {
        ThreepioLib$$1.prepare(template);
        return ThreepioLib$$1.serialize();
      }
    };
  }];
}]);

/*
 * Common Angular constants used in flAngular.
 * DEPRECATED: A better way to handle these configs should be looked for
 * /!\ DO NOT ADD ANY CODE TO THIS FILE BUT SHARED ANGULAR CONSTANTS /!\
 */

var OPAQUE_MODULE_NAME = 'flConfigs';

if (!window.__karma__) {
  angular.module(OPAQUE_MODULE_NAME, []).constant('API_BASE_URL', '/api').constant('AUTH_BASE_URL', '/auth').constant('AUTH_TOKEN_COOKIE', cookieBase + '_AUTH_HASH_V2').constant('FACEBOOK_APP_ID', facebookAppId).constant('GAF_BASE_URL', '').constant('GAF_CDN_URLS', cdnUrls.map(function (url) {
    return 'https://' + url;
  })).constant('USER_ID_COOKIE', cookieBase + '_USER_ID').constant('DEFAULT_AVATAR_URL', '/img/unknown.png').constant('LANGUAGE_COOKIE', cookieBase + '_LANGUAGE').constant('LANGUAGE_COOKIE_DOMAIN', cookieBase).constant('LANGUAGE_COOKIE_EXPIRES', 60 * 60 * 24 * 60) /* 60 days */
  .constant('FLN_BILLING_BASE_URL', flnBillingBaseUrl).constant('TRANSLATE_MODE_COOKIE', cookieBase + '_TRANSLATE_MODE').constant('LOOKING_FOR_COOKIE', cookieBase + '_LOOKING_FOR').constant('RECAPTCHA_PUBLIC_KEY', recaptchaPublicKey);
} else {
  angular.module(OPAQUE_MODULE_NAME, []).constant('API_BASE_URL', 'https://api-mock.freelancer.com').constant('AUTH_BASE_URL', 'https://auth-mock.freelancer.com').constant('AUTH_TOKEN_COOKIE', 'GETAFREE_AUTH_HASH_V2').constant('FACEBOOK_APP_ID', 123123123123).constant('GAF_BASE_URL', 'https://mock.freelancer.com').constant('GAF_CDN_URLS', ['https://cdn-mock.freelancer.com']).constant('USER_ID_COOKIE', 'GETAFREE_USER_ID').constant('DEFAULT_AVATAR_URL', '/img/unknown.png').constant('LANGUAGE_COOKIE', 'languageCookieMock').constant('LANGUAGE_COOKIE_DOMAIN', 'languageCookieDomainMock').constant('LANGUAGE_COOKIE_EXPIRES', 'languageCookieDomainExpires').constant('FLN_BILLING_BASE_URL', 'https://fln_billing_base_url').constant('TRANSLATE_MODE_COOKIE', 'GETAFREEST__TRANSLATE_MODE').constant('LOOKING_FOR_COOKIE', 'GETAFREEST__LOOKING_FOR').constant('RECAPTCHA_PUBLIC_KEY', recaptchaPublicKey);
  // FIXME: get rid of that (fix flAnalytics)
  window.dataLayer = [];
}

/*
 * Angular service wrapper to abstract the creation of Angular services in your
 * applications.
 *
 * ```
 * import ngResource from 'angular-resource';
 * import { flService } from 'fl-forward';
 *
 * export default flService('MyService',
 *   [ngResource],
 *   MyService
 * );
 *
 * class MyService {
 *   constructor($resource) {
 *     ...
 *   }
 * }
 * ```
 */
function flService(name, deps, classFn) {
  return angular.module('flForward.Service.' + name, deps).service(name, classFn).name;
}

/**
 * annotateTemplate - uses threepio to annotate AngularJS templates with
 * HTML attributes required for the translation system.
 *
 * @param  {string} template raw HTML template
 * @return {string}          annotated template
 */
function annotateTemplate(template) {
  if (typeof template === 'function') {
    return annotateTemplate(template());
  }
  if (typeof template !== 'string') {
    return template;
  }

  var threepio = new ThreepioLib(document, {
    startExpr: '{[{',
    endExpr: '}]}'
  });

  threepio.prepare(template);
  return threepio.serialize();
}

var _templateObject$1 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']),
    _templateObject2 = _taggedTemplateLiteral(['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.'], ['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.']),
    _templateObject3 = _taggedTemplateLiteral(['Components need to provide views through the\n      \'template\' property.'], ['Components need to provide views through the\n      \'template\' property.']);

var _templateObject$2 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\'']);

function flDirective(directiveCtrl, directiveObj) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!directiveObj.selector || !/^\[?fl-[a-z-]+\]?$/.test(directiveObj.selector)) {
    throw new Error(oneLine(_templateObject$2, directiveObj.selector));
  }

  // Compute the directive's name from the selector & the "restrict" attribute
  var directiveName = directiveObj.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  var decorator = false;
  if (directiveName[0] === '[') {
    directiveName = directiveName.slice(1, -1);
    decorator = true;
  }

  // The controllerAs value is the directive's name (without the 'fl' prefix)
  var controllerAs = directiveName.slice(2);

  // Create factory wrapper
  var ddo = function ddo() {
    return {
      restrict: decorator ? 'A' : 'E',
      replace: directiveObj.replace || false,
      scope: directiveObj.scope || false,
      transclude: directiveObj.transclude,
      require: directiveObj.require,
      template: annotateTemplate(directiveObj.template),
      compile: function compile() {
        return function (scope) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          // call the link function in the context of the controller
          if (scope[controllerAs].link) {
            var _scope$controllerAs;

            return (_scope$controllerAs = scope[controllerAs]).link.apply(_scope$controllerAs, [scope].concat(args));
          }
          return function noop() {};
        };
      },
      controller: directiveCtrl,
      bindToController: true,
      controllerAs: controllerAs
    };
  };

  // Create the directive itself
  return angular.module('flForward.Directive.' + directiveName, [].concat(directiveObj.providers || []).concat(directiveObj.directives || [])).directive(directiveName, ddo).name;
}

/**
* @ngdoc service
* @name flApi.flResourceInterceptor
* @description
* Global HTTP interceptor working in conjunction with flResource to allow
* custom endpoint-specific request transformations
*/

var flResourceInterceptor = function flResourceInterceptor() {
  _classCallCheck(this, flResourceInterceptor);

  return {
    /**
     * @ngdoc method
     * @name flApi.flResourceInterceptor#request
     * @methodOf flApi.flResourceInterceptor
     *
     * @description
     * Transform the request using the custom _flRequestInterceptor set on
     * the request configuration if any.
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      if (config._flRequestInterceptor) {
        return config._flRequestInterceptor(config);
      }
      return config;
    }
  };
};

var flResourceInterceptorModule = flService('flResourceInterceptor', [], flResourceInterceptor);

angular.module(flResourceInterceptorModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('flResourceInterceptor');
}]);

/**
 * @ngdoc service
 * @name flApi.flResource
 *
 * @description
 * The HTTP interceptors design in Angular is pretty bad as they have to be
 * installed globally and end up relying on crazy RegExes to match or not some
 * specific endpoints.
 *
 * flResource is an Angular $resource wrapper that handle request & response
 * interceptors on a per $resource and per action basics. This wrapper
 * introduces an extra mandatory "interceptor" argument in the 2nd position,
 * i.e. its prototype is:
 *
 * ```
 *    flResource(url, interceptor, [paramDefaults], [actions], options);
 * ```
 *
 * This extra arguments sets the defaults interceptor for the resource and all
 * its actions, the default ones and the one specific or overwritten in the
 * actions param. This interceptor is a standard Angular HTTP interceptor,
 * i.e. an object with one or many of the 3 methods "request, response, and
 * responseError". The ApiInterceptor and GafInterceptors can be use with
 * flResource:
 *
 * ```
 *    const DepositsConfirm = flResource(
 *    API_BASE_URL + '/payments/0.1/deposits/',
 *    ApiInterceptor, {}, { 'update': { method: 'PUT' }});
 * ```
 *
 * This wrapper also extend the interceptor key on the actions objects: by
 * default Angular $resource service only support response & responseError for
 * these. flResource extends that behavior by using a global interceptor to
 * set action-specific request interceptors. This is quite useful for
 * flResource objects that deal with different kind of endpoints:
 *
 * ```
 *    const Invoices = flResource(API_BASE_URL +
 *      '/projects/0.1/invoices/', ApiInterceptor, null, {
 *      fetch: {
 *        method: 'GET',
 *        url: GAF_BASE_URL + '/ajax/project/getProjectInvoices.php',
 *        interceptor: GafInterceptor
 *      },
 *      pay: {
 *        method: 'POST',
 *        url: GAF_BASE_URL + '/ajax/payment/payinvoice.php',
 *        interceptor: GafInterceptor
 *      },
 *      requestChange: {
 *        method: 'GET',
 *        url: GAF_BASE_URL + '/ajax/payment/on-request-invoice-change.php',
 *        interceptor: GafInterceptor
 *      }
 *    });
 *```
 */

var flResourceFactory = function flResourceFactory($resource) {
  _classCallCheck(this, flResourceFactory);

  return function flResource(url, defaultInterceptor, paramDefaults) {
    var actions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { stripTrailingSlashes: false };

    if (!defaultInterceptor || !defaultInterceptor.request) {
      throw new Error('No default interceptor set');
    }

    // Set the default interceptor for the custom actions if not specified
    angular.forEach(actions, function (value, action) {
      if (!angular.isDefined(actions[action].interceptor)) {
        actions[action].interceptor = defaultInterceptor;
        actions[action]._flRequestInterceptor = defaultInterceptor.request;
      } else {
        actions[action]._flRequestInterceptor = actions[action].interceptor.request;
      }
    });

    // Set the default interceptor for the default $resource action if not
    // defined
    var defaultActions = {
      get: { method: 'GET' },
      save: { method: 'POST' },
      query: { method: 'GET', isArray: true },
      remove: { method: 'DELETE' },
      delete: { method: 'DELETE' }
    };

    angular.forEach(defaultActions, function (value, action) {
      if (!angular.isDefined(actions[action])) {
        actions[action] = value;
        actions[action].interceptor = defaultInterceptor;
        actions[action]._flRequestInterceptor = defaultInterceptor.request;
      }
    });

    return $resource(url, paramDefaults, actions, options);
  };
};

flResourceFactory.$inject = ['$resource'];


var flResourceProvider = flService('flResource', [ngResource, flResourceInterceptorModule], flResourceFactory);

var _templateObject$3 = _taggedTemplateLiteral(['(?:(?:^|.*;)\\s*\n      ', '\n      \\s*\\=\\s*([^;]*).*$)|^.*$'], ['(?:(?:^|.*;)\\\\s*\n      ', '\n      \\\\s*\\\\=\\\\s*([^;]*).*$)|^.*$']);

/**
 * @ngdoc service
 * @name flCookies.CookieStore
 *
 * @description
 * A factory which creates a service that lets you interact with the browser's
 * cookies.
 *
 * AngularJS has
 * {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
 * its own $cookieStore implementation} but it doesn't support setting any
 * cookie option (e.g. *path*, *domain*, *secure*,
 * and *expiration*) as of today. The APIs are the same than Angular's
 * {@link https://docs.angularjs.org/api/ngCookies/service/$cookieStore
 * $cookieStore} with an extra parameter (an object with
 * ``expires``, ``path``, ``domain`` and ``secure`` as keys, ``expires``
 * accepting different formats).
 * It is currently used by ``flAuth`` (auth cookies) and ``flAnalytics``
 * (tracking cookies), but you can easily use it in a custom service:
 *
 * ```
   angular.module('myApp')
   .factory('myAwesomeService', function(CookieStore) {
     return {
       setMagicCookie: function(magicNumber) {
         CookieStore.put('CHUCK_NORRIS', magicNumber, {
           expires: Infinity
         });

       ...
     }
   }
 * ```
 *
 * The returned object has action methods which provide high-level behaviors
 * without the need to interact with the low level cookies implementation.
 */

var CookieStoreProvider = function () {
  function CookieStoreProvider($document) {
    _classCallCheck(this, CookieStoreProvider);

    this.$document = $document;
  }
  /**
   * @ngdoc method
   * @name flCookies.CookieStore#get
   * @methodOf flCookies.CookieStore
   *
   * @description
   * Returns the value of given cookie key
   *
   * @param {String} key Id to use for lookup.
   * @returns {Object} Deserialized cookie value.
   */


  _createClass(CookieStoreProvider, [{
    key: 'get',
    value: function get(key) {
      var re = new RegExp(oneLineTrim(_templateObject$3, encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&')));
      var value = this.$document[0].cookie.replace(re, '$1');

      return decodeURIComponent(value) || null;
    }
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#put
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Sets a value for given cookie key
     *
     * @param {String} key Id for the `value`.
     * @param {Object} value The value you want to store in this cookie
     * @param {Object} options Additional settings for the cookie (optional):
     *
     * - expires: expiration date for the cookie
     * - domain: the domain for which the cookie is valid
     * - path: the path for which the cookie is valid
     * - secure: is cookie HTTPS only?
     */

  }, {
    key: 'put',
    value: function put(key, value, options) {
      // Set cookie
      var cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value);
      // See options
      if (options) {
        // Expiration date
        if (options.expires) {
          var date = void 0;

          switch (options.expires.constructor) {
            case Number:
              if (options.expires === Infinity) {
                date = 'Fri, 31 Dec 9999 23:59:59 GMT';
              } else {
                // Note: we don't use max-age here because it's
                // not supported in IE8.
                var d = new Date();
                d.setTime(d.getTime() + options.expires * 1000);
                date = d.toUTCString();
              }
              break;
            case String:
              date = options.expires;
              break;
            case Date:
              date = options.expires.toUTCString();
              break;
            default:
              break;
          }

          cookie += ';expires=' + date;
        }
        // Domain
        cookie += options.domain ? ';domain=' + options.domain : '';
        // Path
        cookie += options.path ? ';path=' + options.path : ';path=/';
        // HTTPS Only
        cookie += options.secure ? ';secure' : '';
      }
      // Save the cookie
      // Note: this.$document is a jqLite wrapper
      this.$document[0].cookie = cookie;
    }
    /**
    * @ngdoc method
    * @name flCookies.CookieStore#remove
    * @methodOf flCookies.CookieStore
    *
    * @description
    * Remove given cookie
    *
    * @param {String} key Id of the key-value pair to delete.
    * @param {Object} options Additional settings for the cookie (optional)
    */

  }, {
    key: 'remove',
    value: function remove(key, options) {
      var opt = options || {};
      // Setting expiry date to a past date deletes a cookie
      opt.expires = new Date(0);
      this.put(key, '', opt);
    }
    /**
     * @ngdoc method
     * @name flCookies.CookieStore#getDomain
     * @methodOf flCookies.CookieStore
     *
     * @description
     * Get Cookie Domain by matching the regex `freelancer.*$`
     * and adding `.` front of it.
     * If it doesn't match the regex, just return the hostName.
     *
     * @param {String} hostName current host name
     *
     * @returns {String} Cookie Domain
     */

  }, {
    key: 'getDomain',
    value: function getDomain(hostName) {
      return hostName.match(/freelancer.*$/) ? '.' + hostName.match(/freelancer.*$/)[0] : '' + hostName;
    }
  }]);

  return CookieStoreProvider;
}();

CookieStoreProvider.$inject = ['$document'];


var CookieStoreProvider$1 = flService('CookieStore', [], CookieStoreProvider);

var _templateObject$4 = _taggedTemplateLiteral(['afpro=', ';\n      afpro_id=', ';\n      afro_sess=', ''], ['afpro=', ';\n      afpro_id=', ';\n      afro_sess=', '']),
    _templateObject2$1 = _taggedTemplateLiteral(['', '-\n        ', '-', '-', '-\n        ', ''], ['', '-\n        ', '-', '-', '-\n        ', '']);

/**
 * @ngdoc service
 * @name flAnalytics.Analytics
 *
 * @description
 * A service that allows you to perform common tasks
 * on Google Analytics.
 */

var AnalyticsProvider = function () {
  function AnalyticsProvider($window, CookieStore, md5) {
    _classCallCheck(this, AnalyticsProvider);

    this.$window = $window;
    this.CookieStore = CookieStore;
    this.md5 = md5;
  }
  /**
   * @ngdoc method
   * @name flAnalytics.Analytics#trackAction
   * @methodOf flAnalytics.Analytics
   *
   * @description
   * Tracks an event/action, i.e. something the app is doing
   *
   * @param {String} category The `eventCategory` parameter
   * @param {String} action The `eventAction` parameter
   * @param {String} result The `eventResult` parameter
   */


  _createClass(AnalyticsProvider, [{
    key: 'trackAction',
    value: function trackAction(category, action, result) {
      this.$window.dataLayer.push({
        event: 'app_action',
        eventCategory: category,
        eventAction: action,
        eventResult: result
      });
    }
    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackAction
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Track a DOM event / user action, e.g. a `click` on a button or
     * a `change` on a select input
     *
     * @param {String} section The `eventSection` parameter
     * @param {String} subsection The `eventSubsection` parameter
     * @param {String} name The `eventName` parameter
     * @param {String} action The `eventAction` parameter
     * @param {String} value The `eventValue` parameter
     * @param {String} label The `eventLabel` parameter
     * @param {String} reference The `eventReference` parameter
     * @param {String} referenceId The `eventReferenceId` parameter
     */

  }, {
    key: 'trackEvent',
    value: function trackEvent(section, subsection, name, action, value, label, reference, referenceId) {
      this.$window.dataLayer.push({
        event: 'user_action',
        eventSection: section,
        eventSubsection: subsection,
        eventName: name,
        eventAction: action,
        eventValue: value,
        eventLabel: label,
        eventReference: reference,
        eventReferenceId: referenceId
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackAjaxTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push user timing data to Google Tag Manager
    *
    * @param {String} method The `ajaxMethod` parameter
    * @param {String} url The `ajaxUrl` parameter
    * @param {String} status The `ajaxStatus` parameter
    * @param {String} timeSpent The `ajaxValue` parameter
    * @param {String} label The `ajaxLabel` parameter
    */

  }, {
    key: 'trackAjaxTiming',
    value: function trackAjaxTiming(method, url, status, timeSpent, label) {
      this.$window.dataLayer.push({
        event: 'ajax_timing',
        ajaxMethod: method,
        ajaxUrl: url,
        ajaxStatus: status,
        ajaxValue: timeSpent,
        ajaxLabel: label
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackAjaxTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track an error (not a JS error, an app error)
    *
    * @param {String} category The `eventCategory` parameter
    * @param {String} action The `eventAction` parameter
    * @param {String} result The `eventResult` parameter
    * @param {String} error The `eventData` parameter
    */

  }, {
    key: 'trackError',
    value: function trackError(category, action, result, error) {
      this.$window.dataLayer.push({
        event: 'app_error',
        eventCategory: category,
        eventAction: action,
        eventResult: result,
        eventLabel: error ? JSON.stringify(error) : undefined
      });
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackABTest
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track an ab test with variation
    *
    * @param {String} category The `test` parameter
    * @param {String} variation The `variation` parameter
    */

  }, {
    key: 'trackABTest',
    value: function trackABTest(name, variation) {
      this.$window.dataLayer.push({
        event: 'abtest',
        testName: name,
        testVariation: variation
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackMobileUserTiming
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push user timing data in Mobile Web to Google Tag Manager
    *
    * @param {String} markName The name of the user timing mark
    * @param {String} markTime The time when the mark was recorded
    */

  }, {
    key: 'trackMobileUserTiming',
    value: function trackMobileUserTiming(markName, markTime) {
      this.$window.dataLayer.push({
        event: 'mobile_user_timing',
        markName: markName,
        markTime: markTime
      });
    }

    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackMobileCountryDomain
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Push country domain data in Mobile Web to data layer
     *
     * @param {String} currentDomain The country domain being used
    */

  }, {
    key: 'trackMobileCountryDomain',
    value: function trackMobileCountryDomain(currentDomain) {
      this.$window.dataLayer.push({
        currentDomain: currentDomain
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackGTMConversion
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Push GTM conversion tracking first with orderId, then conversion
    * type and then fire a QTS event together with the GTM tracking
    *
    * @param {String} type The order type, i.e. can be either 'project' or
    * 'contest'
    * @param {String} orderId The order Id
    * @param {String} conversionType The name of conversion type as
    * specified in the GTM console
    */

  }, {
    key: 'trackGTMConversion',
    value: function trackGTMConversion(type, orderId, conversionType) {
      var formattedOrderId = void 0;
      if (type === 'project') {
        formattedOrderId = 'P' + orderId;
      } else if (type === 'contest') {
        formattedOrderId = 'C' + orderId;
      } else {
        return;
      }

      this.$window.dataLayer.push({ order_id: formattedOrderId });
      this.$window.dataLayer.push({ event: conversionType });

      this.trackEvent('GTMTracking', conversionType, false, false, false, formattedOrderId);
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#trackPageView
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Track the referrer of the given URL
    *
    * @param {String} url of the page
    * @param {String} referrer of the page
    */

  }, {
    key: 'trackPageView',
    value: function trackPageView(url, referrerUrl) {
      this.$window.dataLayer.push({
        event: 'page_view',
        referrerUrl: referrerUrl,
        url: url
      });
    }

    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#trackLocation
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Tracks the latitude and longitude of the user
     */

  }, {
    key: 'trackLocation',
    value: function trackLocation(lat, lon) {
      this.$window.dataLayer.push({
        event: 'user_location',
        lat: lat,
        lon: lon
      });
    }

    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getAFPROHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the affiliate program tracking data. The affiliate tracking
    * cookies are set by GAF when redirecting marketing campaigns links,
    * a.k.a. with a pattern like
    * https://www.freelancer.com/campaign/0XYZ123/.
    *
    * @returns {String} a string containing the encoded value
    * of the affiliate tracking cookies
    */

  }, {
    key: 'getAFPROHeader',
    value: function getAFPROHeader() {
      var program = this.CookieStore.get('GETAFREE_AFPRO');
      var programId = this.CookieStore.get('GETAFREE_AFPRO_ID');
      var session = this.CookieStore.get('GETAFREE_AFPRO_SESS');
      if (!program || !programId || !session) {
        // Don't set the header if there's no data
        return undefined;
      }
      return oneLineTrim(_templateObject$4, encodeURIComponent(program), encodeURIComponent(programId), encodeURIComponent(session));
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getTrackingHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the tracking data (QTS session ID for now).
    *
    * @returns {String} a string containing the encoded value
    * of the affiliate tracking session cookie
    */

  }, {
    key: 'getTrackingHeader',
    value: function getTrackingHeader() {
      var tracking = this.CookieStore.get('_tracking_session');
      // Don't set the header if there's no data
      if (!tracking) {
        return undefined;
      }
      return encodeURIComponent(tracking);
    }
    /**
     * @ngdoc method
     * @name flAnalytics.Analytics#setTrackingHeader
     * @methodOf flAnalytics.Analytics
     *
     * @description
     * Generates session ID cookie from md5 hash
     *
     * @returns {String} Session ID string
     */

  }, {
    key: 'setTrackingHeader',
    value: function setTrackingHeader() {
      var sessionId = this.getTrackingHeader();
      if (!sessionId) {
        var date = new Date();
        var hashed = this.md5.createHash(Math.random().toString());
        var md5SessionId = oneLineTrim(_templateObject2$1, hashed.substr(0, 8), hashed.substr(8, 4), hashed.substr(12, 4), hashed.substr(16, 4), hashed.substr(20, 12));

        this.CookieStore.put('_tracking_session', md5SessionId, {
          expires: date.getTime() + 60 * 60 * 24 * 365,
          domain: this.CookieStore.getDomain(this.$window.location.hostname)
        });

        return md5SessionId;
      }
      return sessionId;
    }
    /**
    * @ngdoc method
    * @name flAnalytics.Analytics#getTTREFHeader
    * @methodOf flAnalytics.Analytics
    *
    * @description
    * Get the TTREF tracking data. The TTREF tracking cookies are used to
    * store the entry points (e.g., button click) that lead to a certain
    * action (e.g., post project).
    *
    * @returns {String} a string containing the encoded value
    * of the GETAFREE_TTREF cookie
    */

  }, {
    key: 'getTTREFHeader',
    value: function getTTREFHeader() {
      var ttref = this.CookieStore.get('GETAFREE_TTREF');
      // Don't set the header if there's no data
      if (!ttref) {
        return undefined;
      }
      return ttref;
    }
  }]);

  return AnalyticsProvider;
}();

AnalyticsProvider.$inject = ['$window', 'CookieStore', 'md5'];


var AnalyticsModule = flService('Analytics', [CookieStoreProvider$1, OPAQUE_MODULE_NAME, md5Provider], AnalyticsProvider);

// HTTP interceptor for tracking ajax requests timings
angular.module(AnalyticsModule).factory('AjaxTimingInterceptor', ['$q', 'Analytics', 'API_BASE_URL', 'AUTH_BASE_URL', 'GAF_BASE_URL', function ($q, Analytics, API_BASE_URL, AUTH_BASE_URL, GAF_BASE_URL) {
  var startTime = {};
  var logTimeSpent = function logTimeSpent(response) {
    // Compute the request end time
    var endTime = new Date().getTime();
    var timeSpent = endTime - startTime[response.config.url].shift();
    // Label the timing event
    var label = void 0;
    var url = response.config.url;
    if (url.match(/^\/views\//)) {
      label = 'HTML_PARTIAL';
    } else if (url.match(/^\/data\//)) {
      label = 'JSON_DATA';
    } else if (url.indexOf(API_BASE_URL) === 0) {
      label = 'REST_API';
    } else if (url.indexOf(AUTH_BASE_URL) === 0) {
      label = 'AUTH';
    } else if (url.indexOf(GAF_BASE_URL) === 0) {
      label = 'GAF';
    }
    // Log the data
    Analytics.trackAjaxTiming(response.config.method, response.config.url, response.status, timeSpent, label);
    // Do not leak memory!
    if (startTime[response.config.url].length === 0) {
      delete startTime[response.config.url];
    }
  };
  return {
    request: function request(config) {
      // Save the request start time
      if (!startTime[config.url]) {
        startTime[config.url] = [];
      }
      startTime[config.url].push(new Date().getTime());
      return config;
    },
    response: function response(_response) {
      logTimeSpent(_response);
      return _response;
    },
    responseError: function responseError(response) {
      logTimeSpent(response);
      return $q.reject(response);
    }
  };
}]);

// Insert the affiliate tracking header on user GET & POST requests
angular.module(AnalyticsModule).factory('AFPROInterceptor', ['Analytics', 'API_BASE_URL', function (Analytics, API_BASE_URL) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL + '/users/0.1/users/')) {
        newConfig.headers['Freelancer-AFPRO'] = Analytics.getAFPROHeader();
      }
      return newConfig;
    }
  };
}]);

// Insert the tracking header on all request to the REST API
angular.module(AnalyticsModule).factory('TrackingInterceptor', ['Analytics', 'API_BASE_URL', function (Analytics, API_BASE_URL) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL)) {
        newConfig.headers['Freelancer-Tracking'] = Analytics.getTrackingHeader();
      }
      return newConfig;
    }
  };
}]);

// Insert the TTREF tracking header on POST project request
angular.module(AnalyticsModule).factory('TTREFInterceptor', ['API_BASE_URL', 'Analytics', function (API_BASE_URL, Analytics) {
  return {
    request: function request(config) {
      var newConfig = config;
      if (config.url.match(API_BASE_URL + '/projects/0.1/projects/') && config.method === 'POST') {
        newConfig.headers['Freelancer-TTREF'] = Analytics.getTTREFHeader();
      }
      return newConfig;
    }
  };
}]);

angular.module(AnalyticsModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AjaxTimingInterceptor');
  $httpProvider.interceptors.push('AFPROInterceptor');
  $httpProvider.interceptors.push('TrackingInterceptor');
  $httpProvider.interceptors.push('TTREFInterceptor');
}]);

angular.module(AnalyticsModule).run(['$window', function ($window) {
  // Log User Agent string.
  // Let's make sure the string is kinda safe while keeping it readable.
  var userAgent = encodeURIComponent($window.navigator.userAgent).replace(/%20/g, ' ').replace(/%2F/g, '/').replace(/%3B/g, ';').replace(/%2C/g, ',');

  $window.dataLayer.push({
    event: 'user_agent',
    uaString: userAgent
  });
}]);

/**
 * @ngdoc service
 * @name flApi.RequestTransformation
 * @description
 * Exposes data transformation methods used for encoding requests and
 * transforming events from realtime fl-notification.
 */

var RequestTransformation = function () {
  function RequestTransformation() {
    _classCallCheck(this, RequestTransformation);
  }

  _createClass(RequestTransformation, [{
    key: 'formUrlEncoded',

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#formUrlEncoded
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method encodes parameters in form encoding, with special handling of
     * array types NOT to use commas, e.g. users[]=123,345 is NOT allowed. This
     * method replaces it with users[]=123&users[]=345
     *
     * @param {Object} data the object intended to be encoded
     * @returns {String} an encoded string
     */
    value: function formUrlEncoded() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var i = void 0;
      var theData = void 0;
      var result = [];

      // If we are sending a Form Encoded request, don't apply the key-value
      // string to the URL. This is bad and makes the request empty :(
      if (data instanceof FormData) {
        return data;
      }

      // Split array parameters into multiple entries
      Object.keys(data).forEach(function (key) {
        if (data[key]) {
          theData = data[key];
          if (Array.isArray(theData)) {
            // Append a '[]' to the param so switching to non-formencoded
            // will be more seamless down the line
            for (i = 0; i < theData.length; i++) {
              var k = encodeURIComponent(key + '[]');
              var d = encodeURIComponent(theData[i]);

              result.push(k + '=' + d);
            }
          } else {
            // Just a normal parameter, encode and push it through
            var _k = encodeURIComponent(key);
            var _d = encodeURIComponent(theData);

            result.push(_k + '=' + _d);
          }
        }
      });
      return result.join('&');
    }
  }, {
    key: 'buildParams',
    value: function buildParams(prefix, obj, add) {
      var _this = this;

      if (Array.isArray(obj)) {
        // Serialize array item.
        angular.forEach(obj, function (v, i) {
          var r = typeof v === 'object' ? i : '';

          // Item is non-scalar (array or object), encode its numeric index.
          _this.buildParams(prefix + '[' + r + ']', v, add);
        });
      } else if (angular.isObject(obj)) {
        // Serialize object item.
        Object.keys(obj).forEach(function (name) {
          _this.buildParams(prefix + '[' + name + ']', obj[name], add);
        });
      } else {
        // Serialize scalar item.
        add(prefix, obj);
      }
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#formUrlEncodedRecursive
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * Serialize an array of form elements or a set of key/values into a query
     * string
     *
     * @param {Object} data the object intended to be encoded
     * @returns {String} an encoded string
     */

  }, {
    key: 'formUrlEncodedRecursive',
    value: function formUrlEncodedRecursive() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var s = [];
      var add = function add(key, value) {
        // If value is a function, invoke it and return its value
        var v = angular.isFunction(value) ? value() : value;

        if (value === null) {
          v = '';
        }

        s[s.length] = encodeURIComponent(key) + '=' + encodeURIComponent(v);
      };

      // If an array was passed in, assume that it is an array of form elements.
      if (Array.isArray(data) && data !== {}) {
        // Serialize the form elements
        angular.forEach(data, function (v, i) {
          add(i, v);
        });
      } else {
        // otherwise encode params recursively.
        Object.keys(data).forEach(function (prefix) {
          _this2.buildParams(prefix, data[prefix], add);
        });
      }
      // update data with final serialization
      return s.join('&');
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#parseBidNotification
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method converts the bid data object from the realtime bid
     * notifications into a raw bid object which can be used to create a bid
     * factory
     *
     * @param {Object} data the bid data object returned by a realtime bid
     * notification
     * @returns {Object} a raw bid object
     */

  }, {
    key: 'parseBidNotification',
    value: function parseBidNotification(data) {
      return {
        id: parseInt(data.bid.id, 10),
        amount: parseInt(data.bid.sum, 10),
        fix_project_hourly_rate: parseFloat(data.bid.fix_project_hourly_rate),
        bidder_id: parseInt(data.bid.users_id, 10),
        description: data.bid.descr,
        award_status: data.bid.award_status,
        frontend_bid_status: 'active',
        hidden: data.bidHidden,
        highlighted: data.bid.highlighted,
        milestone_percentage: data.bid.milestone_percentage,
        period: parseInt(data.bid.period, 10),
        project_id: parseInt(data.bid.project_id, 10),
        project_owner_id: parseInt(data.accountId, 10),
        ranking: data.bid.ranking,
        retracted: false,
        shortlisted: data.bid.isShortlisted || false,
        submitdate: parseInt(data.bid.submitdate_ts, 10),
        time_submitted: parseInt(data.bid.submitdate_ts, 10),
        score: parseFloat(data.bid.score)
      };
    }

    /**
     * @ngdoc method
     * @name flApi.RequestTransformation#parseUserNotification
     * @methodOf flApi.RequestTransformation
     *
     * @description
     * This method converts the user data object from the realtime bid
     * notifications into a raw user object which can be used to create a user
     * factory
     *
     * @param {Object} data the bid data object returned by a realtime bid
     * notification
     * @returns {Object} a raw user object
     */

  }, {
    key: 'parseUserNotification',
    value: function parseUserNotification(data) {
      if (Array.isArray(data.bid.user.insignia)) {
        data.bid.user.insignia = data.bid.user.insignia.map(function (item) {
          return {
            id: parseInt(item.examId, 10),
            name: item.title,
            description: item.description,
            icon_name: item.name
            /* TODO: Data that cannot be parse from Notification's data
             * - icon_url
             * - level
             * - score_percentage
             * - type
             * - user_percentile
             */
          };
        });
      }
      var timezone = void 0;
      if (data.bid.user.timezone_info && data.bid.user.timezone_info.country && data.bid.user.timezone_info.id && data.bid.user.timezone_info.offset && data.bid.user.timezone_info.timezone) {
        timezone = {
          country: data.bid.user.timezone_info.country,
          id: data.bid.user.timezone_info.id,
          offset: data.bid.user.timezone_info.offset,
          timezone: data.bid.user.timezone_info.timezone
        };
      }

      return {
        avatar_cdn: data.imgUrl,
        hourly_rate: data.bid.user.hourlyrate,
        id: parseInt(data.bid.user.id, 10),
        location: {
          country: {
            code: data.bid.user.address.code,
            name: data.bid.user.flag.name
          }
        },
        registration_date: data.bid.user.reg_unixtime,
        reputation: {
          earnings_score: data.bid.user.earnings,
          entire_history: {
            all: data.bid.user.seller_rating.projectCount.entire_history.all,
            completion_rate: data.bid.user.seller_rating.projectCount.entire_history.completion_rate,
            overall: data.bid.user.seller_rating.avg,
            reviews: data.bid.user.seller_rating.count,
            on_time: data.bid.user.seller_rating.reputation.entire_history.ont,
            on_budget: data.bid.user.seller_rating.reputation.entire_history.onb,
            category_ratings: {
              quality: data.bid.user.seller_rating.reputation.entire_history.qua,
              communication: data.bid.user.seller_rating.reputation.entire_history.com,
              expertise: data.bid.user.seller_rating.reputation.entire_history.exp,
              professionalism: data.bid.user.seller_rating.reputation.entire_history.pro,
              hire_again: data.bid.user.seller_rating.reputation.entire_history.hag
            }
          },
          user_id: parseInt(data.bid.user.id, 10)
        },
        username: data.bid.user.username,
        isPortfolioCreated: data.bid.user.isPortfolioCreated,
        qualifications: data.bid.user.insignia,
        corporate: data.bid.user.corporate,
        public_name: data.bid.user.publicName,
        timezone: timezone
      };
    }
  }]);

  return RequestTransformation;
}();

var RequestTransformationProvider = flService('RequestTransformation', [], RequestTransformation);

var _templateObject$5 = _taggedTemplateLiteral(['\n      ', '/contacts/0.1/requests/pending_sent/'], ['\n      ', '/contacts/0.1/requests/pending_sent/']),
    _templateObject2$2 = _taggedTemplateLiteral(['\n            ', ' ', ''], ['\n            ', ' ', '']);

/**
* @ngdoc service
* @name flApi.ApiInterceptor
* @description
* Transform the requests to and from the REST API. Use it with flResource.
*/

var ApiInterceptor = function ApiInterceptor($q, $log, Analytics, RequestTransformation, API_BASE_URL) {
  _classCallCheck(this, ApiInterceptor);

  // In contacts and messaging APIs, the parameters for a request to the API
  // need to be form encoded. These are the exceptions, using a primitive
  // wildcard expression for threads.
  var contactRequestUrl = oneLineTrim(_templateObject$5, API_BASE_URL);
  var threadServiceUrl = API_BASE_URL + '/messages/0.1/threads/*';
  var messageServiceUrl = API_BASE_URL + '/messages/0.1/messages/*';
  var videochatServiceUrl = API_BASE_URL + '/messages/0.1/videochat/*';

  var encodeAsFormExceptionMatcher = function encodeAsFormExceptionMatcher(config) {
    var method = config.method;
    return config.url.match(threadServiceUrl) && (method === 'POST' || method === 'PUT') || config.url.match(messageServiceUrl) || config.url.match(videochatServiceUrl) || config.url.match(contactRequestUrl);
  };

  // Encode parameters in form encoding, with special handling of array
  // types NOT to use commas, e.g. users[]=123,345 is NOT allowed. This
  // function replaces it with users[]=123&users[]=345
  var encodeFormUrlEncoded = function encodeFormUrlEncoded(config) {
    // If we are sending a Form Encoded request, don't apply the key-value
    // string to the URL. This is bad and makes the request empty :(
    if (config.data instanceof FormData) {
      return;
    }

    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = RequestTransformation.formUrlEncoded(config.data);
  };

  // In the translations API, parameter flags are indicated are indicating
  // with either it's the presence (indicating true) or absence (indicating
  // false). As a result, parameters with a "false" value should simply be
  // removed.
  var translationsApiUrl = API_BASE_URL + '/translations/0.1/*';
  var removeFalseParams = function removeFalseParams(config) {
    Object.keys(config.params).forEach(function (key) {
      if (config.params[key] === false) {
        delete config.params[key];
      }
    });
  };
  return {
    /**
     * @ngdoc method
     * @name flApi.ApiInterceptor#request
     * @methodOf flApi.ApiInterceptor
     *
     * @description
     * Intercepts requests to `API_BASE_URL` and applies some modifications
     * to them according to certain criteria (e.g. some header could be
     * added/modified).
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      // Activate the "compact" mode on all requests to the API
      if (config.params) {
        config.params.compact = true;
      } else if (config.data && config.data instanceof FormData) {
        config.data.append('compact', 'true');
      } else if (config.data) {
        config.data.compact = true;
      }

      // Fix the "action" PATH & PUT requests being form submission
      // instead of application/json
      if (encodeAsFormExceptionMatcher(config)) {
        encodeFormUrlEncoded(config);
      } else if ((config.method === 'PUT' || config.method === 'PATCH') && config.data && config.data.action &&
      // Dirty hack, but we have no choice until we fix these global
      // interceptors
      !config.url.match('/api/users/0.1/showcase_items/') && !config.url.match('/api/users/0.1/phone_verifications/') && !config.url.match('/api/users/0.1/webhooks/')) {
        encodeFormUrlEncoded(config);
      }

      // Removing false params from all requests to the translations API
      if (config.url.match(translationsApiUrl)) {
        removeFalseParams(config);
      }
      return config;
    },
    /**
     * @ngdoc method
     * @name flApi.ApiInterceptor#response
     * @methodOf flApi.ApiInterceptor
     *
     * @description
     * Intercepts responses from `API_BASE_URL` and applies some
     * modifications to them according to certain criteria (e.g. some content
     * could be added/modified).
     *
     * @param {Object} response The content of the response.
     * @returns {Object} The object received as a parameter,
     * eventually modified.
     */
    response: function response(_response) {
      // Check the response validity
      if (_response.data && _response.data.status === 'success') {
        if (_response.data.result) {
          _response.data = _response.data.result;
        }
      } else {
        // Shouldn't happen, report the error
        var errorCode = 'INVALID_RESPONSE';
        $log.error('api: invalid server response: ' + _response.data);
        if (typeof Raven !== 'undefined') {
          Raven.captureMessage(errorCode, {
            extra: {
              response: JSON.stringify(_response.data),
              config: JSON.stringify(_response.config),
              status: _response.status,
              status_text: _response.statusText
            }
          });
        }
        Analytics.trackError('api', oneLineTrim(_templateObject2$2, _response.config.method, _response.config.url), _response.status, _response.data);
        _response.code = errorCode;
        return $q.reject(_response);
      }
      return _response.data;
    },
    /**
    * @ngdoc method
    * @name flApi.ApiInterceptor#responseError
    * @methodOf flApi.ApiInterceptor
    *
    * @description
    * `responseError` interceptor gets called when a previous interceptor
    * threw an error or resolved with a rejection.
    *
    * @param {Object} response The request configuration object
    * @returns {Object} The object received as a parameter,
    * eventually modified.
    */
    responseError: function responseError(response) {
      var errorCode = void 0;

      // Provide human-oriented error messages in response blob
      var humanError = {
        title: 'Something went wrong',
        message: 'Please check your internet connection and refresh the page.'
      };
      if (response.status >= 400 && response.status < 500) {
        humanError = {
          title: 'Something went wrong',
          message: 'If this problem persists, please contact support with ' + ('Error: ' + response.data.message)
        };
      } else if (response.status >= 500 && response.status < 600) {
        humanError = {
          title: 'Something went wrong with our service',
          message: 'To continue, please refresh the page and try again.'
        };
      }
      response.humanError = humanError;

      // We should always have an error message
      if (response.data && response.data.error_code) {
        var errors = response.data.error_code.match(/\.(.*$)/);
        if (errors && errors[1]) {
          errorCode = errors[1];
        } else {
          errorCode = 'INVALID_ERROR';
        }
      } else {
        errorCode = 'INVALID_RESPONSE';
      }

      // Push interesting errors into Sentry
      if (errorCode === 'UNKNOWN_ERROR' || errorCode === 'GAF_EXCEPTION' || errorCode === 'INVALID_ERROR' || errorCode === 'INVALID_RESPONSE' || errorCode === 'GENERAL') {
        if (typeof Raven !== 'undefined') {
          Raven.captureMessage(errorCode, {
            tags: {
              api: JSON.stringify(response.config.url)
            },
            extra: {
              response: JSON.stringify(response.data),
              config: JSON.stringify(response.config),
              status: response.status,
              status_text: response.statusText
            }
          });
        }
        Analytics.trackError('api', oneLineTrim(_templateObject2$2, response.config.method, response.config.url), response.status, response.data);
      }
      if (!response.data) {
        response.data = {};
      }
      response.code = errorCode;
      return $q.reject(response);
    }
  };
};

ApiInterceptor.$inject = ['$q', '$log', 'Analytics', 'RequestTransformation', 'API_BASE_URL'];


var ApiInterceptorProvider = flService('ApiInterceptor', [OPAQUE_MODULE_NAME, AnalyticsModule, RequestTransformationProvider], ApiInterceptor);

/**
 * @ngdoc service
 * @name flApiTranslations.Translations
 *
 * @description
 * A service that provides a convenient way to interact with the translations
 * API
 */
var OPAQUE_MODULE_NAME$1 = 'flAngular.TranslationsProvider';

var TranslationsProviderProvider = angular.module(OPAQUE_MODULE_NAME$1, [threepio, OPAQUE_MODULE_NAME, flResourceProvider, ApiInterceptorProvider]).provider('Translations', ['TranslationProvider', 'LocalizationProvider', 'LANGUAGE_COOKIE', 'LANGUAGE_COOKIE_EXPIRES', function TranslationsProvider(TranslationProvider, LocalizationProvider, LANGUAGE_COOKIE, LANGUAGE_COOKIE_EXPIRES) {
  var translationsDomain = void 0;

  this.translate = function (domain, translateRootEl) {
    translationsDomain = domain;
    TranslationProvider.setTranslationsRequest(['Translations', function (Translations) {
      return function (language) {
        return Translations.getStrings(domain, language);
      };
    }]);
    if (translateRootEl) {
      TranslationProvider.translateRootElement();
    }
    LocalizationProvider.setLanguageCookie(LANGUAGE_COOKIE, {
      domain: window.location.hostname.match(/freelancer.*$/) ? window.location.hostname.match(/freelancer.*$/)[0] : undefined,
      expires: LANGUAGE_COOKIE_EXPIRES
    });
  };

  this.setLanguage = function (languageCode$$1) {
    LocalizationProvider.setLanguage(languageCode$$1);
  };

  this.$get = ['flResource', 'ApiInterceptor', 'API_BASE_URL', function (flResource, ApiInterceptor, API_BASE_URL) {
    // The `/translations` GET API endpoint uses the `Accept` header to
    // indicate the preferred response media type. The default `Accept`
    // header for `$http` includes `application/json`, `text/plain`, and
    // `*/*` without any weights, which would create an ambiguous resulting
    // in a `300` status code.
    // Because of this we explicitly specify `application/json` as the sole
    // accepted media type.
    var Translations = flResource(API_BASE_URL + '/translations/0.1/translations/', ApiInterceptor, {
      hashed: true,
      legacy: true
    }, {
      get: {
        cache: true,
        headers: { Accept: 'application/json' }
      }
    });
    var Languages = flResource(API_BASE_URL + '/translations/0.1/languages/', ApiInterceptor);

    return {
      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getStrings
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Get the all the strings of a translation domain for a language
       *
       * @param {String} domain The domain for which to get the translations
       * @returns {Object} language The language code (e.g., "fr") of the
       * locale
       */
      getStrings: function getStrings(domain, language) {
        return Translations.get({
          domain: domain,
          language_code: language
        }).$promise;
      },

      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getDomain
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Get the translation domain set by the Angular app via .config()
       *
       * @returns {String} domain The domain for which to get the translations
       */
      getDomain: function getDomain() {
        return translationsDomain;
      },

      /**
       * @ngdoc method
       * @name flApiTranslations.Translations#getLanguages
       * @methodOf flApiTranslations.Translations
       *
       * @description
       * Fetch a list of all languages in the translations system
       *
       * @param {Boolean} activeOnly      Indicates whether or not inactive
       *                                  languages should also be returned
       * @param {Array}   languageCodes   An optional array of codes for the
       *                                  specific languages to return
       * @returns {Object}                A promise that resolves to an
       *                                  object hash of language codes and
       *                                  names
       */
      getLanguages: function getLanguages() {
        var activeOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var languageCodes = arguments[1];

        return Languages.get({
          'language_codes[]': languageCodes,
          active_only: activeOnly
        }).$promise;
      }
    };
  }];
}]).name;

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines a section that is being tracked.
 */

var flAnalyticsSection = function flAnalyticsSection($attrs) {
  _classCallCheck(this, flAnalyticsSection);

  this.section = $attrs.flAnalyticsSection;
};

flAnalyticsSection.$inject = ['$attrs'];


var flAnalyticsSection$1 = flDirective(flAnalyticsSection, {
  selector: '[fl-analytics-section]'
});

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines a subsection that is being tracked.
 */

var flAnalyticsSubsection = function flAnalyticsSubsection($attrs) {
  _classCallCheck(this, flAnalyticsSubsection);

  this.subsection = $attrs.flAnalyticsSubsection;
};

flAnalyticsSubsection.$inject = ['$attrs'];


var flAnalyticsSubsection$1 = flDirective(flAnalyticsSubsection, {
  selector: '[fl-analytics-subsection]'
});

/**
 * @ngdoc directive
 * @name flAnalytics.Analytics
 *
 * @description
 * A directive which defines an element that is being tracked. The event that
 * is being tracked is inferred by the type of the element.
 */

// Infer the DOM event type from the element tagName & type
function inferEventType(element) {
  if (['button', 'submit'].indexOf(element.type) !== -1) {
    return 'click';
  } else if (['select', 'input', 'textarea'].indexOf(element.tagName.toLowerCase()) !== -1) {
    return 'change';
  } else if (element.isContentEditable) {
    // contenteditable elements don't have change events
    return 'blur';
  }
  return 'click';
}

// Event section is mandotary, event subsection is optional

var flAnalytics = function () {
  function flAnalytics($parse, $log, Analytics) {
    _classCallCheck(this, flAnalytics);

    this.$parse = $parse;
    this.$log = $log;
    this.Analytics = Analytics;
  }

  _createClass(flAnalytics, [{
    key: 'link',
    value: function link(scope, element, attrs, ctrls) {
      var _this = this;

      // The name of the event (mandatory)
      var name = attrs.flAnalytics;
      // The section on the site (mandatory)
      var section = ctrls[0].section;
      // The subsection (optional)
      var subsection = ctrls[1] ? ctrls[1].subsection : undefined;

      if (name && section) {
        (function () {
          // DOM event type
          var type = inferEventType(element[0]);
          element.on(type, function (e) {
            var el = e.target;
            // Get the event value from the attributes (Angular expression) or
            // use the DOM element value is not specified
            var value = _this.$parse(attrs.flAnalyticsValue)(scope);
            // Get the action from the event type if no action is specified
            var action = attrs.flAnalyticsAction ? attrs.flAnalyticsAction : type;
            // Get the element label: if it's a select input & an element is
            // selected, get the selected text, otherwise we use the content
            var label = attrs.flAnalyticsLabel;
            if (!label && !el.isContentEditable) {
              label = el.value && el.options ? el.options[el.selectedIndex].text : el.textContent.trim();
            }
            var reference = attrs.flAnalyticsReference;
            var referenceId = attrs.flAnalyticsReferenceId;

            _this.Analytics.trackEvent(section, subsection, name, action, value, label, reference, referenceId);
          });
        })();
      } else {
        this.$log.warn('invalid event name or section');
      }
    }
  }]);

  return flAnalytics;
}();

flAnalytics.$inject = ['$parse', '$log', 'Analytics'];


var flAnalytics$1 = flDirective(flAnalytics, {
  selector: '[fl-analytics]',
  providers: [AnalyticsModule],
  directives: [flAnalyticsSection$1, flAnalyticsSubsection$1],
  require: ['^flAnalyticsSection', '?^flAnalyticsSubsection'],
  scope: false
});

var _templateObject$6 = _taggedTemplateLiteral(['Invalid app name selector (', '): the selector\n      must be a dash-delimited element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid app name selector (', '): the selector\n      must be a dash-delimited element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']);

/*
 * `angular.module` wrapper to abtract the Angular apps common configurations
 * in GAF. Use it instead of `angular.module` to create & bootstrap your app:
 *
 * ```
 * export default flApp('phoneVerification', [
 *   PhoneVerification
 * ]);
 * ```
 */
function flApp(name, deps, appController) {
  // Lint for invalid selector
  // TODO: this should be a lint rule
  if (!/^fl-[a-z-]+$/.test(name)) {
    throw new Error(oneLine(_templateObject$6, name));
  }

  var app = angular.module(name + 'App', deps.concat([TranslationsProviderProvider, flAnalytics$1, flAnalyticsSection$1, flAnalyticsSubsection$1])).config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
  }]).config(['TranslationsProvider', function (TranslationsProvider) {
    var translationName = name.replace(/^fl-/, '');
    TranslationsProvider.translate('gaf|' + translationName);
    TranslationsProvider.setLanguage(languageCode);
  }]).config(['$interpolateProvider', function ($interpolateProvider) {
    $interpolateProvider.startSymbol('{[{');
    $interpolateProvider.endSymbol('}]}');
  }]);
  // FIXME: There's no way we're gonna to load the TranslationModal for
  // non-translators
  /* .run(function(TranslationModal, CookieStore, TRANSLATE_MODE_COOKIE) {
      TranslationModal.setTranslationMode(
        CookieStore.get(TRANSLATE_MODE_COOKIE) === '1'
      );
    }); */

  if (appController) {
    app.controller('appController', appController);
  }

  setTimeout(function () {
    var app = angular.element(document.querySelector(name));
    if (!app.injector()) {
      angular.bootstrap(app, [name + 'App']);
    }
  });
  return app;
}

/*
 * Angular service wrapper to abstract the creation of Angular services in your
 * applications.
 *
 * ```
 * import ngResource from 'angular-resource';
 * import { flService } from 'fl-forward';
 *
 * export default flService('MyService',
 *   [ngResource],
 *   MyService
 * );
 *
 * class MyService {
 *   constructor($resource) {
 *     ...
 *   }
 * }
 * ```
 */
function flService$1(name, deps, classFn) {
  return angular.module('flForward.Service.' + name, deps).service(name, classFn).name;
}

/**
 * annotateTemplate - uses threepio to annotate AngularJS templates with
 * HTML attributes required for the translation system.
 *
 * @param  {string} template raw HTML template
 * @return {string}          annotated template
 */
function annotateTemplate$1(template) {
  if (typeof template !== 'string') {
    return template;
  }

  var threepio = new ThreepioLib$1(document, {
    startExpr: '{[{',
    endExpr: '}]}'
  });

  threepio.prepare(template);
  return threepio.serialize();
}

var _templateObject$7 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix,\n      e.g. \'fl-laurent-rocks\'']),
    _templateObject2$3 = _taggedTemplateLiteral(['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.'], ['Components cannot have link functions. If you need\n      to do DOM manipulations, use the $postLink hook instead.']),
    _templateObject3$1 = _taggedTemplateLiteral(['Components need to provide views through the\n      \'template\' property.'], ['Components need to provide views through the\n      \'template\' property.']);

function flComponent$1(componentCtrl, componentOptions) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!componentOptions.selector || !/^fl-[a-z-]+$/.test(componentOptions.selector)) {
    throw new Error(oneLine(_templateObject$7, componentOptions.selector));
  }

  // Lint for invalid use of link function
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (componentCtrl && componentCtrl.prototype.link) {
    throw new Error(oneLine(_templateObject2$3));
  }

  // The templates must be loaded through SystemJS
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (componentOptions.templateUrl) {
    throw new Error(oneLine(_templateObject3$1));
  }

  // Get the component name from its selector
  var camelCasedName = componentOptions.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });

  // The controllerAs value is the component's name (without the 'fl' prefix)
  var controllerAs = camelCasedName.slice(2);

  return angular.module('flForward.Component.' + camelCasedName, [].concat(componentOptions.providers || []).concat(componentOptions.directives || [])).component(camelCasedName, {
    controller: componentCtrl,
    controllerAs: controllerAs,
    template: annotateTemplate$1(componentOptions.template),
    transclude: componentOptions.transclude,
    bindings: componentOptions.bindings,
    restrict: 'E',
    require: componentOptions.require
  }).name;
}

var _templateObject$8 = _taggedTemplateLiteral(['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\''], ['Invalid component selector\n      (', '): the selector must be a dash-delimited\n      element selectors starting with the \'fl\' prefix, e.g. \'fl-laurent-rocks\',\n      or dash-delimited attributes selectors starting with the \'fl\' prefix,\n      e.g. \'[fl-laurent-rocks]\'']);

function flDirective$1(directiveCtrl, directiveObj) {
  // Lint for invalid selector
  // TODO: this should be a lint rule in eslint-plugin-fl-forward
  if (!directiveObj.selector || !/^\[?fl-[a-z-]+\]?$/.test(directiveObj.selector)) {
    throw new Error(oneLine(_templateObject$8, directiveObj.selector));
  }

  // Compute the directive's name from the selector & the "restrict" attribute
  var directiveName = directiveObj.selector.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  var decorator = false;
  if (directiveName[0] === '[') {
    directiveName = directiveName.slice(1, -1);
    decorator = true;
  }

  // The controllerAs value is the directive's name (without the 'fl' prefix)
  var controllerAs = directiveName.slice(2);

  // Create factory wrapper
  var ddo = function ddo() {
    return {
      restrict: decorator ? 'A' : 'E',
      replace: directiveObj.replace || false,
      scope: directiveObj.scope || false,
      transclude: directiveObj.transclude,
      require: directiveObj.require,
      template: annotateTemplate$1(directiveObj.template),
      compile: function compile() {
        return function (scope) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          // call the link function in the context of the controller
          if (scope[controllerAs].link) {
            var _scope$controllerAs;

            return (_scope$controllerAs = scope[controllerAs]).link.apply(_scope$controllerAs, [scope].concat(args));
          }
          return function noop() {};
        };
      },
      controller: directiveCtrl,
      bindToController: true,
      controllerAs: controllerAs
    };
  };

  // Create the directive itself
  return angular.module('flForward.Directive.' + directiveName, [].concat(directiveObj.providers || []).concat(directiveObj.directives || [])).directive(directiveName, ddo).name;
}

/*
 * Angular constant wrapper to abstract the creation of Angular constant
 *
 * ```
 * import { flConstant } from 'fl-forward';
 *
 * export default flConstant('CONNECTION_URL', 'http://foo');
 * ```
 */
function flConstant$1(varName, varValue) {
  return angular.module('flForward.Constant.' + varName, []).constant(varName, varValue).name;
}

function setCookie(cName, value, expiredays) {
  var expiremins = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cName + '=' + value + ('' + (expiredays == null ? '' : ';expires=' + exdate.toUTCString())) + '; path=/; secure';
}

function setCookieToBrowser(cookieName, cookieValue, expiredays, path, domain) {
  var expiremins = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  exdate.setMinutes(exdate.getMinutes() + expiremins);
  document.cookie = cookieName + '=' + escape(cookieValue) + ('' + (exdate ? ';expires=' + exdate.toUTCString() : '')) + ('' + (path ? ';path=' + path : '')) + ('' + (domain ? ';domain=' + domain : '')) + ';secure';
}

function getCookie(cName) {
  var cookies = document.cookie;
  if (cookies.length > 0) {
    var cStart = cookies.indexOf(cName + '=');
    if (cStart != -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = cookies.indexOf(';', cStart);
      if (cEnd == -1) cEnd = cookies.length;
      return cookies.substring(cStart, cEnd);
    }
  }
  return '';
}

function randomString(length, chars) {
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.round(Math.random() * (chars.length - 1))];
  }
  return result;
}

function getCSRFToken() {
  var token = getCookie('XSRF-TOKEN');
  if (!token) {
    token = randomString(64, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
    setCookie('XSRF-TOKEN', token, 7);
  }
  return token;
}

/*
  QTS Binding Library
  This includes functions for binding qts pushing to events, as follows:
  init()
  - initializes default values for all qts events
    this may set two separate default values for the navbar and for the page
    push()
  - used for js process events, not directly w/ user interaction
    bind()
  - bind to an element click event.
    if contains a link, it shall prevent & setTimeout to allow qts pixel
    request, before redirecting.
*/

// general container for all qtsbinds data;
var qtsv = {
  timeout: false,
  defaults: {},
  page: {},
  nav: {}
};

qtsv.defaults = {
  pageContainer: '.gaf-container:first',
  navContainer: '.header-and-nav'
};

var setDefault = function setDefault(params, isNav) {
  if (typeof isNav === 'boolean' && isNav) {
    if (params) {
      Object.keys(params).forEach(function (pkey) {
        qtsv.nav[pkey] = params[pkey];
      });
    }
  } else if (params) {
    Object.keys(params).forEach(function (pkey) {
      qtsv.page[pkey] = params[pkey];
    });
  }
  qtsv.timeout = false;
};

var push = function push(params, url, isNav) {
  var qvars = qtsv;
  if (!qvars.timeout) {
    (function () {
      var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

      if (typeof params === 'object') {
        if (params) {
          Object.keys(params).forEach(function (pkey) {
            if (pkey != 'eventName') {
              paramSet[pkey] = params[pkey];
            }
          });
        }
      } else if (typeof params === 'string') {
        paramSet.label = params;
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _t.push(['user_action', paramSet]);
      }

      setTimeout(function () {
        if (typeof url === 'string') {
          window.location = url;
        }
      }, 1000);

      setTimeout(function () {
        qvars.timeout = false;
      }, 100);

      qvars.timeout = true;
    })();
  }
};

var createBind = function createBind(ifselector, params, isNav) {
  var qvars = qtsv;

  params = params || {};

  var containerEl = qvars.defaults.pageContainer;
  var selector = '[data-qts]';

  if (typeof ifselector === 'string') {
    selector = ifselector;
  } else if (typeof ifselector === 'object') {
    selector = ifselector.id;
    // attach conditional values to element so it won't be lost after binding
    jq(selector).attr('data-qtcon', ifselector.con);
    jq(selector).attr('data-qt0', ifselector.falsy);
    jq(selector).attr('data-qt1', ifselector.truthy);
  }

  if (typeof isNav === 'string') {
    containerEl = isNav;
  } else if (typeof isNav === 'boolean' && isNav == true) {
    containerEl = qvars.defaults.navContainer;
  }

  jq(containerEl).on('click', selector, function (e) {
    e.preventDefault();
    // if navbar is a link, assign triggerable flag so it can be triggered after
    // qts is pushed.
    var paramSet = typeof isNav === 'undefined' ? JSON.parse(JSON.stringify(qvars.page)) : JSON.parse(JSON.stringify(qvars.nav));

    var thisEl = jq(e.currentTarget);
    var triggerable = false;
    if (typeof thisEl.attr('href') !== 'undefined') {
      triggerable = true;
    }

    if (!qtsv.timeout) {
      if (params) {
        Object.keys(params).forEach(function (pkey) {
          if (pkey != 'eventName') {
            paramSet[pkey] = params[pkey];
          }
        });
      }

      var label = thisEl.data('qts');

      if (typeof label !== 'undefined') {
        paramSet.label = label;
      }

      // for conditional selectors
      var hasCondition = typeof thisEl.data('qtcon') !== 'undefined';

      if (hasCondition) {
        // toggle text value (qt1 or qt0) depending on condition (qtcon)
        if (thisEl.data('qtcon') == false) {
          paramSet.label = thisEl.data('qt1');
          thisEl.data('qtcon', true);
        } else {
          paramSet.label = thisEl.data('qt0');
          thisEl.data('qtcon', false);
        }
      }

      if (typeof paramSet.action === 'undefined') {
        paramSet.action = 'click';
      }

      if (typeof params.eventName !== 'undefined') {
        _t.push([params.eventName, paramSet]);
      } else {
        _lt.push(['user_action', paramSet]);
      }

      // sets a timeout fxn & timer to measure if qts push taking too long.
      qtsv.timer = setTimeout(function () {
        qtsv.timeout = false;
        if (triggerable) {
          window.location = thisEl.attr('href');
        }
      }, 1000);

      qtsv.timeout = true;
      qtsv.timerRun = 0;
    }
  });
};

qtsv.push = push;

var qtsp = {
  init: setDefault,
  bind: createBind,
  push: push
};

/**
 * @ngdoc service
 * @name flAuth.Auth
 *
 * @description
 * Implementation of the Freelancer Auth API
 */

var AuthProvider = function () {
  function AuthProvider($http, $q, $rootScope, $window, CookieStore, AUTH_BASE_URL, AUTH_TOKEN_COOKIE, USER_ID_COOKIE, FACEBOOK_APP_ID) {
    _classCallCheck(this, AuthProvider);

    this.CookieStore = CookieStore;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$q = $q;
    this.$window = $window;
    this.AUTH_BASE_URL = AUTH_BASE_URL;
    this.AUTH_TOKEN_COOKIE = AUTH_TOKEN_COOKIE;
    this.USER_ID_COOKIE = USER_ID_COOKIE;
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
    this.accessToken = CookieStore.get(AUTH_TOKEN_COOKIE);
    this.userId = parseInt(CookieStore.get(USER_ID_COOKIE), 10);

    // Avoid using $location in fl-api as it breaks backbone.js routers
    // and we need to support legacy code for now
    this.defaultCookieOptions = {
      domain: this.CookieStore.getDomain(this.$window.location.hostname),
      secure: $window.location.protocol === 'https'
    };
  }
  // Start new session / Login user


  _createClass(AuthProvider, [{
    key: 'login',
    value: function login(username, password, remember) {
      var _this = this;

      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', username);
      payload.append('password', password);

      return this.$http.post(this.AUTH_BASE_URL + '/login/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this.set(response.data.token, response.data.user, remember);
        return response.data;
      });
    }

    // Reset session

  }, {
    key: 'reset',
    value: function reset() {
      // Reset state
      this.accessToken = null;
      this.userId = null;
      // Remove auth cookies
      this.CookieStore.remove(this.AUTH_TOKEN_COOKIE, this.defaultCookieOptions);
      this.CookieStore.remove(this.USER_ID_COOKIE, this.defaultCookieOptions);
      // Unset Raven userId
      if (typeof Raven !== 'undefined') {
        Raven.setUser();
      }
      this.$rootScope.$broadcast('user.logout');
    }
    // Set a new session

  }, {
    key: 'set',
    value: function set(accessToken, userId, remember) {
      // Save auth params
      this.accessToken = accessToken;
      this.userId = parseInt(userId, 10);
      // Store the auth params as cookies
      // Only send the session cookie over SSL to prevent session hijacking
      // Remember for a 2 weeks. Yes GAF remembers you for 5 years but
      // that's maybe a bit too much.
      var options = this.defaultCookieOptions;
      // TODO: ^This should be a shallow copy instead of copy by reference.
      // Copy by reference means `options.expires` will
      // also change this.defaultCookieOptions.expires value.
      options.expires = remember ? 60 * 60 * 24 * 14 : null;
      this.CookieStore.put(this.AUTH_TOKEN_COOKIE, accessToken, options);
      this.CookieStore.put(this.USER_ID_COOKIE, userId, options);
      // Set the user id into Raven
      if (typeof Raven !== 'undefined') {
        Raven.setUser({
          id: this.userId
        });
      }
      this.$rootScope.$broadcast('user.login');
    }

    // Set Extra Cookies

  }, {
    key: 'setExtraCookies',
    value: function setExtraCookies(cookies) {
      var _this2 = this;

      Object.keys(cookies).forEach(function (cookieName) {
        var cookie = cookies[cookieName];
        var options = Object.assign({}, _this2.defaultCookieOptions);
        if ('ttl' in cookie) {
          options.expires = cookie.ttl;
        }

        if ('value' in cookie) {
          _this2.CookieStore.put(cookieName, cookie.value, options);
        }
      });
    }

    // End session / Logout user

  }, {
    key: 'logout',
    value: function logout() {
      var _this3 = this;

      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', this.userId);
      payload.append('token', this.accessToken);

      // Destroys the session token
      return this.$http.post(this.AUTH_BASE_URL + '/logout/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function () {
        _this3.reset();
      }).catch(function (error) {
        // Reset the session anyway if the token is invalid
        _this3.reset();
        return error;
      });
    }
    // Is the user currently authenticated?

  }, {
    key: 'isAuthenticated',
    value: function isAuthenticated() {
      return this.userId && this.accessToken;
    }
    // Get userId

  }, {
    key: 'getUserId',
    value: function getUserId() {
      return this.userId;
    }
    // Get accessToken

  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      return this.accessToken;
    }
    // Freelancer-Auth-V2 auth header params for the REST API

  }, {
    key: 'getAuthHeader',
    value: function getAuthHeader() {
      // Do not set the header if not authenticated
      if (this.isAuthenticated()) {
        return this.userId + '; ' + encodeURIComponent(this.accessToken);
      }
      return undefined;
    }
    // Returns a promise

  }, {
    key: 'checkAuthenticated',
    value: function checkAuthenticated() {
      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      return this.$http.get(this.AUTH_BASE_URL + '/check/', {
        params: {
          user: this.userId,
          token: this.token
        }
      }).then(function (response) {
        return response.data.expiry;
      });
    }

    // Set a new password
    // - INVALID_USER
    // - WEAK_PASSWORD
    // - INVALID_CREDENTIALS

  }, {
    key: 'changePassword',
    value: function changePassword(oldPassword, newPassword) {
      var _this4 = this;

      if (!this.isAuthenticated()) {
        return this.$q.reject();
      }
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('user', this.userId);
      payload.append('old_password', oldPassword);
      payload.append('new_password', newPassword);

      return this.$http.post(this.AUTH_BASE_URL + '/change/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this4.set(response.data.token, response.data.user, true);
      });
    }

    // Send reset password email
    // - UNKOWN_EMAIL

  }, {
    key: 'resetPassword',
    value: function resetPassword(email) {
      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('email', email);
      return this.$http.post(this.AUTH_BASE_URL + '/forgot/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      });
    }
    /**
    * @ngdoc method
    * @name flthis.Auth#login
    * @methodOf flthis.Auth
    *
    * @description
    * Use facebook credentials to login to Freelancer
    * Makes use of the FB.login call to the facebook api
    * to ensure the user is logged in to facebook and has
    * granted permissions to Freelance.
    *
    * @returns {Object} a Promise object that will be resolved with an
    * auth response object from the freelancer api
    */

  }, {
    key: 'loginWithFacebook',
    value: function loginWithFacebook(facebookAuthParams) {
      return this.oAuthLogin(this.FACEBOOK_APP_ID, 'facebook', facebookAuthParams.signedRequest);
    }
    // Login the user using OAuth credentials
    // INVALID_USER
    // INVALID_TOKEN

  }, {
    key: 'oAuthLogin',
    value: function oAuthLogin(appId, oauthType, credentials) {
      var _this5 = this;

      // Auth endpoit is using multipart/form-data instead of
      // application/json! Or application/x-www-form-urlencoded! WTF?
      // TODO: Use application/json
      var payload = new FormData();
      payload.append('app_id', appId);
      payload.append('oauth_type', oauthType);
      payload.append('credentials', credentials);

      return this.$http.post(this.AUTH_BASE_URL + '/login/oauth/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: { 'Content-Type': undefined },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this5.set(response.data.token, response.data.user, true);
        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#getDeviceToken
     * @methodOf flAuth.Auth
     *
     * @description
     * Fetch a unique token provided to a device, intended to be
     * stored by the device independent of user sessions.
     *
     * @returns {String} a Promise string token
     */

  }, {
    key: 'getDeviceToken',
    value: function getDeviceToken() {
      return this.$http.get(this.AUTH_BASE_URL + '/device/').then(function (response) {
        return response.data.token;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#loginWith2FA
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer login API with additional device token parameter to
     * determine if user 2FA is required or not. This will also send the TOTP
     * token to the delivery mechanism available for the user.
     *
     * @returns {Object} a Promise object that will throw an error if
     * 2FA is required, otherwise it will be resolved with an
     * auth token and user id.
     */

  }, {
    key: 'loginWith2FA',
    value: function loginWith2FA(username, password, remember, deviceToken) {
      var _this6 = this;

      var payload = new FormData();
      payload.append('user', username);
      payload.append('password', password);
      payload.append('device_token', deviceToken);

      return this.$http.post(this.AUTH_BASE_URL + '/login/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        if (response.data.pre_login_token) {
          var error = response.data;
          error.code = '2FA_REQUIRED';

          return _this6.$q.reject(error);
        }

        // No 2FA required
        _this6.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#verifyTotp
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer login API to verify if the prelogin token, TOTP
     * and device token are valid.
     *
     * @returns {Object} a Promise object that will be resolved with
     * an auth token and user id.
     */

  }, {
    key: 'verifyTotp',
    value: function verifyTotp(preLoginToken, totp, deviceToken, remember) {
      var _this7 = this;

      var payload = new FormData();
      payload.append('pre_login_token', preLoginToken);
      payload.append('totp', totp);
      payload.append('device_token', deviceToken);

      return this.$http.post(this.AUTH_BASE_URL + '/login/verify/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this7.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }

    /**
     * @ngdoc method
     * @name flAuth.Auth#switchAccount
     * @methodOf flAuth.Auth
     *
     * @description
     * Use Freelancer switch account API to login linked corporate accounts
     *
     * @returns {Object} a Promise object that will be resolved with an
     * auth response object from the Freelancer Api
     */

  }, {
    key: 'switchAccount',
    value: function switchAccount(fromUserId, toUserId, remember) {
      var _this8 = this;

      var payload = new FormData();
      payload.append('user', fromUserId);
      payload.append('other_user', toUserId);
      payload.append('token', this.accessToken);

      return this.$http.post(this.AUTH_BASE_URL + '/switch_account/', payload, {
        // Let the XHR implementation fill the 'Content-Type'
        // with the correct boundary Id
        headers: {
          'Content-Type': undefined
        },
        // Tell Angular do not transform (toJSON'd) the request
        transformRequest: angular.identity
      }).then(function (response) {
        _this8.set(response.data.token, response.data.user, remember);

        return response.data;
      });
    }
  }]);

  return AuthProvider;
}();

AuthProvider.$inject = ['$http', '$q', '$rootScope', '$window', 'CookieStore', 'AUTH_BASE_URL', 'AUTH_TOKEN_COOKIE', 'USER_ID_COOKIE', 'FACEBOOK_APP_ID'];


var AuthModule = flService('Auth', [AnalyticsModule, CookieStoreProvider$1, OPAQUE_MODULE_NAME], AuthProvider);

// HTTP interceptor for 401 UNAUTHORIZED
// Logout the current user if it happens (it should not!)
angular.module(AuthModule).factory('AutoLogoutInterceptor', ['$q', '$injector', function ($q, $injector) {
  return {
    responseError: function responseError(response) {
      // Filter out login requests with invalid credentials
      if (response.status === 401 && response.config.url.indexOf('/auth/login') === -1) {
        // Clear invalid session token
        // Differed injection is need to work around circular
        // dependency between Auth & $http
        $injector.invoke(['Auth', function (Auth) {
          Auth.reset();
        }]);
      }
      return $q.reject(response);
    }
  };
}]);

// Add the REST API auth header
angular.module(AuthModule).factory('RESTAuthInterceptor', ['$injector', 'API_BASE_URL', function ($injector, API_BASE_URL) {
  return {
    request: function request(config) {
      if (config.url.match(API_BASE_URL)) {
        // Differed injection is need to work around circular
        // dependency between Auth & $http
        $injector.invoke(['Auth', function (Auth) {
          config.headers['Freelancer-Auth-V2'] = Auth.getAuthHeader();
        }]);
      }
      return config;
    }
  };
}]);

/**
 * @ngdoc service
 * @name flAuth.AuthBackendInterceptor
 *
 * @description
 * HTTP interceptor abstracting the comminutation with the auth backend
 */
angular.module(AuthModule).factory('AuthBackendInterceptor', ['$q', '$log', 'AUTH_BASE_URL', 'Analytics', function ($q, $log, AUTH_BASE_URL, Analytics) {
  return {
    /**
    * @ngdoc method
    * @name flAuth.AuthBackendInterceptor#response
    * @methodOf flAuth.AuthBackendInterceptor
    *
    * @description
    * Process auth related response -
    *    1. Replace response.data with response.data.result on success
    *    2. Report error and returns a rejected promise
    *
    * @param {Object} response The http response object
    * @returns {Object} successful resonse or a rejected promise
    */
    response: function response(_response) {
      // Only handles auth related urls
      if (_response.config.url.match(AUTH_BASE_URL + '(?:[?/]|$)')) {
        // Check the response validity
        if (_response.data && _response.data.status === 'success' && (_response.config.url.match(/\/logout\/$/) || _response.config.url.match(/\/forgot\/$/))) ; else if (_response.data && _response.data.status === 'success' && _response.data.result) {
          _response.data = _response.data.result;
        } else {
          // Shouldn't happen, report the error
          $log.error('auth: invalid server response: ' + _response.data);
          var errorCode = 'INVALID_RESPONSE';
          if (typeof Raven !== 'undefined') {
            Raven.captureMessage(errorCode, {
              extra: {
                response: JSON.stringify(_response.data),
                config: JSON.stringify(_response.config),
                status: _response.status,
                status_text: _response.statusText
              }
            });
          }
          Analytics.trackError('auth', _response.config.method + ' ' + _response.config.url, _response.status, _response.data);
          _response.code = errorCode;
          return $q.reject(_response);
        }
      }
      return _response;
    },
    /**
    * @ngdoc method
    * @name flAuth.AuthBackendInterceptor#responseError
    * @methodOf flAuth.AuthBackendInterceptor
    *
    * @description
    * Process auth related error response
    *
    * @param {Object} response The http response object
    * @returns {Object} A rejected promise with proper reason code
    */
    responseError: function responseError(response) {
      // Only handles auth related urls
      if (response.config.url.match(AUTH_BASE_URL + '(?:[?/]|$)')) {
        var errorCode = void 0;
        if (response.data && (response.data.error_code || response.data.message)) {
          if (response.data.error_code && response.data.error_code !== 'None') {
            var errors = response.data.error_code.match(/\.(.*$)/);
            if (errors && errors[1]) {
              errorCode = errors[1];
            } else {
              errorCode = 'INVALID_ERROR';
            }
          } else if (response.data.message) {
            // Error message -> error code mapping
            // TODO: Use error codes
            switch (response.data.message) {
              case 'Incorrect username or password provided':
                errorCode = 'INVALID_CREDENTIALS';
                break;
              case 'Invalid user provided':
                errorCode = 'INVALID_USER';
                break;
              case 'Invalid token provided':
                errorCode = 'INVALID_TOKEN';
                break;
              case 'Cannot find a user with that email address':
                errorCode = 'UNKNOWN_EMAIL';
                break;
              case 'Unable to authenticate user':
                errorCode = 'INVALID_USER';
                break;
              case 'An error occured verifying OAuth token':
                errorCode = 'INVALID_TOKEN';
                break;
              case 'User could not be found':
                errorCode = 'INVALID_USER';
                break;
              case 'Your new password is too weak. ' + 'Please choose a better password':
                errorCode = 'WEAK_PASSWORD';
                break;
              case 'Invalid user credentials provided':
                errorCode = 'INVALID_CREDENTIALS';
                break;
              case 'You are performing too many requests.':
                errorCode = 'TOO_MANY_REQUESTS';
                break;
              default:
                errorCode = 'UNKNOWN_ERROR';
                break;
            }
          }
        } else {
          errorCode = 'INVALID_RESPONSE';
          $log.error('auth: invalid server response: ' + response.data);
        }
        // Push interesting errors into Sentry
        if (errorCode === 'UNKNOWN_ERROR' || errorCode === 'INVALID_RESPONSE' || errorCode === 'TOO_MANY_REQUESTS') {
          if (typeof Raven !== 'undefined') {
            Raven.captureMessage(errorCode, {
              tags: {
                api: JSON.stringify(response.config.url)
              },
              extra: {
                response: JSON.stringify(response.data),
                config: JSON.stringify(response.config),
                status: response.status,
                status_text: response.statusText
              }
            });
          }
          Analytics.trackError('auth', response.config.method + ' ' + response.config.url, response.status, response.data);
        }
        response.code = errorCode;
        return $q.reject(response);
      }
      return $q.reject(response);
    }
  };
}]);

angular.module(AuthModule).config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AutoLogoutInterceptor');
  $httpProvider.interceptors.push('RESTAuthInterceptor');
  $httpProvider.interceptors.push('AuthBackendInterceptor');
}]);

/**
 * @ngdoc service
 * @name flCdn.Cdn
 *
 * @description
 * A service to interact with Freelancer Content Delivery Network  ("f-cdn")
 */

var crcTable = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

// Compute the CRC32 of a string
var crc32 = function crc32(str) {
  var crc = 0 ^ -1;

  for (var i = 0; i < str.length; i++) {
    crc = crc >>> 8 ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xFF];
  }

  return (crc ^ -1) >>> 0;
};

var Cdn = function () {
  function Cdn(GAF_BASE_URL, GAF_CDN_URLS) {
    _classCallCheck(this, Cdn);

    this.GAF_BASE_URL = GAF_BASE_URL;
    this.GAF_CDN_URLS = GAF_CDN_URLS;
  }
  /**
  * @ngdoc method
  * @name flCdn.Cdn#getCdnUrl
  * @methodOf flCdn.Cdn
  *
  * @description
  * Tries to retrieve a CDN URL for a given URL, and falls back to
  * GAF_BASE_URL if it fails.
  *
  * @param {String} url The URL we want to convert to a CDN URL.
  * @returns {String} A CDN URL in case a CDN is available, otherwise it
  * returns a regular url.
  */


  _createClass(Cdn, [{
    key: 'getCdnUrl',
    value: function getCdnUrl(url) {
      if (this.GAF_CDN_URLS.length > 0) {
        var host = this.GAF_CDN_URLS[Math.abs(crc32(url)) % this.GAF_CDN_URLS.length];
        return host + url;
      }
      return this.GAF_BASE_URL + url;
    }
  }]);

  return Cdn;
}();

Cdn.$inject = ['GAF_BASE_URL', 'GAF_CDN_URLS'];


var CdnProvider = flService('Cdn', [OPAQUE_MODULE_NAME], Cdn);

/**
* @ngdoc service
* @name flApi.GafInterceptor
* @description
*
* HTTP Interceptor for most GAF endpoints.

* DO NOT MODIFY THAT INTERCEPTOR.
* If you need to deal with an endpoint in GAF which behaves differently than
* the others, use a custom interceptor like the HourlyContract service:
*
*```
*    const customInterceptor = {
*      request: GafInterceptor.request,
*
*      response: function(response) {
*        return $q.when(GafInterceptor.response(response))
*        .then(function(data) {
*          return data.message;
*        });
*      },
*
*      responseError: function(response) {
*        switch(response.status) {
*          case 403:
*            response.code = 'CREDENTIAL_ERROR';
*            break;
*          case 400:
*            response.code = 'BAD_REQUEST';
*            break;
*          default:
*            response.code = 'UNKNOWN_ERROR';
*            break;
*        }
*        return $q.reject(response);
*      }
*    };
*```
*
* Note how the request method of the GafInterceptor is reused since only the
* response is different here. In doubt, ask for advices on the Angular HipChat
* channel.
*/

var GafInterceptor = function GafInterceptor($q, RequestTransformation) {
  _classCallCheck(this, GafInterceptor);

  return {
    /**
     * @ngdoc method
     * @name flApi.GafInterceptor#request
     * @methodOf flApi.GafInterceptor
     *
     * @description
     * Url Form encode the HTTP requests
     * ('application/x-www-form-urlencoded')
     *
     * @param {Object} config The request configuration object
     * @returns {Object} The config object received as a parameter,
     * eventually modified.
     */
    request: function request(config) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      config.transformRequest = [];
      config.data = RequestTransformation.formUrlEncodedRecursive(config.data);
      return config;
    },
    /**
     * @ngdoc method
     * @name flApi.GafInterceptor#response
     * @methodOf flApi.GafInterceptor
     *
     * @description
     * Unpack the response from some of the GAF endpoint.
     * DO NOT EXTEND THAT BOOLEAN EXPRESSION. This is very ugly and will be
     * removed at some point. Write you own interceptor like the
     * HourlyContract service if needed
     *
     * @param {Object} response The content of the response.
     * @returns {Object} The object received as a parameter,
     * eventually modified.
     */
    response: function response(_response) {
      if (_response.data && (_response.data === 'success' || _response.data === 'true' || _response.data.success === true || _response.data.status === 'success' || _response.data.status === true)) {
        if (_response.data.data) {
          _response.data = _response.data.data;
        }
      } else {
        _response.defaultError = 'Internal error, please try again later.';
        return $q.reject(_response);
      }
      return _response.data;
    }
  };
};

GafInterceptor.$inject = ['$q', 'RequestTransformation'];


var GafInterceptorProvider = flService('GafInterceptor', [RequestTransformationProvider], GafInterceptor);

/**
 * @ngdoc service
 * @name flApi.Currencies
 *
 * @description
 * A factory that returns an object that exposes methods to easily interact
 * with the `currencies` API
 */

var Currencies = function () {
  function Currencies(flResource, ApiInterceptor, API_BASE_URL) {
    _classCallCheck(this, Currencies);

    this.ApiInterceptor = ApiInterceptor;
    this.API_BASE_URL = API_BASE_URL;
    this.resource = flResource(API_BASE_URL + '/projects/0.1/currencies/', ApiInterceptor, null, { get: { cache: true } });
  }

  /**
   * @ngdoc method
   * @name flApi.Currencies#currencyFactory
   * @methodOf flApi.Currencies
   *
   * @description
   * A factory that generates Currency objects
   *
   * @param {Object} c An object containing a raw currency information
   * @returns {Object} The returned Currency object exposes 1 methods:
   *
   * - get() returns the raw currency information
   */


  _createClass(Currencies, [{
    key: 'currencyFactory',
    value: function currencyFactory(c) {
      var currency = c;

      return {
        get: function get() {
          return currency;
        }
      };
    }

    /**
     * @ngdoc method
     * @name flApi.Currencies#get
     * @methodOf flApi.Currencies
     *
     * @description
     * Return a list of all currencies, or a subset if currencies specified.
     *
     * @param {Object} params An object containing a list of currencies.
     * Available options for params are:
     *
     * currency_codes[]: codes of the currencies
     * currency_ids[]: ids of the currencies
     * @returns {Object} An object generated by currencyListFactory
     */

  }, {
    key: 'get',
    value: function get(params) {
      var _this = this;

      return this.resource.get(params).$promise.then(function (data) {
        return _this.currencyListFactory(data.currencies);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Currencies#currencyListFactory
     * @methodOf flApi.Currencies
     *
     * @description
     * A factory that generates CurrencyList objects
     *
     * @param {Object} c An object containing a list of currencies
     * @returns {Object} The returned CurrencyList object exposes 3 methods:
     *
     * - getMap() returns the raw list of Currencies
     * - getById(id) returns a currency object, given a currencyId
     * - get(params) returns a currency object, given a list of parameters
     */

  }, {
    key: 'currencyListFactory',
    value: function currencyListFactory(c) {
      var _this2 = this;

      var currencies = c;

      return {
        getMap: function getMap() {
          return currencies;
        },
        getList: function getList() {
          return Array.from(Object.keys(currencies).map(function (key) {
            return currencies[key];
          }));
        },
        getById: function getById(id) {
          var currency = Object.keys(currencies).map(function (key) {
            return currencies[key];
          }).find(function (cu) {
            return cu.id === id;
          });
          if (currency) {
            return _this2.currencyFactory(currency);
          }
          return undefined;
        },
        get: function get(params) {
          if (Object.keys(params).length === 1) {
            var _ret = function () {
              var key = Object.keys(params)[0];

              var currency = Object.keys(currencies).map(function (k) {
                return currencies[k];
              }).find(function (cu) {
                return cu[key] === params[key];
              });
              if (currency) {
                return {
                  v: _this2.currencyFactory(currency)
                };
              }
            }();

            if (typeof _ret === "object") return _ret.v;
          }
          return undefined;
        }
      };
    }
  }]);

  return Currencies;
}();

Currencies.$inject = ['flResource', 'ApiInterceptor', 'API_BASE_URL'];


var CurrenciesProvider = flService('Currencies', [flResourceProvider, ApiInterceptorProvider, OPAQUE_MODULE_NAME], Currencies);

var User = function () {
  function User(user, Cdn, DEFAULT_AVATAR_URL, Currencies) {
    _classCallCheck(this, User);

    this.user = user;
    this.Cdn = Cdn;
    this.Currencies = Currencies;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
  }

  _createClass(User, [{
    key: 'canBeQuickHiredBy',
    value: function canBeQuickHiredBy(otherUser) {
      // A user can only be quick hired if that user is a freelancer (or
      // 'both'), and the other user is an employer (or 'both').
      var freelancerRoles = ['freelancer', 'both'];
      var employerRoles = ['employer', 'both'];

      return freelancerRoles.indexOf(this.getRole()) !== -1 && employerRoles.indexOf(otherUser.getRole()) !== -1;
    }
  }, {
    key: 'get',
    value: function get() {
      return this.user;
    }
  }, {
    key: 'getAvatarUrl',
    value: function getAvatarUrl() {
      if (this.user && this.user.avatar) {
        return this.Cdn.getCdnUrl(this.user.avatar);
      }

      // Fallback as sometimes user object is malformed at times
      return this.Cdn.getCdnUrl(this.DEFAULT_AVATAR_URL);
    }
  }, {
    key: 'getPrimaryCurrency',
    value: function getPrimaryCurrency() {
      return this.Currencies.currencyFactory(this.user.primary_currency);
    }
  }, {
    key: 'getBalanceForCurrency',
    value: function getBalanceForCurrency(currencyId) {
      var result = void 0;

      angular.forEach(this.user.account_balances.balances, function (balance) {
        if (balance.currency.id === parseInt(currencyId, 10)) {
          result = balance;
        }
      });

      return result;
    }
  }, {
    key: 'getRole',
    value: function getRole() {
      // Before a user bids or posts a project, their role type is
      // completely wrong. It doesn't just contain an inaccurate value, it
      // contains a value that doesn't make any sense what so ever. I'm
      // talking like apostrophe's in the db. APOSTROPHES. YES.
      //
      // That a side, even when the user has the role specified, it may be
      // inaccurate if it set to 'freelancer'. So if the role is
      // freelancer, AND their self chosen role is set AND is set to a
      // different value, we will assume their self chosen role is
      // correct, and use that.
      var role = this.user.role;
      var chosenRole = this.user.chosen_role;

      if (role === 'freelancer' && role !== chosenRole && chosenRole) {
        role = chosenRole;
      }
      return role;
    }
  }, {
    key: 'set',
    value: function set(updatedUser) {
      angular.extend(this.user, updatedUser);
    }
  }]);

  return User;
}();

var UserList = function () {
  function UserList(users, searchTotal, order, Cdn, DEFAULT_AVATAR_URL, Currencies) {
    _classCallCheck(this, UserList);

    this.users = users;
    this.searchTotal = searchTotal;
    this.order = order;
    this.Cdn = Cdn;
    this.Currencies = Currencies;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
  }

  _createClass(UserList, [{
    key: 'getMap',
    value: function getMap() {
      return this.users;
    }
  }, {
    key: 'getList',
    value: function getList() {
      var _this = this;

      if (angular.isUndefined(this.list)) {
        this.list = [];
        this.order.forEach(function (id) {
          _this.list.push(_this.users[id]);
        });
      }

      return this.list;
    }
  }, {
    key: 'getById',
    value: function getById(id) {
      if (angular.isDefined(this.users[id])) {
        return new User(this.users[id], this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
      }
      return undefined;
    }
  }, {
    key: 'getCount',
    value: function getCount() {
      return this.getList().length;
    }
  }, {
    key: 'getSearchTotal',
    value: function getSearchTotal() {
      if (angular.isDefined(this.searchTotal) && this.searchTotal !== null) {
        return this.searchTotal;
      }
      return undefined;
    }
  }]);

  return UserList;
}();

/**
 * @ngdoc service
 * @name flApi.Users
 *
 * @description
 * A factory which creates a convenient service for interacting with
 * Users API.
 */


var Users = function () {
  function Users($q, Auth, Cdn, Currencies, flResource, ApiInterceptor, GafInterceptor, API_BASE_URL, GAF_BASE_URL, DEFAULT_AVATAR_URL) {
    _classCallCheck(this, Users);

    this.Cdn = Cdn;
    this.$q = $q;
    this.Auth = Auth;
    this.DEFAULT_AVATAR_URL = DEFAULT_AVATAR_URL;
    this.Currencies = Currencies;

    this.Users = flResource(API_BASE_URL + '/users/0.1/users/:userId/', ApiInterceptor, null, {
      get: {
        cache: true
      },
      getList: {
        url: API_BASE_URL + '/users/0.1/users/'
      },
      getDirectory: {
        url: API_BASE_URL + '/users/0.1/users/directory/'
      },
      getSelf: {
        url: API_BASE_URL + '/users/0.1/users/self/'
      },
      updateUserInfo: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/users/self/'
      },
      setJobs: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/self/jobs/'
      },
      setLocation: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/self/location/'
      },
      check: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/users/check/'
      },
      sendPhoneVerification: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/phone_verifications/'
      },
      submitPhoneVerification: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/phone_verifications/'
      },
      alertBoxClose: {
        method: 'POST',
        url: GAF_BASE_URL + '/ajax/alertbox_dont_show_next_time.php',
        interceptor: GafInterceptor
      },
      search: {
        url: API_BASE_URL + '/users/0.1/users/directory/'
      },
      deprecatedSearch: {
        url: GAF_BASE_URL + '/ajax/directory/getFreelancer.php',
        interceptor: GafInterceptor
      },
      getProfile: {
        url: GAF_BASE_URL + '/ajax/getUserProfileData.php',
        interceptor: GafInterceptor
      },
      setProfile: {
        method: 'PUT',
        url: API_BASE_URL + '/users/0.1/users/self/account'
      },
      setPhoneNumber: {
        method: 'POST',
        url: GAF_BASE_URL + '/ajax/signup/register.php',
        interceptor: GafInterceptor
      },
      getPortfolios: {
        url: API_BASE_URL + '/users/0.1/portfolios/',
        interceptor: GafInterceptor
      },
      isReferralInvitationsEligible: {
        method: 'GET',
        url: API_BASE_URL + '/users/0.1/referral_invitations/check/'
      },
      getReferralInvitationsList: {
        method: 'GET',
        url: API_BASE_URL + '/users/0.1/referral_invitations/'
      },
      createReferralInvitation: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/referral_invitations/'
      }
    });

    this.FBUsers = flResource(API_BASE_URL + '/users/0.1/users/facebook/', ApiInterceptor, null, {
      link: {
        method: 'POST',
        url: API_BASE_URL + '/users/0.1/users/facebook/link/'
      }
    });
  }

  /**
   * @ngdoc method
   * @name flApi.Users#userFactory
   * @methodOf flApi.Users
   *
   * @description
   * A factory that generates User objects
   *
   * @returns {Object} The returned User object exposes 5 methods:
   *
   * - canBeQuickHiredBy(user) Checks if the given user can hire the current
   *   user. returns true iff the current user role is either 'freelancer'
   *   or 'both', AND the other users role is either 'employer' or 'both'.
   * - get() returns the raw user information
   * - getAvatarUrl() returns the users avatar url
   * - getPrimaryCurrency() returns the users primary currency
   * - getBalanceForCurrency() returns the user's balance for for specific
   *   currency id
   * - getRole() returns the users role (freelancer/employer/both). This
   *   function takes into account the users 'role' and their 'chosen role'.
   * - set(updatedUser) extends the user object with the specified
   *   parameters
   */


  _createClass(Users, [{
    key: 'userFactory',
    value: function userFactory(u) {
      return new User(u, this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#userListFactory
    * @methodOf flApi.Users
    *
    * @description
    * A factory that generated UserList objects
    *
    * @param {Object} users An object containing a map of users
    * @param {Number} [searchTotal] Total number of users matching the search
    * criteria, see Users.search()
    * @param {Array} [order] List of user ids in specific order; if specified,
    * affects the order returned by userListFactory.getList()
    * @returns {Object} The returned UserList object exposes 4 methods:
    *
    * - getMap() returns the raw object of users
    * - getList() returns a list of user objects NOTE: the ordering of users
    *   is undefined. If you need it to be ordered, you will need to order it
    *   yourself.
    * - getById(id) returns the user object, given a userId
    * - getCount() returns the number of users
    * - getSearchTotal() for search, Users.search(), this returns the total
    *   number of users matching the search criteria; otherwise this will
    *   be undefined
    */

  }, {
    key: 'userListFactory',
    value: function userListFactory(users, searchTotal) {
      var order = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Object.keys(users);

      return new UserList(users, searchTotal, order, this.Cdn, this.DEFAULT_AVATAR_URL, this.Currencies);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#get
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a list of parameters
    *
    * @param {Object} params list of parameters for the requested user.
    * Possible values are:
    *
    * - users[] – Optional list of user IDs to search on.
    * - usernames[] – Optional list of usernames
    * - avatar – Return avatar for each user.
    * - reputation – Return freelancer reputation for each user.
    * - reputation_extra – Return full freelancer reputation info
    * - (jobhistory/projstats).
    * - employer_reputation – Return employer reputation for each user.
    * - employer_reputation_extra – Return full employer reputation info
    * - (jobhistory/projstats).
    * - country_details – Return country flag/code for each user.
    * - profile_description – Return user’s profile blurb
    * - display_info – Return user’s profile name/tagline
    * - jobs – Return jobs (i.e. skills) that the user currently has
    * - status – Return additional status info about user (see UserStatus).
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'get',
    value: function get(params) {
      var _this2 = this;

      return this.Users.get(params).$promise.then(function (user) {
        return _this2.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getDirectory
    * @methodOf flApi.Users
    *
    * @description
    * Get list of freelancers from directory. This method calls the
    * GET /api/users/0.1/users/directory/ endpoint, documented here:
    * https://rtfm.freelancer.com/rtfm/flapi-rest-docs/users_api_0_1.html
    * #get--api-users-0.1-users-directory-
    *
    * @param {Object} params list of parameters for the requested user.
    * Possible values are:
    *
    * - jobs[] – A list of job ids to search for
    * - countries[] – A list of country names to fetch freelancers from.
    * - username – The username of a freelancer to fetch
    * - hourly_rate_min – The minimum hourly rate of freelancers fetched.
    * - hourly_rate_max – The maximum hourly rate of freelancers fetched.
    * - online_only – Only fetch freelancers who are online.
    * - location_latitude – Fetch freelancers close to this latitude
    * - location_longitude – Fetch freelancers close to this longitude
    * - insignias[] – Fetch freelancers who have completed exams with these id
    * - rating – Search for freelancers with a minimum star rating
    * - offset – A pagination offset when fetching the list of users
    * - limit – The number of users to return in the list. Default is 10
    *
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getDirectory',
    value: function getDirectory(params) {
      var _this3 = this;

      return this.Users.getDirectory(params).$promise.then(function (users) {
        return _this3.userListFactory(users);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getByUserId
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a specific user id and a list of parameters
    *
    * @param {Number} userId the id of the user you want to get
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getByUserId',
    value: function getByUserId(userId, params) {
      var p = params || {};
      p.userId = userId;

      return this.get(p);
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getByUsername
    * @methodOf flApi.Users
    *
    * @description
    * Get user info given a specific username and a list of parameters
    *
    * @param {String} username the username of the user you want to get
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getByUsername',
    value: function getByUsername(username, params) {
      var _this4 = this;

      var p = params || {};
      p['usernames[]'] = [username];

      return this.Users.get(params).$promise.then(function (response) {
        if (Object.keys(response.users).length) {
          return _this4.userFactory(response.users[Object.keys(response.users)[0]]);
        }

        return _this4.$q.reject({
          code: 'NOT_FOUND'
        });
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getLoggedInUser
    * @methodOf flApi.Users
    *
    * @description
    * Get user info for current user
    *
    * @param {Object} params list of parameters for the requested user
    * See Users.get() for a list of all possible values.
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory
    */

  }, {
    key: 'getLoggedInUser',
    value: function getLoggedInUser(params) {
      var _this5 = this;

      return this.Users.getSelf(params).$promise.then(function (user) {
        return _this5.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getList
    * @methodOf flApi.Users
    *
    * @description
    * Returns list of users. As per the api, users[] or usernames[] must be
    * provided.
    *
    * @param {Object} params An object containing a set of query parameters
    * that will be used as search criteria. Possible values for params are:
    *
    * - users[]: the ids of specific users
    * - usernames[]: the usernames of specific users
    * @returns {Object} A userList object generated by userListFactory
    */

  }, {
    key: 'getList',
    value: function getList(params) {
      var _this6 = this;

      return this.Users.getList(params).$promise.then(function (result) {
        return _this6.userListFactory(result.users);
      });
    }
    /**
    * @ngdoc method
    * @name flApi.Users#getPortfolios
    * @methodOf flApi.Users
    *
    * @description
    * Returns list of users and portfolios. As per the api, users[] must be
    * provided.
    *
    * @param {Object} params An object containing a set of query parameters
    * that will be used as search criteria. Possible values for params are:
    *
    * - users[]: the ids of specific users
    * - limit
    * - offset
    * @returns {Object} portfolio and users object.
    */

  }, {
    key: 'getPortfolios',
    value: function getPortfolios() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return this.Users.getPortfolios(params).$promise.then(function (response) {
        return response.result;
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#create
    * @methodOf flApi.Users
    *
    * @description
    * Sign up a new user and logs in
    *
    * @param {Object} user an object containing info about the user to create
    * e.g. user.id, user.avatar etc...
    * @param {String} password the password for this user
    * @param {String} captcha captcha string
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or a String in case of error, with one
    * of the following values (quite self-explanatory):
    *
    * - CAPTCHA_REQUIRED
    * - INVALID_CAPTCHA
    * - USERNAME_TAKEN
    * - EMAIL_TAKEN
    */

  }, {
    key: 'create',
    value: function create(user, password, captcha) {
      var _this7 = this;

      var extra = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var newUser = {
        user: {
          email: user.email,
          username: user.username,
          role: user.role
        },
        password: password,
        captcha: captcha || {},
        extra: extra
      };

      return this.Users.save(newUser).$promise.then(function (data) {
        _this7.Auth.set(data.auth_hash, data.user.id, true);
        return _this7.userFactory(data.user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#createWithFacebook
    * @methodOf flApi.Users
    *
    * @description
    * Sign up a new user and logs in using facebook credentials
    *
    * @param {Object} user an object containing info about the user to create
    * e.g. user.id, user.avatar etc...
    * @param {String} facebookId the facebook id of the user
    * @param {String} accessToken the token used to authenticate the user
    * @param {Object} extra an object containing extra data to pass through API
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or a String in case of error
    */

  }, {
    key: 'createWithFacebook',
    value: function createWithFacebook(user, facebookAuthParams) {
      var _this8 = this;

      var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var newUser = {
        user: {
          email: user.email,
          username: user.username,
          role: user.role
        },
        facebook_id: facebookAuthParams.userID,
        access_token: facebookAuthParams.accessToken,
        extra: extra
      };

      return this.FBUsers.save(newUser).$promise.then(function (data) {
        _this8.Auth.set(data.auth_hash, data.user.id, true);
        return _this8.userFactory(data.user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#linkFacebook
    * @methodOf flApi.Users
    *
    * @description
    * Link facebook account to existing user account. The user needs to be
    * logged in before calling this method.
    *
    * @param {String} email email address of user
    * @param {password} email password of user
    * @param {String} facebook_id the facebook id of the user
    * @param {String} access_token the token used to authenticate the user
    * @returns {Object} a Promise object that will be resolved with a user
    * object created by userFactory, or an error object in case of error
    */

  }, {
    key: 'linkFacebook',
    value: function linkFacebook(facebookAuthParams) {
      var _this9 = this;

      var linkInfo = {
        facebook_id: facebookAuthParams.userID,
        access_token: facebookAuthParams.signedRequest
      };

      return this.FBUsers.link(linkInfo).$promise.then(function (user) {
        return _this9.userFactory(user);
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#check
    * @methodOf flApi.Users
    *
    * @description Check if the user's fields are valid for a user signup
    * request. Validated field are "username" and "email". Support a
    * "recommanded_name" param to get a suggested username based on a
    * submitted email/invalid username.
    *
    * @param {Object} user user object with "username" and/or "email" fields.
    * Checks each params individually.
    * @param {Object} params extra params. Only recommended_name is supported
    * for now, which gives back a recommended_name. The recommended username
    * is based off the email address when the email is valid, or based off
    * the username when the email is invalid
    */

  }, {
    key: 'check',
    value: function check(user, params) {
      var p = params || {};

      return this.Users.check(p, { user: user }).$promise.then(function (response) {
        return response;
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#updateUserInfo
     * @methodOf flApi.Users
     *
     * @description
     * Updates a user info given the action
     *
     * @param {String} Valid prams are [email_verify, local_jobs_enable,
     * local_email_subscribe, local_email_unsubscribe].
     */

  }, {
    key: 'updateUserInfo',
    value: function updateUserInfo(action) {
      return this.Users.updateUserInfo({ action: action }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setJobs
    * @methodOf flApi.Users
    *
    * @description
    * Updates ths skills for a logged in user
    *
    * @param {Object} jobs list(int) a list of job ids
    * ```
    *  {
    *    "jobs[]": [2, 3]
    *  }
    * ```
    */

  }, {
    key: 'setJobs',
    value: function setJobs(jobs) {
      return this.Users.setJobs({ 'jobs[]': jobs }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setLocation
    * @methodOf flApi.Users
    *
    * @description
    * Updates the location information for the logged in user.
    *
    * @param {Object} loc location object with the as followed:
    * ```
    *  {
    *    country: {
    *      name: 'Australia'
    *    },
    *    city: 'Sydney',
    *    latitude: -33.873651,
    *    longitude: 151.2068896,
    *    vicinity: 'Sydney',
    *    administrativeArea: 'Sydney',
    *    fullAddress: '42 Wallaby Way, Sydney, NSW, 2008, Australia'
    *  }
    * ```
    */

  }, {
    key: 'setLocation',
    value: function setLocation(loc) {
      return this.Users.setLocation({
        country: loc.country,
        city: loc.city,
        latitude: loc.latitude,
        longitude: loc.longitude,
        vicinity: loc.vicinity,
        administrative_area: loc.administrativeArea,
        full_address: loc.fullAddress
      }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#alertBoxClose
    * @methodOf flApi.Users
    *
    * @description
    * Adds an entry to alert_box_dont_show_next_time table which keeps track
    * of what alerts/messages the user encounters
    *
    * @param {String} event the name of the alert or event
    * @param {Number} eventId an id associated with the event such as a
    * project id
    * @param {Number} otherPartyId Optional an id associated with a secondary
    * party such as another user id
    *
    */

  }, {
    key: 'alertBoxClose',
    value: function alertBoxClose(event, eventId, otherPartyId) {
      return this.Users.alertBoxClose({
        event: event,
        event_id: eventId,
        otherparty_user_id: otherPartyId
      }).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#search
     * @methodOf flApi.Users
     *
     * @description
     * Search for users.
     *
     * @param {String} keyword Search filter to query by profile
     * description, username and jobs
     * @param {Object} params A list of additional parameters to be used as
     * search criteria.
     * @returns {Object} a Promise object that will be resolved with a user
     * list object created by userListFactory.
     */

  }, {
    key: 'search',
    value: function search(keywords) {
      var _this10 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      params.query = keywords;

      return this.Users.search(params).$promise.then(function (result) {
        var users = {};
        var order = [];

        Object.keys(result.users).forEach(function (key) {
          var user = result.users[key];
          users[user.id] = user;
          order.push(user.id);
        });

        return _this10.userListFactory(users, result.total_count, order);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#search
     * @methodOf flApi.Users
     *
     * @description
     * Search for users using the GAF endpoint.
     *
     * Taken from v1. This will be used by the search page when it is migrated
     * to ES6. At the moment, there are still some data missing from the Users
     * API, such as the top skills.
     *
     * This should be removed once the Users API and Search module have been
     * updated.
     *
     * @param {String} keywords A set of terms, space separated.
     * @param {Object} params A list of additional parameters to be used as
     * search criteria.
     * @returns {Object} a Promise object that will be resolved with a user
     * list object created by userListFactory.
     */

  }, {
    key: 'deprecatedSearch',
    value: function deprecatedSearch(keywords) {
      var _this11 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      params.freeSearch = keywords;

      return this.Users.deprecatedSearch(params).$promise.then(function (result) {
        var users = {};
        var order = [];

        Object.keys(result.users).forEach(function (key) {
          var user = result.users[key];
          users[user.user_id] = user;
          order.push(user.user_id);
        });

        return _this11.userListFactory(users, result.count, order);
      });
    }

    /**
     * @ngdoc method
     * @name flApi.Users#setPhoneNumber
     * @methodOf flApi.Users
     *
     * @description
     * Updates the phone number info for the logged in user.
     *
     * @param {Number} phone The phone number to be associated with the user.
     * @param {Number} timestamp The timestamp of expiry.
     * @param {String} token Sha1 generated token from phone, timestamp and
     * CSRF token.
     */

  }, {
    key: 'setPhoneNumber',
    value: function setPhoneNumber(phone, timestamp, token) {
      var _this12 = this;

      return this.Users.setPhoneNumber({
        tm: timestamp,
        ph: phone,
        t: token
      }).$promise
      // Assign error code when ajax endpoint returns error: invalid request
      .catch(function () {
        return _this12.$q.reject({
          code: 'LOCAL_BID_INVALID_REQUEST'
        });
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getProfile
    * @methodOf flApi.Users
    * @description
    * get the profile info for the logged in user.
    * @returns {Object} a Promise object that will be resolved with user
    * profile information.
    **/

  }, {
    key: 'getProfile',
    value: function getProfile() {
      return this.Users.getProfile().$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#setProfile
    * @methodOf flApi.Users
    *
    * @description
    * Updates the profile info for the logged in user.
    *
    * @param {Object} name userData user profile information
    * fields to be updated
    * @returns {Object} a Promise object that will be resolved
    * with profile update success
    */

  }, {
    key: 'setProfile',
    value: function setProfile(userData) {
      return this.Users.setProfile({
        first_name: userData.firstname,
        last_name: userData.lastname,
        address1: userData.address1,
        city: userData.city,
        company: userData.company,
        zip: userData.zip,
        state_code: userData.state_code,
        timezone: userData.timezone,
        thm_session: userData.thm_session,
        token: userData.token
      }).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#sendPhoneVerification
     * @methodOf flApi.Users
     *
     * @description
     * Requests a verification code to be sent to a given phone number.
     *
     * @param {Object} params Query parameters.
     * @param {String} params.phone_number The phone number you wish to
     * verify.
     * @param {String} params.country_code The numeric code which is prefixed
     * to the phone number.
     * @param {String} params.operation The string enum of the type of
     * message you want to receive (either 'sms' or 'call').
     * @param {String} params.requested_country The string country code of
     * the phone's country.
     * @param {Boolean} params.request_phone_change Whether the user already
     * has a verified phone number.
     *
     * @returns {Object} a Promise object that will be resolved with a
     * boolean value 'reference_id', which is used by the phone verification
     * submit endpoint.
     */

  }, {
    key: 'sendPhoneVerification',
    value: function sendPhoneVerification(params) {
      return this.Users.sendPhoneVerification(params).$promise;
    }

    /**
     * @ngdoc method
     * @name flApi.Users#submitPhoneVerification
     * @methodOf flApi.Users
     *
     * @description
     * Updates a phone verification process with a given action.
     *
     * @param {Object} params Query parameters.
     * @param {String} params.action 'verify'.
     * @param {Object} params.verification_details Verification details.
     * @param {String} params.verification_details.reference_id The
     * identifier returned by the verification request.
     * @param {String} params.verification_details.verification_code The code
     * sent to the phone.
     * @param {Boolean} params.verification_details.request_phone_change
     * Whether the user already has a verified phone number.
     * @param {Object} params.verification_details.phone_details Phone
     * details of the phone the code was sent to.
     * @param {String} params.verification_details.phone_details.phone_number
     * The phone number you wish to verify
     * @param {String} params.verification_details.phone_details.country_code
     * The numeric code which is prefixed to the phone number.
     * @param {String}
     * params.verification_details.phone_details.requested_country The string
     * country code of the phone's country.
     *
     * @returns {Object} a Promise object that will be resolved with a
     * boolean value 'id_verification_required', which is set to true if a
     * user must complete their ID verification before the phone verification
     * process is complete.
     *
     */

  }, {
    key: 'submitPhoneVerification',
    value: function submitPhoneVerification(params) {
      return this.Users.submitPhoneVerification(params).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#isGiveGetEligible
    * @methodOf flApi.Users
    *
    * @description
    * Is user eligible in Give Get referral program
    *
    * @returns {Object} a Promise object that will be resolved with a boolean
    * value which is set to true if user is eligible for give get and false
    * otherwise
    */

  }, {
    key: 'isGiveGetEligible',
    value: function isGiveGetEligible() {
      return this.Users.isReferralInvitationsEligible({ bonus_id: 16 }).$promise.catch(function () {
        return false;
      }).then(function (data) {
        if (typeof data === 'object') {
          return data.result;
        }
        return data;
      });
    }

    /**
    * @ngdoc method
    * @name flApi.Users#getGiveGetInvitationsList
    * @methodOf flApi.Users
    *
    * @description
    * Get list of invitations of Give Get referral program.
    * Each element of the array has status, email and send_date.
    *
    * @returns {Object} a Promise object that will be resolved with array of
    *   invitation list
    */

  }, {
    key: 'getGiveGetInvitationsList',
    value: function getGiveGetInvitationsList() {
      return this.Users.getReferralInvitationsList({ bonus_id: 16 }).$promise;
    }

    /**
    * @ngdoc method
    * @name flApi.Users#createGiveGetInvitation
    * @methodOf flApi.Users
    *
    * @description
    * Create GiveGet invitation. Give Get bonus Id = 16
    * @param {object}   emails    array of email addresses
    * @returns {array} List of user
    */

  }, {
    key: 'createGiveGetInvitation',
    value: function createGiveGetInvitation(emails) {
      return this.Users.createReferralInvitation({
        bonus_id: 16,
        emails: emails
      }).$promise;
    }
  }]);

  return Users;
}();

Users.$inject = ['$q', 'Auth', 'Cdn', 'Currencies', 'flResource', 'ApiInterceptor', 'GafInterceptor', 'API_BASE_URL', 'GAF_BASE_URL', 'DEFAULT_AVATAR_URL'];


var UsersProvider = flService('Users', [flResourceProvider, AuthModule, CdnProvider, CurrenciesProvider, ApiInterceptorProvider, GafInterceptorProvider, OPAQUE_MODULE_NAME], Users);

var UsersService = function () {
  function UsersService($http, $log, $window, Auth, FACEBOOK_APP_ID, Localization, Users) {
    _classCallCheck(this, UsersService);

    this.$http = $http;
    this.$window = $window;
    this.Auth = Auth;
    this.Users = Users;
    this.$log = $log;
    this.newAuthUrl = '/auth'; // TODO replace this to use config
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
    this.LOCALSTORAGE_DEVICE_KEY = 'deviceToken';
    this.Localization = Localization;
  }

  /**
   * get device token from Auth Server and saves it to local storage for token reuse
   * The priority to retrieve is:
   * 1. From UserData that parsed in
   * 2. From localStorage
   * 3. From auth server
   * @param UserData user UserData object in UsersService
   */

  _createClass(UsersService, [{
    key: 'getDeviceToken',
    value: function getDeviceToken(user) {
      var _this = this;

      var deviceToken = void 0;
      if (user.deviceToken) {
        return user.deviceToken;
      }

      if (window.localStorage) {
        deviceToken = window.localStorage.getItem(this.LOCALSTORAGE_DEVICE_KEY);
      }

      if (deviceToken) {
        user.deviceToken = deviceToken;
        return Promise.resolve(deviceToken);
      }

      return this.$http.get(this.newAuthUrl + '/device/').then(function (response) {
        if (response.status === 200 && response.data) {
          if (window.localStorage) {
            try {
              window.localStorage.setItem(_this.LOCALSTORAGE_DEVICE_KEY, response.data.token);
            } catch (e) {
              // throws QuotaExceededError in Safari <11.
              _this.trackError('QuotaExceededError', e);
            }
          }
          user.deviceToken = response.data.token;
          return response.data.token;
        }
        throw new Error('auth: invalid server response: ' + response.data);
      }).catch(function (e) {
        return _this.trackError('GetDeviceToken', e);
      });
    }
  }, {
    key: 'verifyNewEmail',
    value: function verifyNewEmail(email) {
      var _this2 = this;

      var params = {
        existing: true,
        json: true,
        email: email
      };
      return this.$http.get('/ajax/users/email/check_email_valid.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this2.trackError('EmailExistsCheck', e);
      });
    }
  }, {
    key: 'checkBlockedEmail',
    value: function checkBlockedEmail(email) {
      var _this3 = this;

      var params = { email: email };
      return this.$http.get('/ajax/check-email-blocked.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this3.trackError('BlockedEmailCheck', e);
      });
    }
  }, {
    key: 'autofillUsername',
    value: function autofillUsername(email) {
      var _this4 = this;

      var user = { email: email };
      return this.Users.check(user, { recommend_name: true }).catch(function (e) {
        return _this4.trackError('AutofillUsername', e);
      });
    }
  }, {
    key: 'getSuggestedUsernames',
    value: function getSuggestedUsernames(email) {
      var _this5 = this;

      var user = { email: email };
      return this.Users.check(user, { recommend_name: true }).catch(function (e) {
        return _this5.trackError('GetSuggestedUsernames', e);
      });
    }
  }, {
    key: 'checkUsernameExists',
    value: function checkUsernameExists(username) {
      var _this6 = this;

      var params = {
        validator: true,
        username: username
      };
      return this.$http.get('/ajax/check-username-exist.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this6.trackError('UniqueUsernameCheck', e);
      });
    }
  }, {
    key: 'checkEmailExists',
    value: function checkEmailExists(email) {
      var _this7 = this;

      var params = {
        email: email,
        validator: true
      };
      return this.$http.get('/ajax/check-email-exist.php', { params: params }).then(function (response) {
        return response.data;
      }).catch(function (e) {
        return _this7.trackError('UniqueEmailCheck', e);
      });
    }
  }, {
    key: 'setExtraCookies',
    value: function setExtraCookies() {
      var _this8 = this;

      // sets a cookie to identify users who have logged in
      // at least once, separating them "from new_users"
      setCookieToBrowser(cookieBase + '_NOTNEW', true, 365, '/', cookieDomain);

      this.Users.getLoggedInUser().then(function (user) {
        _this8.Localization.language(user.get().primary_language);
      });

      var quickLoginFencePromise = this.getQuickLoginFenceCookie();

      Promise.all([quickLoginFencePromise]).then(function (responses) {
        var cookies = {};
        responses.forEach(function (cookie) {
          cookies = Object.assign(cookies, cookie);
        });

        _this8.Auth.setExtraCookies(cookies);
      });
    }

    /**
     * New 2FA Login Endpoint.
     *
     * Example request without device token:
     * {
     *   "status": "success",
     *   "result": {
     *     "token": "xx6IBy22+ve4rjkMAA1p5Q+fu/NvAeMz0vzeqQ6CcVY=",
     *     "user": 23521511
     *   },
     *   "request_id": "unknown"
     * }
     *
     * Example request with device token:
     * {
     *   "status": "success",
     *   "result": {
     *     "pre_login_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVC..",
     *     "message": "We've temporarily blocked this login attempt. Get a verification code from your Email."
     *   },
     *   "request_id": "unknown"
     * }
     */

  }, {
    key: 'login',
    value: function login(user, rememberLogin, old2FAToken) {
      var _this9 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        user: user.username,
        password: user.password
      };
      if (user.deviceToken) {
        data.device_token = user.deviceToken;
      }
      if (old2FAToken) {
        data.old_2FA_token = old2FAToken;
      }
      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this9.Auth.set(response.data.token, response.data.user, rememberLogin);
          _this9.setExtraCookies();
          return response;
        } else if (response.data && response.data.pre_login_token) {
          user.preLoginToken = response.data.pre_login_token;
          return response;
        }
      }).then(function (response) {
        return _this9.crossDomainSSO(response, rememberLogin);
      }).catch(function (response) {
        _this9.trackError('NewLoginUser', response.data.error_code);
        if (response.status === 401 || response.status === 429 || response.status === 500) {
          return Promise.reject(response);
        }
      });
    }

    /**
     * 2FA, Time-based One Time Password Login
     *
     * Example request:
     * {
     *   "status": "success",
     *   "result": {
     *     "token": "xx6IBy22+ve4rjkMAA1p5Q+fu/NvAeMz0vzeqQ6CcVY=",
     *     "user": 23521511
     *   },
     *   "request_id": "unknown"
     * }
     *
     * Example error request:
     * {
     *   "status": "error",
     *   "message": "There was a problem logging in with your account.Please contact support.",
     *   "error_code": "ExceptionCodes.EXPIRED_PRELOGIN_TOKEN",
     *   "request_id": "unknown"
     * }
     */

  }, {
    key: 'totpLogin',
    value: function totpLogin(user, rememberLogin) {
      var _this10 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        device_token: user.deviceToken,
        pre_login_token: user.preLoginToken,
        totp: user.TOTP
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login_verify.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this10.Auth.set(response.data.token, response.data.user, rememberLogin);
          _this10.setExtraCookies();
          return response;
        }
      }).then(function (response) {
        return _this10.crossDomainSSO(response, rememberLogin);
      }).catch(function (response) {
        _this10.trackError('totpLogin', response.data.error_code);
        if (response.status === 401) {
          return Promise.reject(response);
        } else if (response.status === 429) {
          return Promise.reject(response);
        } else if (response.status === 500) {
          return Promise.reject(response);
        }
      });
    }

    /**
     * Login through Facebook.
     */

  }, {
    key: 'loginWithFacebook',
    value: function loginWithFacebook(user) {
      var _this11 = this;

      var data = {
        app_id: this.FACEBOOK_APP_ID,
        oauth_type: 'facebook',
        credentials: user.facebookSignedRequest,
        access_token: user.facebookAccessToken
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/fb_login.php',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json'
        },
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login
          _this11.Auth.set(response.data.token, response.data.user);
          _this11.setExtraCookies();
          return response;
        } else if (response.data && response.data.pre_login_token) {
          user.preLoginToken = response.data.pre_login_token;
          return response;
        }
      }).then(function (response) {
        return _this11.crossDomainSSO(response);
      }).catch(function (response) {
        _this11.trackError('FacebookLogin', response.data.error_code);
        return Promise.reject(response);
      });
    }

    /**
     * Link Facebook Account.
     * - Given User Details and Facebook Tokens
     * - Able to bypass the TOTP Login.
     * - Default remembers login. (Same as loginWithFacebook->oAuthLogin)
     */

  }, {
    key: 'linkFacebookAccount',
    value: function linkFacebookAccount(user) {
      var _this12 = this;

      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        email: user.email,
        password: user.password,
        credentials: user.facebookSignedRequest,
        access_token: user.facebookAccessToken
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/fb_link_login.php',
        headers: headers,
        data: this.serializeData(data)
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data && response.data.token) {
          // Successfully login.
          _this12.Auth.set(response.data.token, response.data.user, true);
          _this12.setExtraCookies();
          return response;
        }
      }).then(function (response) {
        return _this12.crossDomainSSO(response);
      }).catch(function (response) {
        _this12.trackError('LinkFacebookAccount', response.data.error_code);
        if (response.status === 401 || response.status === 429 || response.status === 500) {
          return Promise.reject(response);
        }
      });
    }
  }, {
    key: 'crossDomainSSO',
    value: function crossDomainSSO(originalResponse, rememberLogin) {
      var _this13 = this;

      if (!originalResponse || !originalResponse.data || !originalResponse.data.token || !originalResponse.data.user) {
        return originalResponse;
      }
      var ssoPromise = function ssoPromise(domain) {
        return _this13.$http({
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/json'
          },
          url: domain + '/ajax/auth/cross_domain_sso.php',
          withCredentials: true,
          data: _this13.serializeData({
            authToken: originalResponse.data.token,
            userId: originalResponse.data.user,
            rememberLogin: !!rememberLogin
          })
        }).catch(function (e) {
          return _this13.trackError('CrossDomainSSOProcess', e);
        });
      };

      return this.$http({
        headers: { 'Content-Type': 'application/json' },
        url: '/ajax/auth/cross_domain_sso_domains.php'
      }).then(function (response) {
        if (response.status === 200 && response.data && response.data.domains) {
          var _ret = function () {
            var ssoPromises = [];
            var current = _this13.$window.location.protocol.concat('//').concat(_this13.$window.location.hostname);
            response.data.domains.forEach(function (domain) {
              if (domain !== current) {
                ssoPromises.push(ssoPromise(domain));
              }
            });
            return {
              v: Promise.all(ssoPromises).then(function () {
                return originalResponse;
              })
            };
          }();

          if (typeof _ret === "object") return _ret.v;
        }
        return originalResponse;
      }).catch(function (e) {
        return _this13.trackError('CrossDomainSSOGetDomains', e);
      });
    }
  }, {
    key: 'getQuickLoginFenceCookie',
    value: function getQuickLoginFenceCookie() {
      return this.$http({
        method: 'GET',
        url: '/ajax/signup/get-quick-login-fence.php'
      }).then(function (response) {
        if (response.status !== 200) {
          return Promise.reject(response);
        }
        if (response.data) {
          return response.data;
        }
      }).catch(function () {});
    }
  }, {
    key: 'forgotPassword',
    value: function forgotPassword(email) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-XSRF-TOKEN': getCSRFToken(),
        Accept: 'application/json'
      };
      var data = { email: email };
      return this.$http({
        method: 'POST',
        url: '/users/ajaxonforgotpassword.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }, {
    key: 'serializeData',
    value: function serializeData(obj) {
      var result = [];

      Object.keys(obj).forEach(function (key) {
        var value = obj[key];
        if (value === null) {
          value = '';
        }
        result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      return result.join('&');
    }
  }, {
    key: 'trackError',
    value: function trackError(label, e) {
      qtsp.push({
        section: 'newAuth2FA',
        subsection: 'usersService',
        label: label,
        action: 'error',
        value: JSON.stringify(e)
      });
    }
  }, {
    key: 'getLoginRedirectUrl',
    value: function getLoginRedirectUrl(redirectDisabled, isModal, goto) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };

      var data = {
        redirect_disabled: redirectDisabled,
        is_modal: isModal,
        goto: goto
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/login_redirect.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }, {
    key: 'getSignupRedirectUrl',
    value: function getSignupRedirectUrl(redirectDisabled, isModal, goto, projectCollaborationInvitation, contestCollaborationInvitation) {
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };

      var data = {
        redirect_disabled: redirectDisabled,
        is_modal: isModal,
        goto: goto,
        project_collaboration_invitation: projectCollaborationInvitation,
        contest_collaboration_invitation: contestCollaborationInvitation
      };

      return this.$http({
        method: 'POST',
        url: '/ajax/auth/signup_redirect.php',
        headers: headers,
        data: this.serializeData(data)
      });
    }
  }]);

  return UsersService;
}();

UsersService.$inject = ['$http', '$log', '$window', 'Auth', 'FACEBOOK_APP_ID', 'Localization', 'Users'];

var UsersProvider$1 = flService$1('UsersService', [AuthModule, UsersProvider, OPAQUE_MODULE_NAME], UsersService);

var UserData = function () {
  function UserData(UsersService) {
    _classCallCheck(this, UserData);

    this.user = {
      username: '',
      email: '',
      password: '',
      deviceToken: '',
      preLoginToken: '',
      TOTP: '',
      role: '',
      isNewUser: false,
      captcha: {
        challenge: '',
        response: ''
      },
      // Facebook
      facebookConnected: false,
      facebookName: '',
      facebookEmail: '',
      facebookPictureUrl: '',
      facebookAccessToken: '',
      facebookSignedRequest: '',
      // Privacy Consent
      isFromEU: false,
      privacyConsent: false,
      privateUser: null
    };
    this.UsersService = UsersService;
  }

  _createClass(UserData, [{
    key: 'setFacebookName',
    value: function setFacebookName(name) {
      this.user.facebookName = name;
    }
  }, {
    key: 'getFacebookName',
    value: function getFacebookName() {
      return this.user.facebookName;
    }
  }, {
    key: 'setFacebookEmail',
    value: function setFacebookEmail(email) {
      this.user.facebookEmail = email;
    }
  }, {
    key: 'getFacebookEmail',
    value: function getFacebookEmail() {
      return this.user.facebookEmail;
    }
  }, {
    key: 'setFacebookPictureUrl',
    value: function setFacebookPictureUrl(url) {
      this.user.facebookPictureUrl = url;
    }
  }, {
    key: 'getFacebookPictureUrl',
    value: function getFacebookPictureUrl() {
      return this.user.facebookPictureUrl;
    }
  }, {
    key: 'setFacebookUserId',
    value: function setFacebookUserId(id) {
      this.user.facebookUserId = id;
    }
  }, {
    key: 'getFacebookUserId',
    value: function getFacebookUserId() {
      return this.user.facebookUserId;
    }
  }, {
    key: 'setFacebookAccessToken',
    value: function setFacebookAccessToken(token) {
      this.user.facebookAccessToken = token;
    }
  }, {
    key: 'getFacebookAccessToken',
    value: function getFacebookAccessToken() {
      return this.user.facebookAccessToken;
    }
  }, {
    key: 'setFacebookConnected',
    value: function setFacebookConnected(isFacebook) {
      this.user.facebookConnected = isFacebook;
    }
  }, {
    key: 'isFacebookConnected',
    value: function isFacebookConnected() {
      return this.user.facebookConnected;
    }
  }]);

  return UserData;
}();

UserData.$inject = ['UsersService'];

var UserData$1 = flService$1('UserData', [UsersProvider$1], UserData);

/**
 * @ngdoc directive
 * @name flBlockedEmailCheck
 * @restrict A
 * @description
 * Validate if user email address is blocked
 */

var BlockedEmailCheck = function () {
  function BlockedEmailCheck($q, $timeout, UsersService) {
    _classCallCheck(this, BlockedEmailCheck);

    this.$q = $q;
    this.$timeout = $timeout;
    this.UsersService = UsersService;
  }

  _createClass(BlockedEmailCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$asyncValidators.unblockedEmail = function (modelValue, email) {
        var deferred = _this.$q.defer();
        _this.UsersService.checkBlockedEmail(email).then(function (isValidEmail) {
          _this.$timeout(function () {
            if (isValidEmail) {
              deferred.resolve();
            } else {
              deferred.reject();
            }
          }, 500);
        });
        return deferred.promise;
      };
    }
  }]);

  return BlockedEmailCheck;
}();

BlockedEmailCheck.$inject = ['$q', '$timeout', 'UsersService'];

var flBlockedEmailCheck = flDirective$1(BlockedEmailCheck, {
  selector: '[fl-blocked-email-check]',
  require: 'ngModel',
  providers: [UsersProvider$1]
});

var _templateObject$9 = _taggedTemplateLiteral(['^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\n    \\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]\n    {1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'], ['^(([^<>()\\\\[\\\\]\\\\\\.,;:\\\\s@"]+(\\\\.[^<>()\\\\[\\\\]\n    \\\\\\.,;:\\\\s@"]+)*)|(".+"))@((\\\\[[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]\n    {1,3}])|(([a-zA-Z\\\\-0-9]+\\\\.)+[a-zA-Z]{2,}))$']);

function isValidEmail(email) {
  // TODO: Check unit test as the regex has failed to catch no TLD domains.
  var re = new RegExp(oneLineTrim(_templateObject$9));
  return re.test(email);
}

function isValidUsernameFormat(username) {
  var re = /^[a-z][a-z0-9]{2,15}$/i;
  return re.test(username);
}

/**
 * @ngdoc directive
 * @name flEmailUsernameValidCheck
 * @restrict A
 * @description
 * Validates email pattern and is not equal to username
 */

var flEmailUsernameValidCheck = function () {
  function flEmailUsernameValidCheck(UserData) {
    _classCallCheck(this, flEmailUsernameValidCheck);

    this.user = UserData.user;
  }

  _createClass(flEmailUsernameValidCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      var field = attr.flEmailUsernameValidCheck;
      if (field === 'email') {
        ngModel.$validators.validEmail = isValidEmail;
      } else if (field === 'username') {
        ngModel.$validators.validUsername = isValidUsernameFormat;
        ngModel.$validators.uniqueFromPassword = function (username) {
          if (!username) {
            return true;
          }

          return username !== _this.user.password;
        };
      } else {
        ngModel.$validators.validEmailUsername = function (email) {
          if (!email) {
            return true;
          }
          return isValidEmail(email) || isValidUsernameFormat(email);
        };
      }
    }
  }]);

  return flEmailUsernameValidCheck;
}();

flEmailUsernameValidCheck.$inject = ['UserData'];

var flEmailUsernameValidCheck$1 = flDirective$1(flEmailUsernameValidCheck, {
  selector: '[fl-email-username-valid-check]',
  require: 'ngModel',
  providers: [UserData$1]
});

/**
 * @ngdoc directive
 * @name flPasswordCheck
 * @restrict A
 * @description
 * Validates password pattern and is not equal to username
 */

var PasswordCheck = function () {
  function PasswordCheck(UserData) {
    _classCallCheck(this, PasswordCheck);

    this.user = UserData.user;
  }

  _createClass(PasswordCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      ngModel.$validators.uniqueFromUsername = function (password) {
        if (!password) {
          return true;
        }
        return password !== _this.user.username;
      };

      ngModel.$validators.strongPassword = function (password) {
        if (!password) {
          return true;
        }
        var nums = password.match(/\d/g);
        var lowers = password.match(/[a-z]/g);
        var uppers = password.match(/[A-Z]/g);

        var pattern = /^.{6,}$/i;
        var pattern_result = pattern.test(password);

        if (pattern_result) {
          var strengthLevel = 0;
          if (nums) {
            strengthLevel += 2;
          }
          if (lowers) {
            strengthLevel += uppers ? 4 : 3;
          }
          if (uppers) {
            strengthLevel += lowers ? 4 : 3;
          }
          return strengthLevel > 4;
        }
        return false;
      };
    }
  }]);

  return PasswordCheck;
}();

PasswordCheck.$inject = ['UserData'];

var flPasswordCheck = flDirective$1(PasswordCheck, {
  selector: '[fl-password-check]',
  require: 'ngModel',
  providers: [UserData$1]
});

/**
 * @ngdoc directive
 * @name flUniqueEmailUsernameCheck
 * @restrict A
 * @description
 * Async Validator to check if email or username given already exists
 */

var UniqueEmailUsernameCheck = function () {
  function UniqueEmailUsernameCheck($q, $timeout, UsersService) {
    _classCallCheck(this, UniqueEmailUsernameCheck);

    this.$q = $q;
    this.$timeout = $timeout;
    this.UsersService = UsersService;
  }

  _createClass(UniqueEmailUsernameCheck, [{
    key: 'link',
    value: function link(scope, elm, attr, ngModel) {
      var _this = this;

      var field = attr.flUniqueEmailUsernameCheck;
      if (field === 'username') {
        ngModel.$asyncValidators.uniqueUsername = function (modelValue, username) {
          var deferred = _this.$q.defer();
          if (!username) {
            deferred.resolve();
          }
          _this.UsersService.checkUsernameExists(username).then(function (response) {
            _this.$timeout(function () {
              if (response === 'true') {
                deferred.resolve();
              } else {
                deferred.reject();
              }
            }, 500);
          });
          return deferred.promise;
        };
      } else {
        ngModel.$asyncValidators.uniqueEmail = function (modelValue, email) {
          var deferred = _this.$q.defer();
          if (!email) {
            deferred.resolve();
          }
          _this.UsersService.checkEmailExists(email).then(function (response) {
            _this.$timeout(function () {
              if (response === 'true') {
                deferred.resolve();
              } else {
                deferred.reject();
              }
            }, 500);
          });
          return deferred.promise;
        };
      }
    }
  }]);

  return UniqueEmailUsernameCheck;
}();

UniqueEmailUsernameCheck.$inject = ['$q', '$timeout', 'UsersService'];

var flUniqueEmailUsernameCheck = flDirective$1(UniqueEmailUsernameCheck, {
  selector: '[fl-unique-email-username-check]',
  require: 'ngModel',
  providers: [UsersProvider$1]
});

var CorporateService = function () {
  function CorporateService($http, $log, Auth) {
    _classCallCheck(this, CorporateService);

    this.$http = $http;
    this.$log = $log;
    this.Auth = Auth;
    this.newAuthUrl = '/auth'; // TODO: Replace this to use config
    this.CORPORATE_COOKIE_KEY = 'CORPORATE_ID';
  }

  _createClass(CorporateService, [{
    key: 'checkCorporate',
    value: function checkCorporate() {
      if (getCookie(this.CORPORATE_COOKIE_KEY) !== '') {
        return true;
      }
      return false;
    }
  }, {
    key: 'serializeData',
    value: function serializeData(obj) {
      var result = [];

      Object.keys(obj).forEach(function (key) {
        result.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
      });
      return result.join('&');
    }
  }, {
    key: 'swapAccount',
    value: function swapAccount(rememberLogin) {
      var _this = this;

      var user = this.Auth.getUserId();
      var token = this.Auth.getAccessToken();
      var otherUser = getCookie(this.CORPORATE_COOKIE_KEY);
      var headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      };
      var data = {
        user: user,
        token: token,
        other_user: otherUser
      };
      if (user != otherUser) {
        return this.$http({
          method: 'POST',
          url: this.newAuthUrl + '/switch_account/',
          headers: headers,
          data: this.serializeData(data)
        }).then(function (response) {
          if (response.status !== 200) {
            return;
          }
          if (response.data && response.data.token) {
            // Successfully login
            _this.Auth.reset();
            _this.Auth.set(response.data.token, response.data.user, rememberLogin);
            return response;
          }
        }).catch(function (response) {
          _this.trackError('SwitchCorporateUserLogin', response.data.error_code);
          // Auth HTTP Interceptor will log the user out if a response status is 401.
          // Add the Auth Cookie for the current user if this happens.
          _this.Auth.reset();
          _this.Auth.set(token, user, rememberLogin);
          return response;
        });
      }
      return Promise.resolve();
    }
  }, {
    key: 'trackError',
    value: function trackError(label, e) {
      qtsp.push({
        section: 'newAuth2FA',
        subsection: 'corporateService',
        label: label,
        action: 'error',
        value: JSON.stringify(e)
      });
    }
  }]);

  return CorporateService;
}();

CorporateService.$inject = ['$http', '$log', 'Auth'];

var CorporateProvider = flService$1('CorporateService', [AuthModule], CorporateService);

/**
 * @ngdoc directive
 * @name flUtils.directive:flIcon
 * @element A
 * @function
 *
 * @description
 * Our own md-icon.
 *
 * @example
  ```
    <fl-icon name="icon-name"></fl-icon>
  ```
 */
var OPAQUE_MODULE_NAME$2 = 'flAngular.flIcon';

var flIconProvider = angular.module(OPAQUE_MODULE_NAME$2, []).directive('flIcon', ['$sce', '$window', function ($sce, $window) {
  return {
    templateUrl: function templateUrl(elem, attrs) {
      return $sce.trustAsResourceUrl($window.SystemJS.normalizeSync('icons/' + attrs.name + '.svg'));
    },
    link: function link(scope, element, attrs) {
      if (attrs.class) {
        element.find('svg').addClass(attrs.class);
        element.removeAttr('class');
      }
    }
  };
}]).name; // exports the opaque token

var template = "<div class=\"Modal\" ng-class=\"UiModal.modalProps.classes\">\n  <div class=\"Modal-inner\" outbounds=\"true\">\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <fl-compiled bind-html-compile=\"{[{UiModal.bodyTemplate}]}\"></fl-compiled>\n      </div>\n      <fl-compiled ng-if=\"UiModal.shadowFooterTemplate\" bind-html-compile=\"{[{UiModal.shadowFooterTemplate}]}\"></fl-compiled>\n    </div>\n  </div>\n  <div class=\"Modal-overlay\" tabindex=\"-1\"></div>\n</div>\n";

var Compiled = function () {
  function Compiled($scope, $element, $attrs, $compile) {
    _classCallCheck(this, Compiled);

    this.$compile = $compile;
    this.scope = $scope;
    this.element = $element;
    this.attrs = $attrs;
  }

  _createClass(Compiled, [{
    key: '$postLink',
    value: function $postLink() {
      var _this = this;

      this.scope.$watch(function () {
        return _this.attrs.bindHtmlCompile;
      }, function (value) {
        _this.element.html(value && value.toString());
        var compileScope = _this.scope.$parent;
        _this.$compile(_this.element.contents())(compileScope);
      });
    }
  }]);

  return Compiled;
}();

Compiled.$inject = ['$scope', '$element', '$attrs', '$compile'];

var flCompiled = flComponent$1(Compiled, {
  selector: 'fl-compiled'
});

var Modal = function () {
  function Modal($scope, $element, $document) {
    var _this = this;

    _classCallCheck(this, Modal);

    this.scope = $scope;
    if ($element.length) {
      this.element = $element[0];
    } else {
      this.element = $element;
    }
    if ($document.length) {
      this.body = $document[0].body;
    } else {
      this.body = $document.body;
    }
    this.bodyTemplate = '<' + this.modalSelector + ' ' + 'modal-props="UiModal.modalProps" ' + 'modal-visible="UiModal.modalVisible">' + ('</' + this.modalSelector + '>');

    this.shadowFooterTemplate = this.modalShadowFooterSelector ? '<' + this.modalShadowFooterSelector + ' ' + 'modal-props="UiModal.modalProps" ' + 'modal-visible="UiModal.modalVisible">' + ('</' + this.modalShadowFooterSelector + '>') : null;

    this.element.addEventListener('click', function (event) {
      if (event.target.hasAttribute('outbounds')) {
        _this.backdropClicked();
      }
    });

    document.addEventListener('keydown', function (event) {
      // keydown on Esc key
      if (event.which === 27) {
        event.preventDefault();
        _this.backdropClicked();
      }
    });
  }

  _createClass(Modal, [{
    key: '$postLink',
    value: function $postLink() {
      this.body.appendChild(this.element);
    }
  }, {
    key: 'backdropClicked',
    value: function backdropClicked() {
      if (typeof this.modalProps.onBackdropClick === 'function') {
        this.modalProps.onBackdropClick();
      }
      if (!this.modalProps.disableBackdropClose) {
        this.modalVisible = false;
        this.scope.$apply();
      }
    }
  }]);

  return Modal;
}();

Modal.$inject = ['$scope', '$element', '$document'];

var flUiModalProvider = flComponent$1(Modal, {
  selector: 'fl-ui-modal',
  template: template,
  bindings: {
    modalSelector: '=',
    modalShadowFooterSelector: '=',
    modalVisible: '=',
    modalProps: '='
  },
  providers: [flCompiled]
});

// Compute the CRC32 of a string
var table = '00000000 77073096 EE0E612C 990951BA 076DC419\n  706AF48F E963A535 9E6495A3 0EDB8832 79DCB8A4 E0D5E91E 97D2D988 09B64C2B\n  7EB17CBD E7B82D07 90BF1D91 1DB71064 6AB020F2 F3B97148 84BE41DE 1ADAD47D\n  6DDDE4EB F4D4B551 83D385C7 136C9856 646BA8C0 FD62F97A 8A65C9EC 14015C4F\n  63066CD9 FA0F3D63 8D080DF5 3B6E20C8 4C69105E D56041E4 A2677172 3C03E4D1\n  4B04D447 D20D85FD A50AB56B 35B5A8FA 42B2986C DBBBC9D6 ACBCF940 32D86CE3\n  45DF5C75 DCD60DCF ABD13D59 26D930AC 51DE003A C8D75180 BFD06116 21B4F4B5\n  56B3C423 CFBA9599 B8BDA50F 2802B89E 5F058808 C60CD9B2 B10BE924 2F6F7C87\n  58684C11 C1611DAB B6662D3D 76DC4190 01DB7106 98D220BC EFD5102A 71B18589\n  06B6B51F 9FBFE4A5 E8B8D433 7807C9A2 0F00F934 9609A88E E10E9818 7F6A0DBB\n  086D3D2D 91646C97 E6635C01 6B6B51F4 1C6C6162 856530D8 F262004E 6C0695ED\n  1B01A57B 8208F4C1 F50FC457 65B0D9C6 12B7E950 8BBEB8EA FCB9887C 62DD1DDF\n  15DA2D49 8CD37CF3 FBD44C65 4DB26158 3AB551CE A3BC0074 D4BB30E2 4ADFA541\n  3DD895D7 A4D1C46D D3D6F4FB 4369E96A 346ED9FC AD678846 DA60B8D0 44042D73\n  33031DE5 AA0A4C5F DD0D7CC9 5005713C 270241AA BE0B1010 C90C2086 5768B525\n  206F85B3 B966D409 CE61E49F 5EDEF90E 29D9C998 B0D09822 C7D7A8B4 59B33D17\n  2EB40D81 B7BD5C3B C0BA6CAD EDB88320 9ABFB3B6 03B6E20C 74B1D29A EAD54739\n  9DD277AF 04DB2615 73DC1683 E3630B12 94643B84 0D6D6A3E 7A6A5AA8 E40ECF0B\n  9309FF9D 0A00AE27 7D079EB1 F00F9344 8708A3D2 1E01F268 6906C2FE F762575D\n  806567CB 196C3671 6E6B06E7 FED41B76 89D32BE0 10DA7A5A 67DD4ACC F9B9DF6F\n  8EBEEFF9 17B7BE43 60B08ED5 D6D6A3E8 A1D1937E 38D8C2C4 4FDFF252 D1BB67F1\n  A6BC5767 3FB506DD 48B2364B D80D2BDA AF0A1B4C 36034AF6 41047A60 DF60EFC3\n  A867DF55 316E8EEF 4669BE79 CB61B38C BC66831A 256FD2A0 5268E236 CC0C7795\n  BB0B4703 220216B9 5505262F C5BA3BBE B2BD0B28 2BB45A92 5CB36A04 C2D7FFA7\n  B5D0CF31 2CD99E8B 5BDEAE1D 9B64C2B0 EC63F226 756AA39C 026D930A 9C0906A9\n  EB0E363F 72076785 05005713 95BF4A82 E2B87A14 7BB12BAE 0CB61B38 92D28E9B\n  E5D5BE0D 7CDCEFB7 0BDBDF21 86D3D2D4 F1D4E242 68DDB3F8 1FDA836E 81BE16CD\n  F6B9265B 6FB077E1 18B74777 88085AE6 FF0F6A70 66063BCA 11010B5C 8F659EFF\n  F862AE69 616BFFD3 166CCF45 A00AE278 D70DD2EE 4E048354 3903B3C2 A7672661\n  D06016F7 4969474D 3E6E77DB AED16A4A D9D65ADC 40DF0B66 37D83BF0 A9BCAE53\n  DEBB9EC5 47B2CF7F 30B5FFE9 BDBDF21C CABAC28A 53B39330 24B4A3A6 BAD03605\n  CDD70693 54DE5729 23D967BF B3667A2E C4614AB8 5D681B02 2A6F2B94 B40BBE37\n  C30C8EA1 5A05DF1B 2D02EF8D';

/* Number */
function crc32$1( /* String */str, /* Number */crc) {
  if (crc == undefined) crc = 0;
  var n = 0; // a number between 0 and 255
  var x = 0; // an hex number

  crc ^= -1;
  for (var i = 0, iTop = str.length; i < iTop; i++) {
    n = (crc ^ str.charCodeAt(i)) & 0xff;
    x = '0x' + table.substr(n * 9, 8);
    crc = crc >>> 8 ^ x;
  }
  return crc ^ -1;
}

function cdn_url(url, protocol) {
  // forcing https this way for backwards compat
  protocol = 'https://';

  var host = cdnUrls[Math.abs(crc32$1(url)) % cdnUrls.length];
  return protocol + host + url;
}

/**
 * - disableRedirect option will disable redirects & reloads, but not force
 *   redirects in on login. Note it will also cancel default redirects into
 *   the usual signup funnel.
 * - Best not to directly edit varaibles showSignup and visible, but to use the
 *   appropriate function calls.
 */
var DEFAULT_OPTIONS = {
  showAsModal: true,
  hideFb: false,
  showSignupOption: true,
  showLoginOption: true,
  showAppLinks: true,
  pageName: '',
  signupTitle: '',
  loginTitle: '',
  signupSuccessMessage: '',
  loginSuccessMessage: '',
  forcedAccountType: '',
  redirectUrl: '',
  disableRedirect: false,
  disableBackdropClose: false,
  visible: false,
  showSignup: false,
  projectCollaborationInvitation: '',
  contestCollaborationInvitation: '',
  old2FAToken: ''
};

/**
 * @ngdoc service
 * @name loginSignupApp.LoginSignupConfig
 *
 * @description
 * Customisable Login Signup Config.
 * Acts as an angularjs service which can be accessed by legacy code
 *
 * Usage:
 */

var LoginSignupConfig = function () {
  function LoginSignupConfig($rootScope, UserData) {
    var _this = this;

    _classCallCheck(this, LoginSignupConfig);

    this.$rootScope = $rootScope;
    this.UserData = UserData;

    // Auth Messages returned in onAuthPromise, on signup and login
    this.authMessages = {
      SIGNUP_EMPLOYER: 'signup_success_employer',
      SIGNUP_FREELANCER: 'signup_success_freelancer',
      LOGIN_SUCCESS: 'login_success',
      CLOSE_MODAL: 'close_modal'
    };

    // Customisable options: Can be changed on the fly. For example each time
    // you show the Login/Signup Modal.
    this.options = Object.assign({}, DEFAULT_OPTIONS);

    this.$rootScope.$watch(function () {
      return _this.options.visible;
    }, function (newValue) {
      // If Login/Signup has been hidden, reject the auth promise
      if (newValue === false && typeof _this.rejectAuth === 'function') {
        _this.rejectAuth(_this.authMessages.CLOSE_MODAL);
      }
    });
  }

  /**
   * @ngdoc method
   * @name loginSignupApp.LoginSignupConfig#showSignup
   * @param {object} customOptions Custom modal options. (optional)
   * @description
   * Show the signup angular modal.
   * This can be called from within angular code and legacy code.
   */

  _createClass(LoginSignupConfig, [{
    key: 'showSignup',
    value: function showSignup(customOptions) {
      var _this2 = this;

      this.$rootScope.$evalAsync(function () {
        _this2.options = Object.assign({}, _this2.options, customOptions);
        _this2.options.visible = true;
        _this2.options.showSignup = true;
      });

      return new Promise(function (resolve, reject) {
        _this2.resolveAuth = resolve;
        _this2.rejectAuth = reject;
      });
    }

    /**
     * @ngdoc method
     * @name loginSignupApp.LoginSignupConfig#showLogin
     * @param {object} customOptions Custom modal options. (optional)
     * @description
     * Show the login angular modal.
     * This can be called from within angular code and legacy code.
     */

  }, {
    key: 'showLogin',
    value: function showLogin(customOptions) {
      var _this3 = this;

      this.$rootScope.$evalAsync(function () {
        _this3.options = Object.assign({}, _this3.options, customOptions);

        _this3.options.visible = true;
        _this3.options.showSignup = false;
      });

      return new Promise(function (resolve, reject) {
        _this3.resolveAuth = resolve;
        _this3.rejectAuth = reject;
      });
    }
  }, {
    key: 'switchToSignup',
    value: function switchToSignup() {
      this.options.showSignup = true;
      // reset the username value
      this.UserData.user.username = '';
      // if username is valid email, move to email input on Signup Form.
      if (this.UserData.user.username && isValidEmail(this.UserData.user.username)) {
        this.UserData.user.email = this.UserData.user.username;
      }
    }
  }, {
    key: 'switchToLogin',
    value: function switchToLogin() {
      this.options.showSignup = false;
      if (this.UserData.user.email) {
        this.UserData.user.username = this.UserData.user.email;
      }
    }
  }, {
    key: 'hide',
    value: function hide() {
      var _this4 = this;

      this.$rootScope.$evalAsync(function () {
        _this4.options.visible = false;
      });
    }
  }, {
    key: 'isModal',
    value: function isModal() {
      return this.options.showAsModal;
    }
  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.options.visible;
    }
  }, {
    key: 'isDisableBackdropClose',
    value: function isDisableBackdropClose() {
      return this.options.disableBackdropClose;
    }
  }, {
    key: 'showSignupOption',
    value: function showSignupOption() {
      return this.options.showSignupOption;
    }
  }, {
    key: 'showLoginOption',
    value: function showLoginOption() {
      return this.options.showLoginOption;
    }
  }, {
    key: 'showAppLinks',
    value: function showAppLinks() {
      return this.options.showAppLinks;
    }
  }, {
    key: 'getPageName',
    value: function getPageName() {
      return this.options.pageName;
    }
  }, {
    key: 'getSignupTitle',
    value: function getSignupTitle() {
      return this.options.signupTitle;
    }
  }, {
    key: 'getLoginTitle',
    value: function getLoginTitle() {
      return this.options.loginTitle;
    }
  }, {
    key: 'getSignupSuccessMessage',
    value: function getSignupSuccessMessage() {
      return this.options.signupSuccessMessage;
    }
  }, {
    key: 'getLoginSuccessMessage',
    value: function getLoginSuccessMessage() {
      return this.options.loginSuccessMessage;
    }
  }, {
    key: 'getRedirectUrl',
    value: function getRedirectUrl() {
      return this.options.redirectUrl;
    }
  }, {
    key: 'getForcedAccountType',
    value: function getForcedAccountType() {
      return this.options.forcedAccountType;
    }
  }, {
    key: 'isHideFb',
    value: function isHideFb() {
      return this.options.hideFb;
    }
  }, {
    key: 'getSkipCaptchaHash',
    value: function getSkipCaptchaHash() {
      return this.options.skipCaptchaHash;
    }
  }, {
    key: 'isRedirectDisabled',
    value: function isRedirectDisabled() {
      return this.options.disableRedirect;
    }
  }, {
    key: 'getEmailPrefill',
    value: function getEmailPrefill() {
      return this.options.emailPrefill;
    }
  }, {
    key: 'getProjectCollaborationInvitation',
    value: function getProjectCollaborationInvitation() {
      return this.options.projectCollaborationInvitation;
    }
  }, {
    key: 'getContestCollaborationInvitation',
    value: function getContestCollaborationInvitation() {
      return this.options.contestCollaborationInvitation;
    }
  }, {
    key: 'getOld2FAToken',
    value: function getOld2FAToken() {
      return this.options.old2FAToken;
    }
  }]);

  return LoginSignupConfig;
}();

LoginSignupConfig.$inject = ['$rootScope', 'UserData'];

var LoginSignupConfigProvider = flService$1('LoginSignupConfig', [UserData$1], LoginSignupConfig);

var APP_LINKS = flConstant$1('APP_LINKS', {
  appStoreLink: 'https://bnc.lt/Ed5l/nPQu9RdcWr',
  playStoreLink: 'https://bnc.lt/Ed5l/nPQu9RdcWr'
});

var linkTemplate = "<div class=\"ModalLoginSignup-appLinks\">\n  <a id='appStore' href=\"{{AppLinks.appStoreUrl}}\" class=\"app-store-link\" target=\"_blank\"\n    title=\"Download from the iTunes store\"\n    ng-click=\"AppLinks.trackAppStoreClick()\">\n    <img ng-src=\"{{AppLinks.cdn_url('/static/img/appstoreicons/apple-app-store-badge.png')}}\" height=\"100%\" />\n  </a>\n  <a id='playStore' href=\"{{AppLinks.playStoreUrl}}\" class=\"app-store-link\" target=\"_blank\"\n    title=\"Download from Google play\"\n    ng-click=\"AppLinks.trackPlayStoreClick()\">\n    <img ng-src=\"{{AppLinks.cdn_url('/static/img/appstoreicons/google-play-store-badge.png')}}\" height=\"100%\" />\n  </a>\n</div>\n";

var flAppLinks = function () {
  function flAppLinks(APP_LINKS$$1, LoginSignupConfig) {
    _classCallCheck(this, flAppLinks);

    this.appStoreUrl = APP_LINKS$$1.appStoreLink;
    this.playStoreUrl = APP_LINKS$$1.playStoreLink;
    this.cdn_url = cdn_url;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flAppLinks, [{
    key: 'trackPlayStoreClick',
    value: function trackPlayStoreClick() {
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'DownloadPlayStore',
        action: 'click'
      });
    }
  }, {
    key: 'trackAppStoreClick',
    value: function trackAppStoreClick() {
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'DownloadAppStore',
        action: 'click'
      });
    }
  }]);

  return flAppLinks;
}();

flAppLinks.$inject = ['APP_LINKS', 'LoginSignupConfig'];

var flAppLinks$1 = flComponent$1(flAppLinks, {
  selector: 'fl-app-links',
  template: linkTemplate,
  providers: [APP_LINKS, LoginSignupConfigProvider]
});

/**
* @ngdoc directive
* @name flUi.directive:flFocusOn
* @element input
* @function
*
* @description
* Focus an element when the attached expression is true
*
* @usage
* <!-- This input will gain focus when focus evaluates to true -->
* <input type="text" fl-focus-on="focus">
* </input>
*
* @example
*  <example module="flUi">
*    <file name="index.html">
*      <div ng-controller="myController">
*        <input type="text" fl-focus-on="result.willBeTrue"
*          ng-model="confirmation">
*        </input>
*        <a ng-click="startInterval()" class="btn btn-primary" href="">
*          Run example again
*        </a>
*      </div>
*    </file>
*    <file name="index.js">
*        angular.module('flUi', []).controller('myController',
*        ($scope, $interval) => {
*          // Here we store our $interval so we can cancel it (stop it) later
*          let interval;
*          // Initialize this to false. As soon as it turns to true,
*          // our input element will gain focus.
*          $scope.result = {
*            willBeTrue: false
*          };
*          // The value of this var will appear in the text input
*          //after 5 secs
*          $scope.confirmation = null;
*
*          // Make expression evaluate to true after 3 seconds
*          $scope.startInterval = () => {
*            $scope.result.willBeTrue = false;
*            $scope.confirmation = 5;
*
*            interval = $interval(() => {
*              $scope.confirmation--;
*
*              if($scope.confirmation === 0) {
*                $scope.confirmation = "I should have focus now...";
*                $scope.result.willBeTrue = true;
*                $interval.cancel(interval);
*              };
*            }, 1000);
*          };
*
*          $scope.startInterval();
*        })
*    </file>
*  </example>
*/

var flFocusOn = function () {
  function flFocusOn() {
    _classCallCheck(this, flFocusOn);
  }

  _createClass(flFocusOn, [{
    key: 'link',
    value: function link(scope, element, attrs) {
      scope.$watch(attrs.flFocusOn, function (doFocus) {
        if (doFocus) {
          element[0].focus();
        }
      });
    }
  }]);

  return flFocusOn;
}();

var flFocusOnProvider = flDirective(flFocusOn, {
  selector: '[fl-focus-on]'
});

/**
* @ngdoc service
* @name flFacebook.FacebookSDK
*
* @description
* Angular wrapper around the Facebook API, providing access to all the
* Facebook JS SDK APIs within the Angular context & returning Promises instead
* of callbacks. This service is currently implemented using "ezfb". Please
* prefer the use of the higher level Facebook service over that one.
*/

var FacebookSDK = function FacebookSDK(ezfb) {
  _classCallCheck(this, FacebookSDK);

  return ezfb;
};

FacebookSDK.$inject = ['ezfb'];

var FacebookSDKModule = flService('FacebookSDK', ['ezfb', OPAQUE_MODULE_NAME], FacebookSDK);

angular.module(FacebookSDKModule).config(['ezfbProvider', 'FACEBOOK_APP_ID', function (ezfbProvider, FACEBOOK_APP_ID) {
  ezfbProvider.setInitParams({
    appId: FACEBOOK_APP_ID,
    xfbml: false,
    version: 'v2.8'
  });
}]);

var _templateObject$10 = _taggedTemplateLiteral(['\n        ', '://\n        ', '\n        ', '\n        ', '', ''], ['\n        ', '://\n        ', '\n        ', '\n        ', '', '']),
    _templateObject2$4 = _taggedTemplateLiteral(['\n        https://www.facebook.com/dialog/oauth?client_id=\n        ', '\n        &redirect_uri=', '\n        &scope=', ''], ['\n        https://www.facebook.com/dialog/oauth?client_id=\n        ', '\n        &redirect_uri=', '\n        &scope=', '']);

/**
  * @ngdoc service
  * @name flFacebook.Facebook
  *
  * @description
  * Provides high level Facebook functionality. Your controllers should prefer
  * using this service instead of Facebook SDK as it abstracts Facebook SDK's
  * internal complexity.
  */

var FacebookProvider = function () {
  function FacebookProvider($q, $window, $location, FacebookSDK, FACEBOOK_APP_ID) {
    _classCallCheck(this, FacebookProvider);

    this.$q = $q;
    this.$window = $window;
    this.$location = $location;
    this.FacebookSDK = FacebookSDK;
    this.FACEBOOK_APP_ID = FACEBOOK_APP_ID;
  }
  /**
  * @ngdoc method
  * @name flFacebook.Facebook#getLoginStatus
  * @methodOf flFacebook.Facebook
  *
  * @description
  * Check if the user is currently connected with Facebook.
  *
  * @returns {Object} a Promise object that will be resolved with an
  * AuthResponse object from the Facebook API. This object can then be
  * passed to the Auth Service's loginWithFacebook API to login the
  * user into Freelancer or the Users Service's createWithFacebook to
  * create a new user account. On failure, an error object with a "code"
  * key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' will be returned.
  */


  _createClass(FacebookProvider, [{
    key: 'checkConnected',
    value: function checkConnected() {
      var _this = this;

      return this.FacebookSDK.getLoginStatus().then(function (response) {
        // Ask user to login if they are not signed into facebook
        if (response.status === 'connected') {
          return _this.$q.when(response.authResponse);
        } else if (response.status === 'not_authorized') {
          return _this.$q.reject({ code: 'NOT_AUTHORISED' });
        }

        return _this.$q.reject({ code: 'NOT_CONNECTED' });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#login
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Prompt the user, if required, to login to his Facebook account &
    * authorize Freelancer to access his profile.
    *
    * @param {Array} scope Array of permission strings. Calling this
    * function with new permissions will prompt the user to accept them.
    * These permissions will be added to the default ones (user_location,
    * user_website, email, user_birthday).
    *
    * @returns {Object} a Promise object that will be resolved with an
    * AuthResponse object from the Facebook API. This object can then be
    * passed to the Auth Service's loginWithFacebook API to login the
    * user into Freelancer or the Users Service's createWithFacebook to
    * create a new user account. On failure, an error object with a "code"
    * key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' will be returned.
    * WARNING: For Chrome on iOS (userAgent detected), the user would be
    * redirect to Facebook & redirected back to the current page with the
    * "facebook_redirect" appended to it. This is needed to fix
    * http://stackoverflow.com/questions/16843116/
    * facebook-oauth-unsupported-in-chrome-on-ios
    */

  }, {
    key: 'login',
    value: function login(permissions) {
      var _this2 = this;

      var s = ['email', 'public_profile'];
      var scope = s.concat(permissions);
      // The redirect method is needed to fix
      // http://stackoverflow.com/questions/16843116/
      // facebook-oauth-unsupported-in-chrome-on-ios
      // Also for the installable web app when launched specifically on iOS
      if (this.$window.navigator.userAgent.match('CriOS') || this.$window.navigator.standalone) {
        // Exclusive to iOS
        // Add the "facebook_redirect" search param to the current query
        // string to allow the app to identify the redirect
        var queryString = this.$window.location.search;
        // TODO: a proper URL lib would probably be nicer
        var redirectQueryString = queryString ? queryString + '&facebook_redirect' : '?facebook_redirect';
        var redirectUrl = oneLineTrim(_templateObject$10, this.$location.protocol(), this.$location.host(), this.$location.path(), redirectQueryString, this.$location.hash());
        // Do redirect the user.
        this.$window.location.href = oneLineTrim(_templateObject2$4, this.FACEBOOK_APP_ID, encodeURIComponent(redirectUrl), scope.join(','));
        // Do not return a state as user is going to be redirected
        return this.$q.defer().promise;
      }
      return this.FacebookSDK.login(null, {
        scope: scope.join(', ')
      }).then(function (response) {
        // Make sure the user has authorised Facebook
        if (response.status === 'connected') {
          return _this2.$q.when(response.authResponse);
        } else if (response.status === 'not_authorized') {
          return _this2.$q.reject({ code: 'NOT_AUTHORISED' });
        }
        return _this2.$q.reject({ code: 'NOT_CONNECTED' });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#getUser
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Get the Facebook Graph API user object of the currently connected
    * user, or an error object with a "code" key of 'NOT_AUTHORISED' or
    * 'NOT_CONNECTED' on error.
    *
    * @returns {Object} a Promise object that will be resolved with an
    * Faceook Graph API User Object. The exact fields of the user object
    * are determined by the requested permissions on login.
    */

  }, {
    key: 'getUser',
    value: function getUser() {
      var _this3 = this;

      var fields = ['first_name', 'email'];
      return this.checkConnected().then(function () {
        return _this3.FacebookSDK.api('/me', { fields: fields.join(', ') });
      });
    }
    /**
    * @ngdoc method
    * @name flFacebook.Facebook#getUserPictureUrl
    * @methodOf flFacebook.Facebook
    *
    * @description
    * Get the profile picture URL on the currently connected user, or an error
    * object with a "code" key of 'NOT_AUTHORISED' or 'NOT_CONNECTED' on error
    *
    * @param {int} height Request a profile picture with a specific height
    * @param {int} width Request a profile picture with a specific width
     * @returns {String} a Promise object that will be resolved with the URL
    * of the user's profile picture. The dimession of the picture are
    * determined by the height & width paramaters and default to Facebook
    * default size if unspecified.
    */

  }, {
    key: 'getUserPictureUrl',
    value: function getUserPictureUrl(height, width) {
      var _this4 = this;

      var params = height ? '&height=' + height : '';
      params += width ? '&width=' + width : '';
      return this.checkConnected().then(function () {
        return _this4.FacebookSDK.api('/me/picture?redirect=false' + params);
      }).then(function (response) {
        return response.data.url;
      });
    }
  }]);

  return FacebookProvider;
}();

FacebookProvider.$inject = ['$q', '$window', '$location', 'FacebookSDK', 'FACEBOOK_APP_ID'];


var FacebookProvider$1 = flService('Facebook', [FacebookSDKModule, OPAQUE_MODULE_NAME], FacebookProvider);

var template$1 = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\" ng-click=\"LoginForm.closeModal()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"LoginForm.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-logo\"></fl-icon>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Login\">\n    <div class=\"ModalLoginSignup-body-heading\">\n      <span ng-if=\"!LoginForm.loginSignupConfig.getLoginTitle()\">\n        Welcome Back\n      </span>\n      <span ng-if=\"LoginForm.loginSignupConfig.getLoginTitle()\">\n        {{LoginForm.loginSignupConfig.getLoginTitle()}}\n      </span>\n    </div>\n    <form class=\"user-login-form fl-form large-form responsive-form\">\n        <div ng-messages=\"LoginForm.fbError\">\n            <div ng-message=\"facebookNotAuthorized\" class=\"alert alert-error\">\n                Please authorize Freelancer to access your Facebook account in order to login with Facebook\n            </div>\n            <div ng-message=\"facebookNotConnected\" class=\"alert alert-error\">\n                Please connect with your Facebook account or login below\n            </div>\n            <div ng-message=\"facebookRateLimit\" class=\"alert alert-error\">\n              You are performing too many requests. Please try again later.\n            </div>\n            <div ng-message=\"facebookClosed\" class=\"alert alert-error\">\n              This account has been closed. Please contact <a href=\"/support\">support</a> for more assistance.\n            </div>\n            <div ng-message=\"facebookAccessDenied\" class=\"alert alert-error\">\n                There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.\n            </div>\n            <div ng-message=\"facebookUnknownError\" class=\"alert alert-error\">\n                Failed to connect with Facebook. Please try again.\n            </div>\n        </div>\n        <button ng-if=\"!LoginForm.loginSignupConfig.isHideFb()\"\n            ng-click=\"LoginForm.fbLogin()\"\n            class=\"btn-facebook btn btn-large ModalLoginSignup-facebook-connect\"\n            data-uitest-target=\"facebook-login-button\"\n            fl-analytics=\"FBLogin\">\n            <fl-icon name=\"flicon-facebook\"></fl-icon>Login with Facebook\n        </button>\n    </form>\n    <div class=\"hr-divider\" ng-if=\"!LoginForm.loginSignupConfig.isHideFb()\"><span class=\"hr-divider-text\">OR</span></div>\n    <form name=\"LoginForm.form\" class=\"user-login-form fl-form large-form responsive-form\">\n        <aside ng-class=\"{'is-hidden': !LoginForm.showErrorMessage}\"\n            class=\"alert alert-error\">\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'ExceptionCodes.MISSING_USER'\">Incorrect username or password provided.</span>\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'Closed'\">This account has been closed. Please contact <a href=\"/support\">support</a> for more assistance.</span>\n            <span ng-if=\"LoginForm.errorStatus === 401 && LoginForm.errorCode === 'ExceptionCodes.BLOCKED_TWO_FACTOR'\">\n                We have detected your log in from a new device. Please check your email to continue.\n            </span>\n            <span ng-if=\"(\n                    LoginForm.errorStatus === 401\n                    && LoginForm.errorCode !== 'ExceptionCodes.MISSING_USER'\n                    && LoginForm.errorCode !== 'Closed'\n                    && LoginForm.errorCode !== 'ExceptionCodes.BLOCKED_TWO_FACTOR'\n                )\n                || LoginForm.errorStatus === 500\">\n                There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.<br/>Request ID: {{LoginForm.requestId}}\n            </span>\n            <span ng-if=\"LoginForm.errorStatus === 429\">You are performing too many requests. Please try again later.</span>\n        </aside>\n        <div ng-if=\"LoginForm.loginSuccess\"\n          class=\"form-feedback-success login-success alert alert-success\">\n          Login Success!\n          <div class=\"Loader Loader--small\"></div>\n        </div>\n        <fieldset>\n            <ol>\n                <li ng-class=\"{'is-invalid': LoginForm.form.username.$invalid && LoginForm.form.username.$dirty}\"\n                    class=\"form-step username-step\">\n                    <label for=\"username\" class=\"is-accessibly-hidden\">Username</label>\n                    <input id=\"username\" name=\"username\" type=\"text\"\n                      placeholder=\"Email or Username\" maxlength=\"150\" class=\"large-input\"\n                      ng-model=\"LoginForm.UserData.user.username\"\n                      ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n                      ng-required=\"true\"\n                      ng-change=\"LoginForm.hideErrorMessage()\"\n                      fl-email-username-valid-check\n                      fl-focus-on=\"LoginForm.focusEmailInput\" />\n                    <div ng-messages=\"LoginForm.form.username.$error\" tabindex=\"-1\">\n                        <div class=\"form-error\" ng-message=\"required\">\n                            Please enter your username or email address.\n                        </div>\n                        <div class=\"form-error\" ng-message=\"validEmailUsername\">\n                            Please enter a valid username or email address.\n                        </div>\n                    </div>\n                </li>\n                <li ng-class=\"{'is-invalid': LoginForm.form.password.$invalid && LoginForm.form.password.$dirty}\"\n                  class=\"form-step password-step\">\n                    <label for=\"password\" class=\"is-accessibly-hidden\">Password</label>\n                    <input id=\"password\" name=\"password\" type=\"password\"\n                      placeholder=\"Password\" maxlength=\"150\" class=\"large-input\"\n                      ng-model=\"LoginForm.UserData.user.password\"\n                      ng-required=\"true\"/>\n                    <div ng-messages=\"LoginForm.form.password.$error\" tabindex=\"-1\">\n                        <div class=\"form-error\" ng-message=\"required\">\n                            Please enter your password.\n                        </div>\n                    </div>\n                </li>\n                <li class=\"form-step has-label login-form-options\">\n                    <a ng-click=\"LoginForm.showResetPasswordForm()\" class=\"login-form-forgot forgot-password\" fl-analytics=\"ForgotPassword\">\n                        Forgot Password?\n                    </a>\n                    <div class=\"Checkbox\">\n                        <input ng-model=\"LoginForm.rememberLogin\" id=\"loginpermanent\" class=\"Checkbox-input\" type=\"checkbox\" name=\"remember\" />\n                        <label class=\"Checkbox-label checkbox\" for=\"loginpermanent\">\n                            Remember me\n                        </label>\n                    </div>\n                </li>\n                <li class=\"form-step\">\n                    <button ng-click=\"LoginForm.login($event)\"\n                        id=\"login_btn\"\n                        ng-disabled=\"LoginForm.isSubmitting\"\n                        type=\"submit\"\n                        class=\"btn btn-info btn-large btn-submit ModalLoginSignup-loginForm-submitBtn\"\n                        fl-analytics=\"NormalLogin\">\n                        Log In\n                    </button>\n                </li>\n            </ol>\n        </fieldset>\n    </form>\n    <span class=\"ModalLoginSignup-switchLoginSignupType\" ng-if=\"LoginForm.loginSignupConfig.showSignupOption()\">\n        Don't have an account?\n        <a ng-click=\"LoginForm.goToSignup($event)\" fl-analytics=\"SignupLink\">Sign Up</a>\n    </span>\n</div>\n";

var flLoginForm = function () {
  function flLoginForm($window, $timeout, $rootScope, UsersService, Users, UserData, Facebook, Analytics, Auth, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flLoginForm);

    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.UsersService = UsersService;
    this.Users = Users;
    this.UserData = UserData;
    this.Analytics = Analytics;
    this.Facebook = Facebook;
    this.Auth = Auth;
    this.UsersService.getDeviceToken(this.UserData.user);
    this.isSubmitting = false;
    this.showErrorMessage = false;
    this.rememberLogin = false;
    this.loginSuccess = false;
    this.form = {};
    this.fbError = {};

    this.loginSignupConfig = LoginSignupConfig;

    this.watchShowSignup = $rootScope.$watch(function () {
      return _this.loginSignupConfig.options.showSignup;
    }, function (newValue) {
      // If Show Signup was set to false (on login), try auto connect facebook
      if (newValue === false && _this.UserData.isFacebookConnected()) {
        _this.fbLogin(true);
      }
    });

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flLoginForm, [{
    key: 'login',
    value: function login(event) {
      var _this2 = this;

      event.preventDefault();
      this.showErrorMessage = false;

      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });

      if (!this.form.$valid || this.isSubmitting || this.loginSuccess) {
        return;
      }

      this.isSubmitting = true;
      this.fbError = {};
      return this.UsersService.login(this.UserData.user, this.rememberLogin, this.loginSignupConfig.getOld2FAToken()).then(function (response) {
        if (response.data && response.data.pre_login_token) {
          _this2.onNeedTotp({
            twoFAMethod: _this2.retrieveTwoFAMethod(response.data.pre_login_token)
          });
          return;
        } else if (response.data && response.data.token) {
          _this2.loginSuccess = true;
          _this2.$window.requestAnimationFrame(function () {
            _this2.onLoginSuccess({
              rememberLogin: _this2.rememberLogin
            });
          });
          return;
        }
        _this2.isSubmitting = false;
      }).catch(function (response) {
        if (response.data && response.data.error_code === 'Suspended') {
          _this2.$window.requestAnimationFrame(function () {
            _this2.onLoginSuccess({
              rememberLogin: _this2.rememberLogin,
              forceRedirectUrl: '/users/usersuspended.php'
            });
          });
        }
        _this2.showErrorMessage = true;
        _this2.errorStatus = response.status;
        _this2.errorCode = response.data.error_code;
        _this2.requestId = response.data.request_id;
        _this2.errorMessage = response.data.message;
        _this2.isSubmitting = false;
      });
    }
  }, {
    key: 'retrieveTwoFAMethod',
    value: function retrieveTwoFAMethod(preLoginToken) {
      var token = preLoginToken.split('.');
      var twoFATokenDecoded = atob(token[1]);
      return JSON.parse(twoFATokenDecoded)['2fa_methods'][0];
    }

    /**
     * Login through Facebook.
     * Automatically Triggers FB Link or Switch to Signup on new account.
     */

  }, {
    key: 'fbLogin',
    value: function fbLogin(skipLogin) {
      var _this3 = this;

      if (this.loginSuccess || this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      this.showErrorMessage = false;
      this.fbError = {};
      var facebookAuthParams = void 0;
      var authParamsPromise = void 0;
      // 1. Get Facebook auth params
      // If we come from Facebook signup, we need to skip the login
      // step overwise the popup will be blocked!
      if (!skipLogin) {
        authParamsPromise = this.Facebook.login();
      } else {
        authParamsPromise = this.Facebook.checkConnected();
      }

      // 2. Log into the Freelancer account
      return authParamsPromise.then(function (authParams) {
        facebookAuthParams = authParams;
        _this3.UserData.user.facebookAccessToken = authParams.accessToken;
        _this3.UserData.user.facebookSignedRequest = authParams.signedRequest;

        return _this3.UsersService.loginWithFacebook(_this3.UserData.user)
        // 3. Redirect the user
        .then(function (response) {
          if (response.data) {
            _this3.loginSuccess = true;
            _this3.Analytics.trackAction('facebook', 'login', 'SUCCESS');
            _this3.$window.requestAnimationFrame(function () {
              _this3.onLoginSuccess({
                rememberLogin: false
              });
            });
            return;
          }
          _this3.isSubmitting = false;
        }).catch(function (error) {
          // Get Error Contents
          var errorStatus = error.status;
          error = error.data || null;

          // No Error Data
          if (!error) {
            _this3.Analytics.trackError('facebook', 'login', errorStatus, 'EmptyError');
            _this3.fbError.facebookUnknownError = true;
            _this3.isSubmitting = false;
            return;
          }

          if (error.error_code === 'FacebookEmailMatch') {
            // Facebook email matches an existing Freelancer's email.
            _this3.Analytics.trackAction('facebook', 'login', error.error_code);
            _this3.fbLink(facebookAuthParams);
            return;
          } else if (error.error_code === 'ExceptionCodes.MISSING_USER') {
            // New User, Redirect to Signup
            _this3.Analytics.trackAction('facebook', 'login', error.error_code);
            _this3.fbRedirectToSignup();
            return;
          }

          _this3.isSubmitting = false;
          if (errorStatus === 429) {
            _this3.fbError.facebookRateLimit = true;
          } else if (error.error_code === 'Closed') {
            _this3.fbError.facebookClosed = true;
          } else if (errorStatus === 401) {
            _this3.fbError.facebookAccessDenied = true;
          } else {
            _this3.Analytics.trackError('facebook', 'login', error.error_code, error.message);
            _this3.fbError.facebookUnknownError = true;
          }
        });
      }).catch(function () {
        _this3.isSubmitting = false;
      });
    }

    /**
     * Get Facebook Details for current user then Redirect to /signup
     * Used from fbLogin()
     */

  }, {
    key: 'fbRedirectToSignup',
    value: function fbRedirectToSignup() {
      var _this4 = this;

      return this.Facebook.getUser().then(function (facebookUser) {
        _this4.UserData.setFacebookConnected(true);
        // Clear username and set Email
        _this4.UserData.username = '';
        _this4.UserData.user.email = facebookUser.email;
        // Set Facebook Data
        _this4.UserData.setFacebookEmail(facebookUser.email);
        _this4.UserData.setFacebookName(facebookUser.first_name);
        // Switch to Signup Form
        _this4.isSubmitting = false;
        _this4.showSignupForm();
      }).catch(function (error) {
        _this4.isSubmitting = false;
        if (error.code === 'NOT_AUTHORISED') {
          _this4.fbError.facebookNotAuthorized = true;
        } else if (error.code === 'NOT_CONNECTED') {
          _this4.fbError.facebookNotConnected = true;
        } else {
          _this4.Analytics.trackError('facebook', 'loginRedirectToSignup', error.code);
          _this4.fbError.facebookUnknownError = true;
        }
      });
    }

    /**
     * Links User to their Freelancer Account.
     * Used from fbLogin()
     */

  }, {
    key: 'fbLink',
    value: function fbLink(facebookAuthParams) {
      var _this5 = this;

      this.fbError = {};
      this.Facebook.getUser().then(function (facebookUser) {
        _this5.UserData.setFacebookConnected(true);
        _this5.UserData.setFacebookEmail(facebookUser.email);
        _this5.UserData.setFacebookName(facebookUser.first_name);
        _this5.UserData.user.facebookAccessToken = facebookAuthParams.accessToken;
        _this5.UserData.user.facebookSignedRequest = facebookAuthParams.signedRequest;

        // Try Get Profile Picture then Show Facebook Link Form
        _this5.Facebook.getUserPictureUrl(60, 60).then(function (pictureUrl) {
          _this5.UserData.setFacebookPictureUrl(pictureUrl);
        }).finally(function () {
          _this5.isSubmitting = false;
          _this5.showFacebookLinkForm();
        });
      }).catch(function (error) {
        _this5.isSubmitting = false;
        if (error.code === 'NOT_AUTHORISED') {
          _this5.Analytics.trackAction('facebook', 'link accounts', error.code);
          _this5.fbError.facebookNotAuthorized = true;
        } else if (error.code === 'NOT_CONNECTED') {
          _this5.Analytics.trackAction('facebook', 'link accounts', error.code);
          _this5.fbError.facebookNotConnected = true;
        } else {
          _this5.fbError.facebookUnknownError = error.code;
        }
      });
    }
  }, {
    key: 'goToSignup',
    value: function goToSignup($event) {
      $event.preventDefault();
      this.showSignupForm();
    }
  }, {
    key: 'hideErrorMessage',
    value: function hideErrorMessage() {
      this.showErrorMessage = false;
    }
  }]);

  return flLoginForm;
}();

flLoginForm.$inject = ['$window', '$timeout', '$rootScope', 'UsersService', 'Users', 'UserData', 'Facebook', 'Analytics', 'Auth', 'LoginSignupConfig'];

var flLoginForm$1 = flComponent$1(flLoginForm, {
  selector: 'fl-login-form',
  template: template$1,
  providers: [flIconProvider, flFocusOnProvider, flEmailUsernameValidCheck$1, UsersProvider$1, FacebookProvider$1, AnalyticsModule, AuthModule, UserData$1, UsersProvider, LoginSignupConfigProvider],
  bindings: {
    showSignupForm: '&',
    showResetPasswordForm: '&',
    showFacebookLinkForm: '&',
    onNeedTotp: '&',
    rememberLogin: '=',
    onLoginSuccess: '&',
    showAsModal: '=',
    closeModal: '&'
  }
});

var template$2 = "<div class=\"Modal-header\">\n    <div class=\"ModalLoginSignup-header-logo\">\n        <fl-icon name=\"fl-logo\"></fl-icon>\n    </div>\n</div>\n<div class=\"Modal-body ModalLoginSignup-body ModalLoginSignup-totp\">\n    <h4 class=\"ModalLoginSignup-body-heading\">2-Step Verification</h4>\n    <div class=\"ModalLoginSignup-totp-message\">\n        A verification code has been sent to you via\n        <span ng-switch=\"TotpForm.twoFaMethod\">\n            <span ng-switch-when=\"1\">Email.</span>\n            <span ng-switch-when=\"2\">SMS.</span>\n            <span ng-switch-when=\"3\">Generator App.</span>\n            <span ng-switch-when=\"4\">Freelancer App.</span>\n            <span ng-switch-default>Email, SMS or App.</span>\n        </span>\n        Please verify that 6 digit code below to continue.\n    </div>\n    <form class=\"user-login-form fl-form large-form responsive-form\">\n        <div ng-if=\"TotpForm.loginSuccess\"\n          class=\"form-feedback-success login-success alert alert-success\">\n          Login Success\n        </div>\n        <fieldset>\n            <ol>\n                <li class=\"form-step has-label login-form-options\">\n                    <a ng-click=\"TotpForm.login()\" class=\"login-form-forgot recover-login-switch-bt\">Resend code</a>\n                </li>\n                <aside ng-class=\"{'is-hidden': !TotpForm.showResendSuccessMessage}\"\n                    class=\"alert alert-info\">\n                    Code has been resent. Please check your\n                    <span ng-switch=\"TotpForm.twoFaMethod\">\n                        <span ng-switch-when=\"1\">Email.</span>\n                        <span ng-switch-when=\"2\">SMS.</span>\n                        <span ng-switch-when=\"3\">Generator App.</span>\n                        <span ng-switch-when=\"4\">Freelancer App.</span>\n                        <span ng-switch-default>Email, SMS or App.</span>\n                    </span>\n                </aside>\n                <aside ng-class=\"{'is-hidden': !TotpForm.showErrorMessage}\"\n                    class=\"alert alert-error\">\n                    <span ng-if=\"TotpForm.errorStatus === 401 && TotpForm.errorCode === 'ExceptionCodes.INVALID_TOTP'\">Wrong code. Please try again.</span>\n                    <span ng-if=\"TotpForm.errorStatus === 401 && TotpForm.errorCode !== 'ExceptionCodes.INVALID_TOTP'\">There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.<br/>Error: {{TotpForm.errorCode}}</span>\n                    <span ng-if=\"TotpForm.errorStatus === 429\">You are performing too many requests. Please try again later.</span>\n                    <span ng-if=\"TotpForm.errorStatus === 500\">{{TotpForm.errorMessage}}<br/>Error: {{TotpForm.errorCode}}</span>\n                </aside>\n                <li class=\"form-step totp-step\">\n                    <label for=\"totp\" class=\"is-accessibly-hidden\">One Time Password</label>\n                    <input type=\"text\" placeholder=\"6 digit code\" name=\"totp\"\n                        class=\"large-input\"\n                        ng-model=\"TotpForm.UserData.user.TOTP\"\n                        ng-keypress=\"TotpForm.totpOnKeyPress($event)\"\n                        ng-change=\"TotpForm.totpOnChange()\"\n                        fl-focus-on=\"TotpForm.focusTotpInput\" />\n                </li>\n            </ol>\n        </fieldset>\n    </form>\n</div>\n";

/**
 * @ngdoc component
 * @name LoginSignupApp.flTotpForm
 * @description
 * Handles the code input, and resends for the 2FA form.
 */

var flTotpForm = function () {
  function flTotpForm($window, $timeout, Analytics, UsersService, UserData) {
    var _this = this;

    _classCallCheck(this, flTotpForm);

    this.$window = $window;
    this.$timeout = $timeout;
    this.Analytics = Analytics;
    this.Users = UsersService;
    this.UserData = UserData;

    this.Users.getDeviceToken(this.UserData.user);
    this.showResendSuccessMessage = false;
    this.isResendingCode = false;
    this.isSubmitting = false;
    this.loginSuccess = false;

    // Focus on TOTP Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusTotpInput = true;
    }, 50);
  }

  _createClass(flTotpForm, [{
    key: 'tryTotpLogin',
    value: function tryTotpLogin() {
      var _this2 = this;

      if (!this.isSubmitting && !this.loginSuccess && this.UserData.user.TOTP.length > 5) {
        this.isSubmitting = true;
        this.showErrorMessage = false;
        this.Users.totpLogin(this.UserData.user, this.rememberLogin).then(function (response) {
          if (response.data && response.data.token) {
            _this2.loginSuccess = true;
            _this2.$window.requestAnimationFrame(function () {
              _this2.onLoginSuccess({
                rememberLogin: _this2.rememberLogin
              });
            });
          }
          _this2.isSubmitting = false;
        }).catch(function (response) {
          _this2.showErrorMessage = true;
          _this2.errorStatus = response.status;
          _this2.errorCode = response.data.error_code;
          _this2.errorMessage = response.data.message;
          _this2.isSubmitting = false;
        });
      }
    }

    /**
     * Try to login again. This is useful for totp form component to mimic resending code
     */

  }, {
    key: 'login',
    value: function login() {
      var _this3 = this;

      this.Analytics.trackEvent('Login', '2fa', null, 'click', null, 'ResendCode');

      if (!this.isResendingCode) {
        this.isResendingCode = true;

        return this.Users.login(this.UserData.user, this.rememberLogin).then(function (response) {
          if (response.data && response.data.pre_login_token) {
            _this3.showResendSuccessMessage = true;
            _this3.$timeout(function () {
              _this3.showResendSuccessMessage = false;
            }, 10000);
          }

          _this3.isResendingCode = false;
        });
      }
    }

    /**
     * Limit TOTP length to 6 numbers.
     * Disallows input if length is greater or equal to 6 characters.
     */

  }, {
    key: 'totpOnKeyPress',
    value: function totpOnKeyPress(event) {
      var specialKeys = ['Backspace', 'Tab', 'End', 'Home'];
      var specialKeyCodes = [8, 9, 2, 3];
      // Allow Special Keys
      if (event.key && specialKeys.indexOf(event.key) !== -1 || specialKeyCodes.indexOf(event.keyCode) !== -1) {
        return;
      }

      if (this.UserData.user.TOTP.length < 6) {
        return;
      }
      event.preventDefault();
    }

    /**
     * Allow only numeric values and Limit Length
     */

  }, {
    key: 'totpOnChange',
    value: function totpOnChange() {
      var numberOnlyValue = this.UserData.user.TOTP.replace(/[^0-9]/g, '');
      this.UserData.user.TOTP = numberOnlyValue;
      var limitString = this.UserData.user.TOTP.substring(0, 6);
      this.UserData.user.TOTP = limitString;

      this.tryTotpLogin();
    }
  }]);

  return flTotpForm;
}();

flTotpForm.$inject = ['$window', '$timeout', 'Analytics', 'UsersService', 'UserData'];

var flTotpForm$1 = flComponent$1(flTotpForm, {
  selector: 'fl-totp-form',
  template: template$2,
  providers: [flIconProvider, flFocusOnProvider, AnalyticsModule, UsersProvider$1, UserData$1],
  bindings: {
    twoFaMethod: '=',
    rememberLogin: '=',
    onLoginSuccess: '&'
  }
});

var facebookLinkFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"FacebookLinkForm.cancelLink()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"FacebookLinkForm.closeModal()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n        ng-if=\"FacebookLinkForm.showAsModal\">\n        <span class=\"Icon Icon--small\">\n          <fl-icon name=\"ui-close\"></fl-icon>\n        </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{FacebookLinkForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    Link to existing Freelancer account\n  </div>\n  <figure class=\"ImageThumbnail ModalLoginSignup-facebook-profileImage\">\n    <img ng-src=\"{{FacebookLinkForm.UserData.getFacebookPictureUrl()}}\" alt=\"Profile Picture\"\n      class=\"ImageThumbnail-image\">\n  </figure>\n  <h2 class=\"ModalLoginSignup-body-heading\">\n    Welcome {{FacebookLinkForm.UserData.getFacebookName()}}!\n  </h2>\n  <div class=\"ModalLoginSignup-facebookLinkForm-info\">\n    Your email address is already associated with a Freelancer account. Enter your password below to link accounts:\n  </div>\n  <form name=\"FacebookLinkForm.form\" class=\"user-login-form fl-form large-form responsive-form\">\n    <div ng-messages=\"FacebookLinkForm.errors\">\n      <div ng-message=\"incorrectPassword\" class=\"alert alert-error\">\n        Incorrect username or password provided.\n      </div>\n      <div ng-message=\"facebookRateLimit\" class=\"alert alert-error\">\n        You are performing too many requests. Please try again later.\n      </div>\n      <div ng-message=\"facebookClosed\" class=\"alert alert-error\">\n        This account has been closed. Please contact <a href=\"/support\">support</a> for more assistance.\n      </div>\n      <div ng-message=\"facebookAccessDenied\" class=\"alert alert-error\">\n        There was a problem logging in with your account. Please contact <a href=\"/support\">support</a>.\n      </div>\n      <div ng-message=\"facebookUnknownError\" class=\"alert alert-error\">\n        Failed to connect with Facebook. Please try again.\n      </div>\n    </div>\n    <div ng-if=\"FacebookLinkForm.loginSuccess\"\n      class=\"form-feedback-success login-success alert alert-success\">\n      Successfully Linked!\n    </div>\n    <fieldset>\n      <ol>\n        <li ng-class=\"{'is-invalid': FacebookLinkForm.form.email.$invalid && FacebookLinkForm.form.email.$dirty}\"\n          class=\"form-step email-step\">\n          <label for=\"email\" class=\"is-accessibly-hidden\">Username</label>\n          <input id=\"email\" name=\"email\" type=\"email\"\n            maxlength=\"150\" class=\"large-input\"\n            ng-model=\"FacebookLinkForm.UserData.user.email\"\n            ng-required=\"true\"\n            ng-disabled=\"true\"/>\n        </li>\n        <li ng-class=\"{'is-invalid': FacebookLinkForm.form.password.$invalid && FacebookLinkForm.form.password.$dirty}\"\n          class=\"form-step password-step\">\n          <label for=\"password\" class=\"is-accessibly-hidden\">Password</label>\n          <input id=\"password\" name=\"password\" type=\"password\"\n            placeholder=\"Password\" class=\"large-input\"\n            maxlength=\"150\"\n            ng-model=\"FacebookLinkForm.UserData.user.password\"\n            ng-required=\"true\"/>\n          <div ng-if=\"FacebookLinkForm.form.password.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div ng-messages=\"FacebookLinkForm.form.password.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter your password.\n            </div>\n          </div>\n        </li>\n        <li class=\"form-step has-label login-form-options\">\n          <a ng-click=\"FacebookLinkForm.showResetPasswordForm()\" class=\"login-form-forgot forgot-password\">Forgot Password?</a>\n        </li>\n        <li class=\"form-step\">\n          <button ng-click=\"FacebookLinkForm.onFormSubmit($event)\" ng-disabled=\"FacebookLinkForm.isSubmitting\" type=\"submit\" class=\"btn btn-info btn-large btn-submit ModalLoginSignup-facebookLinkForm-submitBtn\">\n            Log In\n          </button>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n</div>\n";

var flFacebookLinkForm = function () {
  function flFacebookLinkForm($http, Cdn, UsersService, UserData, Analytics) {
    _classCallCheck(this, flFacebookLinkForm);

    this.$http = $http;
    this.UserData = UserData;
    this.Analytics = Analytics;
    this.UsersService = UsersService;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.isSubmitting = false;
    this.errors = {};
  }

  _createClass(flFacebookLinkForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      var _this = this;

      event.preventDefault();
      this.errors = {};
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;

      // All Errors should be dealt with in linkFacebookAccount.
      this.linkFacebookAccount().then(function () {
        _this.onComplete();
      }).catch(function () {});
    }

    /**
     * Try to link a user to their facebook account, given their facebook auth
     * params and email and password.
     */

  }, {
    key: 'linkFacebookAccount',
    value: function linkFacebookAccount() {
      var _this2 = this;

      this.errors = {};
      return this.UsersService.linkFacebookAccount(this.UserData.user).then(function (response) {
        if (response.data && response.data.token) {
          _this2.loginSuccess = true;
          _this2.onLoginSuccess();
          return;
        }
        _this2.isSubmitting = false;
      }).catch(function (error) {
        // Get Error Contents
        var errorStatus = error.status;
        error = error.data || null;

        // No Error Data
        if (!error) {
          _this2.Analytics.trackError('facebook', 'login', errorStatus, 'EmptyError');
          _this2.errors.facebookUnknownError = true;
          return;
        }

        // Redirect on Suspended
        if (error.error_code === 'Suspended') {
          _this2.onLoginSuccess({
            rememberLogin: _this2.rememberLogin,
            forceRedirectUrl: '/users/usersuspended.php'
          });
          return;
        }

        _this2.isSubmitting = false;
        if (errorStatus === 429) {
          _this2.errors.facebookRateLimit = true;
        } else if (errorStatus === 401 && error.error_code === 'None') {
          _this2.errors.incorrectPassword = true;
        } else if (errorStatus === 401 && error.error_code === 'Closed') {
          _this2.errors.facebookClosed = true;
        } else if (errorStatus === 401) {
          _this2.errors.facebookAccessDenied = true;
        } else {
          _this2.Analytics.trackError('facebook', 'login', error.error_code, error.message);
          _this2.errors.facebookUnknownError = true;
        }
      });
    }

    /**
     * Cancel Facebook Link
     */

  }, {
    key: 'cancelLink',
    value: function cancelLink() {
      // Clear User Data
      this.UserData.user.facebookConnected = false;
      this.UserData.user.facebookName = '';
      this.UserData.user.facebookEmail = '';
      this.UserData.user.facebookPictureUrl = '';
      this.UserData.user.facebookAccessToken = '';
      this.UserData.user.facebookSignedRequest = '';
      this.UserData.user.password = '';
      // Use Callback.
      this.onCancel();
    }
  }]);

  return flFacebookLinkForm;
}();

flFacebookLinkForm.$inject = ['$http', 'Cdn', 'UsersService', 'UserData', 'Analytics'];

var flFacebookLinkForm$1 = flComponent$1(flFacebookLinkForm, {
  selector: 'fl-facebook-link-form',
  template: facebookLinkFormTemplate,
  bindings: {
    onComplete: '&',
    onCancel: '&',
    onLoginSuccess: '&',
    showResetPasswordForm: '&',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [ngMessages, UserData$1, UsersProvider$1, AnalyticsModule, CdnProvider, flIconProvider]
});

var template$3 = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"ResetPasswordForm.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <div class=\"ModalLoginSignup-header-logo\">\n      <fl-icon name=\"fl-logo\"></fl-icon>\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body ModalLoginSignup-body\">\n  <h4 class=\"ModalLoginSignup-body-heading\">Reset your password</h4>\n  <p ng-class=\"{'is-hidden': !ResetPasswordForm.showSuccessMessage}\"\n      class=\"alert alert-info\">\n      Email sent. If the email address you entered is registered at Freelancer.com, you'll receive an email with instructions on how to set a new password.\n  </p>\n  <p ng-class=\"{'is-hidden': !ResetPasswordForm.showErrorMessage}\" class=\"alert alert-danger\">\n    {{ ResetPasswordForm.errorMessage }}\n  </p>\n  <form name=\"ResetPasswordForm.form\" class=\"recover-password-form fl-form large-form ModalLoginSignup-resetPassword-form\">\n    <fieldset>\n      <ol>\n        <li class=\"form-step recover-email-step\"\n          ng-class=\"{'is-invalid': ResetPasswordForm.form.email.$invalid && ResetPasswordForm.form.email.$dirty,\n          'is-valid': ResetPasswordForm.form.email.$valid}\">\n          <label for=\"forgotten-email\" class=\"is-accessibly-hidden\">Email Address</label>\n          <input id=\"forgotten-email\" name=\"email\" maxlength=\"100\" type=\"text\"\n            class=\"large-input\"\n            placeholder=\"Enter your email address\"\n            ng-model=\"ResetPasswordForm.UserData.user.email\"\n            ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n            ng-required=\"true\"\n            fl-email-username-valid-check=\"email\"\n            fl-focus-on=\"ResetPasswordForm.focusEmailInput\" />\n          <div ng-messages=\"ResetPasswordForm.form.email.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n                Please enter your email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"validEmail\">\n                Please enter a valid email address.\n            </div>\n          </div>\n        </li>\n        <li class=\"form-step\">\n          <button class=\"btn btn-info btn-large btn-primary btn-submit ModalLoginSignup-resetPassword-submitBtn\"\n            ng-disabled=\"ResetPasswordForm.isSubmitting\"\n            ng-click=\"ResetPasswordForm.resetPassword($event)\"\n            type=\"submit\">\n            Reset Password\n          </button>\n        </li>\n      </ol>\n    </fieldset>\n  </form>\n  <span class=\"login-form-signup-link\" ng-if=\"ResetPasswordForm.loginSignupConfig.showSignupOption()\">\n      Don't have an account?\n      <a ng-click=\"ResetPasswordForm.goToSignup($event)\">Sign Up</a>\n  </span>\n</div>\n";

var flResetPasswordForm = function () {
  function flResetPasswordForm($timeout, UsersService, UserData, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flResetPasswordForm);

    this.$timeout = $timeout;
    this.UserData = UserData;
    this.Users = UsersService;
    this.isSubmitting = false;
    this.showSuccessMessage = false;
    this.showErrorMessage = false;
    this.errorMessage = '';
    this.loginSignupConfig = LoginSignupConfig;

    // Set User Email to Username if it's a valid email
    // Reset Password is accessed from Login, which uses ng mdoel on username,
    // so we check to see if we can prefill this value first instead.
    if (this.UserData.user.username && isValidEmail(this.UserData.user.username)) {
      this.UserData.user.email = this.UserData.user.username;
    }

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flResetPasswordForm, [{
    key: 'resetPassword',
    value: function resetPassword(event) {
      var _this2 = this;

      event.preventDefault();
      this.showErrorMessage = false;
      // Set form fields as dirty for each form input type with any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid || this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;
      this.Users.forgotPassword(this.UserData.user.email).then(function (response) {
        if (response.data && response.data.status === 'success') {
          _this2.showSuccessMessage = true;
          _this2.$timeout(function () {
            _this2.showSuccessMessage = false;
          }, 10000);
        } else if (response.data && response.data.msg) {
          _this2.errorMessage = response.data.msg;
          _this2.showErrorMessage = true;

          if (response.data.redirectUrl) {
            window.location.href = response.data.redirectUrl;
          }
        }
        _this2.isSubmitting = false;
      });
    }
  }, {
    key: 'goToSignup',
    value: function goToSignup($event) {
      $event.preventDefault();
      this.showSignupForm();
    }
  }]);

  return flResetPasswordForm;
}();

flResetPasswordForm.$inject = ['$timeout', 'UsersService', 'UserData', 'LoginSignupConfig'];

var flResetPasswordForm$1 = flComponent$1(flResetPasswordForm, {
  selector: 'fl-reset-password-form',
  template: template$3,
  providers: [flIconProvider, flFocusOnProvider, flEmailUsernameValidCheck$1, UserData$1, UsersProvider$1, LoginSignupConfigProvider],
  bindings: {
    showSignupForm: '&',
    onCancel: '&',
    showLoginForm: '&'
  }
});

var loginSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\" ng-click=\"LoginSuccess.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"LoginSuccess.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{LoginSuccess.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Login\">\n  <div class=\"ModalLoginSignup-loginSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Login Success!</h2>\n    <div ng-if=\"LoginSuccess.loginSignupConfig.getLoginSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">{{LoginSuccess.loginSignupConfig.getLoginSuccessMessage()}}</p>\n    </div>\n    <div ng-if=\"!LoginSuccess.loginSignupConfig.getLoginSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    </div>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flLoginSuccess = function () {
  function flLoginSuccess(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flLoginSuccess);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flLoginSuccess, [{
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flLoginSuccess;
}();

flLoginSuccess.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flLoginSuccess$1 = flComponent$1(flLoginSuccess, {
  selector: 'fl-login-success',
  template: loginSuccessTemplate,
  bindings: { closeModal: '&' },
  providers: [CdnProvider, UserData$1, LoginSignupConfigProvider]
});

var LOGIN_STEPS = {
  LOGIN_FORM: 1,
  TOTP_FORM: 2,
  FB_LINK_FORM: 3,
  RESET_PASSWORD_FORM: 4,
  LOGIN_SUCCESS: 10
};

var loginTemplate = "<fl-login-form\n  ng-if=\"Login.currentStep === Login.steps.LOGIN_FORM\"\n  show-signup-form=\"Login.goToSignup()\"\n  show-reset-password-form=\"Login.showResetPasswordForm()\"\n  show-facebook-link-form=\"Login.showFacebookLinkForm()\"\n  on-need-totp=\"Login.showTOTPForm(twoFAMethod)\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  remember-login=\"Login.rememberLogin\"\n  show-as-modal=\"Login.showAsModal\"\n  close-modal=\"Login.closeModal()\">\n</fl-login-form>\n<fl-totp-form\n  ng-if=\"Login.currentStep === Login.steps.TOTP_FORM\"\n  two-fa-method=\"Login.twoFAMethod\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  remember-login=\"Login.rememberLogin\"\n  show-as-modal=\"Login.showAsModal\">\n</fl-totp-form>\n<fl-reset-password-form\n  ng-if=\"Login.currentStep === Login.steps.RESET_PASSWORD_FORM\"\n  show-signup-form=\"Login.goToSignup()\"\n  on-cancel=\"Login.currentStep = Login.steps.LOGIN_FORM\"\n  show-login-form=\"Login.showLoginForm()\"\n  show-as-modal=\"Login.showAsModal\">\n</fl-reset-password-form>\n<fl-facebook-link-form\n  ng-if=\"Login.currentStep === Login.steps.FB_LINK_FORM\"\n  on-cancel=\"Login.currentStep = Login.steps.LOGIN_FORM\"\n  on-login-success=\"Login.onLoginSuccess({rememberLogin: rememberLogin, forceRedirectUrl: forceRedirectUrl})\"\n  show-reset-password-form=\"Login.showResetPasswordForm()\"\n  show-as-modal=\"Login.showAsModal\"\n  close-modal=\"Login.closeModal()\">\n</fl-facebook-link-form>\n<fl-login-success\n  ng-if=\"Login.currentStep === Login.steps.LOGIN_SUCCESS\"\n  close-modal=\"Login.closeModal($event)\">\n</fl-login-success>\n";

var flLogin = function () {
  function flLogin($window, $rootScope, UserData, LoginSignupConfig) {
    _classCallCheck(this, flLogin);

    this.$window = $window;
    this.$rootScope = $rootScope;
    this.UserData = UserData;
    this.steps = LOGIN_STEPS;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flLogin, [{
    key: 'goToSignup',
    value: function goToSignup() {
      this.loginSignupConfig.switchToSignup();
    }
  }, {
    key: 'showLoginForm',
    value: function showLoginForm() {
      this.currentStep = this.steps.LOGIN_FORM;
    }
  }, {
    key: 'showTOTPForm',
    value: function showTOTPForm(twoFAMethod) {
      this.currentStep = this.steps.TOTP_FORM;
      this.twoFAMethod = twoFAMethod;
    }
  }, {
    key: 'showResetPasswordForm',
    value: function showResetPasswordForm() {
      this.currentStep = this.steps.RESET_PASSWORD_FORM;
    }
  }, {
    key: 'showFacebookLinkForm',
    value: function showFacebookLinkForm() {
      if (this.UserData.isFacebookConnected()) {
        this.UserData.user.password = '';
        this.UserData.user.email = this.UserData.getFacebookEmail();
        this.currentStep = this.steps.FB_LINK_FORM;
        return;
      }
      this.currentStep = this.steps.LOGIN_FORM;
    }
  }]);

  return flLogin;
}();

flLogin.$inject = ['$window', '$rootScope', 'UserData', 'LoginSignupConfig'];

var flLogin$1 = flComponent$1(flLogin, {
  selector: 'fl-login',
  template: loginTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&',
    currentStep: '='
  },
  providers: [UserData$1, flLoginForm$1, flTotpForm$1, flLoginSuccess$1, flFacebookLinkForm$1, flResetPasswordForm$1, LoginSignupConfigProvider]
});

var usernameInputTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"UsernameInput.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n\n    <button class=\"Modal-close\" ng-click=\"UsernameInput.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"UsernameInput.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{UsernameInput.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <h2 class=\"ModalLoginSignup-body-title\">Choose a username</h2>\n  <p class=\"ModalLoginSignup-body-subtitle\">Please note that a username cannot be changed, once chosen.</p>\n  <form class=\"user-signup-form fl-form responsive-form\" name=\"UsernameInput.form\">\n    <div class=\"form-step email-step\"\n      ng-class=\"{'is-invalid': UsernameInput.form.username.$invalid && UsernameInput.form.username.$dirty,\n                 'is-valid': UsernameInput.form.username.$valid}\">\n      <label for=\"new-username\" class=\"is-accessibly-hidden\">Username</label>\n      <input type=\"text\" name=\"username\" id=\"new-username\"\n        rel=\"popover\" placeholder=\"Username\" class=\"large-input\"\n        ng-model=\"UsernameInput.UserData.user.username\"\n        ng-model-options=\"{ debounce: {'default': 300, 'blur': 0} }\"\n        ng-required=\"true\"\n        ng-minlength=\"3\"\n        ng-maxlength=\"16\"\n        fl-email-username-valid-check=\"username\"\n        fl-unique-email-username-check=\"username\"\n        fl-focus-on=\"UsernameInput.focusUsernameInput\">\n      <div ng-if=\"UsernameInput.form.username.$pending\"\n        class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n      </div>\n      <div ng-messages=\"UsernameInput.form.username.$error\" tabindex=\"-1\">\n        <div class=\"form-error\" ng-message=\"required\">\n          Please enter a username.\n        </div>\n        <div class=\"form-error\" ng-message=\"minlength\">\n          Please enter at least 3 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"maxlength\">\n          Please enter at most 16 characters.\n        </div>\n        <div class=\"form-error\" ng-message=\"validUsername\">\n          Username must be alphanumeric starting with a letter.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueUsername\">\n          This username already exists, please choose another.\n        </div>\n        <div class=\"form-error\" ng-message=\"uniqueFromPassword\">\n          Username must be different to password.\n        </div>\n      </div>\n      <div id=\"new-username-suggestion\" class=\"ModalLoginSignup-signupUsernameInput-suggestions\">\n        <span class=\"ModalLoginSignup-signupUsernameInput-suggestionTitle\">Suggestions:</span>\n        <span ng-repeat=\"name in UsernameInput.usernameSuggestions\">\n          <a ng-click=\"UsernameInput.updateUsername(name)\">\n          {{name}}\n          </a>\n          <span ng-show=\"!$last\" class=\"ModalLoginSignup-signupUsernameInput-suggestions-separator\">/</span>\n        </span>\n      </div>\n    </div>\n    <button class=\"btn btn-info btn-large ModalLoginSignup-signupUsernameInput-submitBtn\"\n      ng-disabled=\"UsernameInput.isSubmitting\"\n      ng-click=\"UsernameInput.onFormSubmit($event)\"\n      fl-analytics=\"NormalSignupUsername\">\n      Next\n      <span ng-if=\"UsernameInput.isSubmitting\" class=\"Loader Loader--small\">\n      </span>\n    </button>\n  </form>\n</div>\n";

var flUsernameInput = function () {
  function flUsernameInput($scope, $timeout, Cdn, UsersService, UserData, Facebook) {
    var _this = this;

    _classCallCheck(this, flUsernameInput);

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.Users = UsersService;
    this.Facebook = Facebook;

    // Focus on Username Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusUsernameInput = true;
    }, 50);
  }

  _createClass(flUsernameInput, [{
    key: 'updateUsername',
    value: function updateUsername(name) {
      var _this2 = this;

      this.form.username.$setDirty();
      this.UserData.user.username = name;
      var usernameValidWatch = this.$scope.$watch(function () {
        return _this2.form.$valid;
      }, function (newValue) {
        if (newValue === true) {
          _this2.onComplete();
          usernameValidWatch();
        }
      });
    }
  }, {
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }]);

  return flUsernameInput;
}();

flUsernameInput.$inject = ['$scope', '$timeout', 'Cdn', 'UsersService', 'UserData', 'Facebook'];

var flUsernameInput$1 = flComponent$1(flUsernameInput, {
  selector: 'fl-username-input',
  template: usernameInputTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    usernameSuggestions: '=',
    showAsModal: '=',
    closeModal: '&',
    isSubmitting: '='
  },
  providers: [CdnProvider, UserData$1, UsersProvider$1, flFocusOnProvider, flIconProvider, FacebookProvider$1, flEmailUsernameValidCheck$1, flUniqueEmailUsernameCheck]
});

var signupBaseFormTemplate = "<div class=\"Modal-header\">\n  <button class=\"Modal-close\" ng-click=\"SignupBaseForm.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n    ng-if=\"SignupBaseForm.showAsModal\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div class=\"ModalLoginSignup-header-logo\">\n    <fl-icon name=\"fl-logo\"></fl-icon>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <div class=\"ModalLoginSignup-body-heading\">\n    <span ng-if=\"!SignupBaseForm.loginSignupConfig.getSignupTitle()\">\n      Sign Up\n    </span>\n    <span ng-if=\"SignupBaseForm.loginSignupConfig.getSignupTitle()\">\n      {{SignupBaseForm.loginSignupConfig.getSignupTitle()}}\n    </span>\n  </div>\n  <div ng-if=\"!SignupBaseForm.UserData.isFacebookConnected()\">\n    <button ng-if=\"!SignupBaseForm.loginSignupConfig.isHideFb()\"\n      ng-click=\"SignupBaseForm.facebookConnect()\"\n      class=\"btn-facebook btn btn-large ModalLoginSignup-facebook-connect\"\n      data-uitest-target=\"facebook-signup-button\"\n      fl-analytics=\"FBSignup\">\n      <fl-icon name=\"flicon-facebook\"></fl-icon>\n      Connect with Facebook\n    </button>\n    <div ng-messages=\"SignupBaseForm.facebookErrors\" class=\"ModalLoginSignup-signupBaseForm-facebookErrors\">\n      <div ng-message=\"facebookLinked\" class=\"alert alert-success ModalLoginSignup-signupBaseForm-loginSuccess\">\n        <div class=\"ModalLoginSignup-signupBaseForm-loginSuccess-text\">Welcome {{SignupBaseForm.UserData.getFacebookName()}}! Logging you in.</div>\n        <div class=\"Loader Loader--small\"></div>\n      </div>\n      <div ng-message=\"emailTaken\" class=\"alert alert-info\">\n        Your Facebook email is already associated with a Freelancer account.\n        Click <a ng-click=\"SignupBaseForm.showLoginForm()\">here</a> to login.\n      </div>\n      <div ng-message=\"emailBlocked\" class=\"alert alert-error\">\n        The email domain associated with your Facebook Account is blocked. Please use a different email address.\n      </div>\n      <div ng-message=\"notAuthorized\" class=\"alert alert-error\">\n        Please authorise Freelancer to access your Facebook account in order to sign up with Facebook.\n      </div>\n      <div ng-message=\"accessDenied\" class=\"alert alert-error\">\n        There was a problem logging in with your account. Please contact <a href=\"https://www.freelancer.com/support\">support</a>.\n      </div>\n      <div ng-message=\"unknownError\" class=\"alert alert-error\">\n        Failed to connect with Facebook. Please try again.\n      </div>\n    </div>\n    <div ng-if=\"!SignupBaseForm.loginSignupConfig.isHideFb()\" class=\"hr-divider\">\n      <span class=\"hr-divider-text\">OR</span>\n    </div>\n  </div>\n  <div ng-if=\"SignupBaseForm.UserData.isFacebookConnected()\">\n    <figure class=\"ImageThumbnail ModalLoginSignup-facebook-profileImage\">\n      <img ng-src=\"{{SignupBaseForm.UserData.user.facebookPictureUrl}}\" class=\"ImageThumbnail-image\">\n    </figure>\n    <h2 class=\"ModalLoginSignup-body-heading\">\n      Welcome {{SignupBaseForm.UserData.getFacebookName()}}!\n    </h2>\n  </div>\n  <form id=\"signup_form\" class=\"user-signup-form fl-form responsive-form\"\n    name=\"SignupBaseForm.form\">\n    <fieldset>\n      <ol>\n        <li class=\"form-step email-step\"\n          ng-class=\"{'is-invalid': SignupBaseForm.form.email.$invalid && SignupBaseForm.form.email.$dirty,\n                     'is-valid': SignupBaseForm.form.email.$valid}\">\n          <label for=\"new-email\" class=\"is-accessibly-hidden\">Email Address</label>\n          <input type=\"text\" name=\"email\" id=\"new-email\"\n            rel=\"popover\" placeholder=\"Email Address\" class=\"large-input\"\n            ng-model=\"SignupBaseForm.UserData.user.email\"\n            ng-model-options=\"{ debounce: {'default': 300, 'blur': 0}, allowInvalid: true }\"\n            ng-disabled=\"SignupBaseForm.UserData.isFacebookConnected()\n              && (SignupBaseForm.form.email.$valid || SignupBaseForm.form.email.$pending)\n              && SignupBaseForm.UserData.user.email === SignupBaseForm.UserData.getFacebookEmail()\"\n            ng-required=\"true\"\n            fl-email-username-valid-check=\"email\"\n            fl-blocked-email-check\n            fl-unique-email-username-check\n            fl-focus-on=\"SignupBaseForm.focusEmailInput\">\n          <div ng-if=\"SignupBaseForm.form.email.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div class=\"form-help\" id=\"new-email-suggestion\" style=\"display: none;\">\n            Did you mean <a id=\"new-email-suggestion-content\"></a>?\n          </div>\n          <div ng-messages=\"SignupBaseForm.form.email.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter an email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"validEmail\">\n              Please enter a valid email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"unblockedEmail\">\n              This email domain is blocked. Please use a different email address.\n            </div>\n            <div class=\"form-error\" ng-message=\"uniqueEmail\">\n              This email address is already in use.\n            </div>\n          </div>\n        </li>\n\n        <li class=\"form-step password-step\"\n          ng-if=\"!SignupBaseForm.UserData.isFacebookConnected()\"\n          ng-class=\"{'is-invalid': SignupBaseForm.form.password.$invalid && SignupBaseForm.form.password.$dirty,\n                     'is-valid': SignupBaseForm.form.password.$valid}\">\n          <label for=\"new-password\" class=\"is-accessibly-hidden\">Password</label>\n          <input type=\"password\" id=\"new-password\" name=\"password\"\n            placeholder=\"Password\" class=\"large-input\"\n            ng-model=\"SignupBaseForm.UserData.user.password\"\n            ng-required=\"true\"\n            ng-minlength=\"6\"\n            ng-maxlength=\"150\"\n            fl-password-check>\n          <div ng-if=\"SignupBaseForm.form.password.$pending\"\n            class=\"Loader Loader--small ModalLoginSignup-inputLoader\">\n          </div>\n          <div ng-messages=\"SignupBaseForm.form.password.$error\" tabindex=\"-1\">\n            <div class=\"form-error\" ng-message=\"required\">\n              Please enter a password.\n            </div>\n            <div class=\"form-error\" ng-message=\"minlength\">\n              Password must be at least 6 characters.\n            </div>\n            <div class=\"form-error\" ng-message=\"maxlength\">\n              Password must be at most 150 characters.\n            </div>\n            <div class=\"form-error\" ng-message=\"uniqueFromUsername\">\n              Password must be different to username.\n            </div>\n            <div class=\"form-error\" ng-message=\"strongPassword\">\n              Password must contain lowercase and uppercase letters or a number.\n            </div>\n          </div>\n        </li>\n\n        <li id=\"coupon-step\" class=\"form-step coupon-step\" ng-if=\"SignupBaseForm.showCouponInput\">\n            <button type=\"button\" id=\"redeem_coupon\" class=\"coupon-step-toggle btn btn-plain\">\n              I have a coupon code I would like to use\n            </button>\n            <div class=\"coupon-step-inner\">\n              <label for=\"coupon\">\n                Coupon Code (Optional)\n              </label>\n              <input type=\"text\" name=\"coupon\" id=\"coupon\" value=\"{{SignupBaseForm.coupon}}\" class=\"default-input\">\n              <span class=\"help-inline\"></span>\n              <div class=\"form-error\"></div>\n            </div>\n        </li>\n\n        <input type=\"hidden\" name=\"signup_skip_captcha\" id=\"signup_skip_captcha\" value=\"{{SignupBaseForm.loginSignupConfig.getSkipCaptchaHash()}}\">\n\n        <li class=\"form-step\">\n            <button type=\"submit\" id=\"signup_btn\"\n              class=\"btn btn-info btn-large btn-submit ModalLoginSignup-signupBaseForm-submitBtn\"\n              ng-click=\"SignupBaseForm.onFormSubmit($event)\"\n              fl-analytics=\"NormalSignupEmailPassword\">\n              Join Freelancer\n            </button>\n        </li>\n        <small class=\"ModalLoginSignup-signupBaseForm-signupTerms\">\n          By registering you confirm that you accept the\n          <a href='#' onclick='window.open(\n            \"/info/plainterms.html\",\"\",\"width=500, height=450, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n            );return false;'>\n            Terms and Conditions\n          </a>\n          and\n          <a href='javascript: void()' onclick='window.open(\n            \"/about/privacy?popup=true\",\"\",\"width=700, height=550, left=100,top=100,menu=no, toolbar=no,scrollbars=yes,resizable=yes\"\n           );return false;'>\n            Privacy Policy\n          </a>\n        </small>\n      </ol>\n    </fieldset>\n  </form>\n</div>\n";

var flSignupBaseForm = function () {
  function flSignupBaseForm($log, $timeout, UsersService, UserData, LoginSignupConfig) {
    var _this = this;

    _classCallCheck(this, flSignupBaseForm);

    this.$log = $log;
    this.$timeout = $timeout;
    this.UserData = UserData;
    this.Users = UsersService;
    this.loginSignupConfig = LoginSignupConfig;

    if (this.loginSignupConfig.getEmailPrefill()) {
      this.UserData.user.email = this.loginSignupConfig.getEmailPrefill();
    }

    // Focus on Email Input after timeout. (Triggers flFocusOn)
    this.$timeout(function () {
      _this.focusEmailInput = true;
    }, 50);
  }

  _createClass(flSignupBaseForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }, {
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flSignupBaseForm;
}();

flSignupBaseForm.$inject = ['$log', '$timeout', 'UsersService', 'UserData', 'LoginSignupConfig'];

var flSignupBaseForm$1 = flComponent$1(flSignupBaseForm, {
  selector: 'fl-signup-base-form',
  template: signupBaseFormTemplate,
  bindings: {
    onComplete: '&',
    showLoginForm: '&',
    facebookConnect: '&',
    facebookErrors: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [ngMessages, UserData$1, UsersProvider$1, flIconProvider, flFocusOnProvider, flPasswordCheck, flBlockedEmailCheck, flEmailUsernameValidCheck$1, LoginSignupConfigProvider, flUniqueEmailUsernameCheck]
});

var USER_TYPE_EMPLOYER = 'employer';
var USER_TYPE_FREELANCER = 'freelancer';
var SIGNUP_STEPS = {
  BASE_STEP: 1,
  USERNAME_STEP: 2,
  ACCOUNT_TYPE_STEP: 3,
  PRIVACY_CONSENT_STEP: 4,
  CAPTCHA_STEP: 5,
  SUCCESS_STEP: 10 };
var REFERRAL_SIGNUP_COOKIE_KEY = 'referral_signup';
var IS_FROM_EU_COOKIE_KEY = 'is_from_eu';
var PRIVACY_CONSENT_KEY = 'privacy_consent';
var BUSINESS_USER_KEY = 'business_user';
var PROJECT_COLLABORATION_INVITATION_KEY = 'project_collaboration_invitation';
var CONTEST_COLLABORATION_INVITATION_KEY = 'contest_collaboration_invitation';

var accountTypeSelectorTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"AccountTypeSelector.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"AccountTypeSelector.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"AccountTypeSelector.showAsModal\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{AccountTypeSelector.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <h2 class=\"ModalLoginSignup-body-title\">Select account type</h2>\n  <p class=\"ModalLoginSignup-body-subtitle\">Don’t worry, this can be changed later.</p>\n  <div ng-click=\"AccountTypeSelector.selectFreelancer()\" class=\"Card ModalLoginSignup-signupAccountType-card\" fl-analytics=\"NormalSignupFreelancer\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{AccountTypeSelector.workImageUrl}]}\" alt=\"Work Image\" />\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to work\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!AccountTypeSelector.submittingSignup || AccountTypeSelector.selectedEmployer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"AccountTypeSelector.submittingSignup && AccountTypeSelector.selectedFreelancer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n  <div ng-click=\"AccountTypeSelector.selectEmployer()\" class=\"Card ModalLoginSignup-signupAccountType-card\" fl-analytics=\"NormalSignupEmployer\">\n    <div class=\"ModalLoginSignup-signupAccountType-card-content\">\n      <div class=\"ModalLoginSignup-signupAccountType-card-image\">\n        <img ng-src=\"{[{AccountTypeSelector.hireImageUrl}]}\" alt=\"Hire Image\" />\n      </div>\n      <div class=\"ModalLoginSignup-signupAccountType-card-title\">\n        I want to hire\n      </div>\n    </div>\n    <div class=\"ModalLoginSignup-signupAccountType-card-next\">\n      <div ng-if=\"!AccountTypeSelector.submittingSignup || AccountTypeSelector.selectedFreelancer\">\n        <fl-icon name=\"ui-arrow-right\" class=\"ModalLoginSignup-signupAccountType-card-next-icon\">\n        </fl-icon>\n      </div>\n      <div ng-if=\"AccountTypeSelector.submittingSignup && AccountTypeSelector.selectedEmployer\" class=\"Loader Loader--small\">\n      </div>\n    </div>\n  </div>\n</div>\n";

var flAccountTypeSelector = function () {
  function flAccountTypeSelector(Cdn, UserData, UsersService) {
    _classCallCheck(this, flAccountTypeSelector);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.hireImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-hire.svg');
    this.workImageUrl = Cdn.getCdnUrl('/static/img/login-signup/fln-icon-work.svg');
    this.UserData = UserData;
    this.Users = UsersService;

    // States
    this.selectedEmployer = false;
    this.selectedFreelancer = false;
  }

  _createClass(flAccountTypeSelector, [{
    key: 'selectEmployer',
    value: function selectEmployer() {
      this.UserData.user.role = USER_TYPE_EMPLOYER;
      this.selectedEmployer = true;
      this.selectedFreelancer = false;
      this.onComplete();
    }
  }, {
    key: 'selectFreelancer',
    value: function selectFreelancer() {
      this.UserData.user.role = USER_TYPE_FREELANCER;
      this.selectedFreelancer = true;
      this.selectedEmployer = false;
      this.onComplete();
    }
  }]);

  return flAccountTypeSelector;
}();

flAccountTypeSelector.$inject = ['Cdn', 'UserData', 'UsersService'];

var flAccountTypeSelector$1 = flComponent$1(flAccountTypeSelector, {
  selector: 'fl-account-type-selector',
  template: accountTypeSelectorTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [CdnProvider, UserData$1, UsersProvider$1, flIconProvider]
});

var privacyConsentFormTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <div ng-click=\"PrivacyConsentForm.onCancel()\" class=\"ModalLoginSignup-header-previousStep\">\n      <fl-icon name=\"ui-chevron-left\" class=\"ModalLoginSignup-header-previousStep-icon\"></fl-icon>\n    </div>\n    <button class=\"Modal-close\" ng-click=\"PrivacyConsentForm.loginSignupConfig.hide()\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"PrivacyConsentForm.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{PrivacyConsentForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n <form name=\"PrivacyConsentForm.form\">\n    <h2 class=\"ModalLoginSignup-body-title\">Email Opt-In</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Would you like to receive marketing promotions, special offers, inspirations, and updates to Freelancer's product and policies? You can unsubscribe at any time.</p>\n    <div class=\"fl-form Checkbox ModalLoginSignup-privacyConsentForm-input\">\n      <input id=\"privacy-consent\" name=\"privacy-consent\"\n        class=\"Checkbox-input\" type=\"checkbox\"\n        ng-model=\"PrivacyConsentForm.UserData.user.privacyConsent\">\n      <label class=\"Checkbox-label\" for=\"privacy-consent\">\n        Yes, I want to receive emails.\n      </label>\n    </div>\n\n    <h2 class=\"ModalLoginSignup-body-title\">Account Type</h2>\n    <p class=\"ModalLoginSignup-body-subtitle\">Do you intend to use Freelancer for personal use? Using Freelancer for cases other than business may be subject to additional VAT.</p>\n    <div class=\"fl-form Checkbox ModalLoginSignup-privacyConsentForm-input\">\n      <input id=\"business-user\" name=\"business-user\"\n        class=\"Checkbox-input\" type=\"checkbox\"\n        ng-model=\"PrivacyConsentForm.UserData.user.privateUser\">\n      <label class=\"Checkbox-label\" for=\"business-user\">\n        Yes, I am using Freelancer for personal use.\n      </label>\n    </div>\n\n    <button type=\"submit\"\n      class=\"btn btn-info btn-large btn-submit ModalLoginSignup-privacyConsentForm-submitBtn\"\n      ng-click=\"PrivacyConsentForm.onFormSubmit($event)\"\n      fl-analytics=\"NormalSignupPrivacyConsent\"\n      ng-disabled=\"PrivacyConsentForm.submittingSignup\">\n      <span ng-if=\"!PrivacyConsentForm.submittingSignup\">\n        Sign Up\n      </span>\n      <span ng-if=\"PrivacyConsentForm.submittingSignup\">\n        <div class=\"Loader Loader--small\"></div>\n      </span>\n    </button>\n  </form>\n</div>\n";

var flPrivacyConsentForm = function () {
  function flPrivacyConsentForm(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flPrivacyConsentForm);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
    this.UserData.user.privateUser = false;
  }

  _createClass(flPrivacyConsentForm, [{
    key: 'onFormSubmit',
    value: function onFormSubmit(event) {
      event.preventDefault();
      // Set form fields as dirty if it has any errors.
      angular.forEach(this.form.$error, function (type) {
        angular.forEach(type, function (field) {
          field.$setDirty();
        });
      });
      if (!this.form.$valid) {
        return;
      }
      this.onComplete();
    }
  }]);

  return flPrivacyConsentForm;
}();

flPrivacyConsentForm.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flPrivacyConsentForm$1 = flComponent$1(flPrivacyConsentForm, {
  selector: 'fl-privacy-consent-form',
  template: privacyConsentFormTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '='
  },
  providers: [CdnProvider, UserData$1, flIconProvider, LoginSignupConfigProvider]
});

/**
 * @ngdoc service
 * @name Captcha
 * @description
 * Captcha Service
 * TODO: Move to replace captcha.js in flAngular
 * (also need to move flRecaptcha.js which contains the directive)
 */

var Captcha = function () {
  function Captcha($q, $window, $interval, RECAPTCHA_PUBLIC_KEY) {
    _classCallCheck(this, Captcha);

    this.$q = $q;
    this.$window = $window;
    this.$interval = $interval;
    this.RECAPTCHA_PUBLIC_KEY = RECAPTCHA_PUBLIC_KEY;
    this.recaptchaLibraryLoaded = false;
  }

  _createClass(Captcha, [{
    key: 'create',
    value: function create(element, params) {
      var _this = this;

      // Assign Site Key
      params.sitekey = this.RECAPTCHA_PUBLIC_KEY;
      // Create Promise
      var deferred = this.$q.defer();
      if (this.recaptchaLibraryLoaded) {
        (function () {
          var waitForLoad = _this.$interval(function () {
            if (angular.isDefined(_this.$window.grecaptcha)) {
              _this.$interval.cancel(waitForLoad);
              var widgetId = _this._render(element, params);
              deferred.resolve(widgetId);
            }
          }, 100);
        })();
      } else if (!this._existsRecaptchaScript()) {
        // If recaptcha script does not exist, create it and call back to render
        this.recaptchaLibraryLoaded = true;
        // Create callback function to onRecaptchaLoad
        this.$window.onRecaptchaLoad = function () {
          var widgetId = _this._render(element, params);
          deferred.resolve(widgetId);
        };
        this._injectRecaptchaScript(element);
      } else {
        // Otherwise, call render
        var widgetId = this._render(element, params);
        deferred.resolve(widgetId);
      }
      return deferred.promise;
    }
  }, {
    key: '_render',
    value: function _render(element, params) {
      return this.$window.grecaptcha.render(element, params);
    }
  }, {
    key: '_existsRecaptchaScript',
    value: function _existsRecaptchaScript() {
      return angular.isDefined(this.$window.grecaptcha);
    }
  }, {
    key: '_injectRecaptchaScript',
    value: function _injectRecaptchaScript() {
      var script = angular.element(document.createElement('script'));
      script.attr('src', 'https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit');
      script.attr('async', true);
      angular.element(document.body).append(script);
    }
  }]);

  return Captcha;
}();

Captcha.$inject = ['$q', '$window', '$interval', 'RECAPTCHA_PUBLIC_KEY'];

var CaptchaProvider = flService$1('Captcha', [OPAQUE_MODULE_NAME], Captcha);

/**
 * @ngdoc directive
 * @name Captcha.directive:flRecaptcha
 * @restrict E
 * @description
 * Injects Google No Captcha Recaptcha
 * TODO: Move to replace this with flRecaptcha in flAngular
 * (also need to move captcha.js which contains the service)
 */

var flRecaptcha = function () {
  function flRecaptcha($window, Captcha) {
    _classCallCheck(this, flRecaptcha);

    this.$window = $window;
    this.Captcha = Captcha;
  }

  _createClass(flRecaptcha, [{
    key: 'link',
    value: function link() {
      var _this = this;

      this.widgetId = null;
      this.captchaRendered = false;
      this.Captcha.create(this.elementId, this.getParams()).then(function (widgetId) {
        _this.widgetId = widgetId;
        _this.captchaRendered = true;
      }).catch(function () {});
    }
  }, {
    key: 'getParams',
    value: function getParams() {
      return {
        callback: this._successCallback.bind(this),
        'expired-callback': this._expiredCallback.bind(this),
        'error-callback': this._errorCallback.bind(this),
        theme: this.theme,
        type: this.type,
        size: this.size
      };
    }
  }, {
    key: '_successCallback',
    value: function _successCallback(response) {
      this.onSuccess({ response: response });
    }
  }, {
    key: '_expiredCallback',
    value: function _expiredCallback() {
      this.onExpired();
    }
  }, {
    key: '_errorCallback',
    value: function _errorCallback() {
      this.onError();
    }
  }]);

  return flRecaptcha;
}();

flRecaptcha.$inject = ['$window', 'Captcha'];

var flRecaptcha$1 = flDirective$1(flRecaptcha, {
  selector: 'fl-recaptcha',
  template: '<div id="{{Recaptcha.elementId}}"></div><div class="Loader" ng-if="!Recaptcha.captchaRendered"></div>',
  restrict: 'E',
  scope: {
    elementId: '@',
    theme: '@',
    type: '@',
    size: '@',
    onSuccess: '&',
    onExpired: '&',
    onError: '&'
  },
  providers: [CaptchaProvider]
});

var captchaFormTemplate = "<div class=\"Modal-header\">\n  <button type=\"button\" class=\"Modal-close\" type=\"button\"\n    aria-label=\"Close this modal window\" ng-click=\"CaptchaForm.closeModal($event)\">\n    <span class=\"Icon Icon--small\">\n      <fl-icon name=\"ui-close\"></fl-icon>\n    </span>\n  </button>\n  <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n    <img ng-src=\"{[{CaptchaForm.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n  </div>\n</div>\n<div class=\"Modal-body\">\n  <h2 class=\"ModalLoginSignup-body-heading\">You're almost there!</h2>\n  <div class=\"ModalLoginSignup-captchaForm-recaptcha\">\n    <fl-recaptcha element-id=\"SignupCaptcha\"\n      on-success=\"CaptchaForm.onVerifyCaptcha(response)\"\n      on-expired=\"CaptchaForm.onExpiredCaptcha()\">\n    </fl-recaptcha>\n  </div>\n  <div ng-if=\"CaptchaForm.showError\" class=\"alert alert-error ModalLoginSignup-captchaForm-error\">\n    You must click the I'm not a robot checkbox.\n  </div>\n  <button class=\"btn btn-large btn-info ModalLoginSignup-captchaForm-submit\"\n    ng-click=\"CaptchaForm.onSubmit()\"\n    ng-disabled=\"CaptchaForm.submittingSignup\">\n    <span ng-if=\"!CaptchaForm.submittingSignup\">\n      Join Freelancer\n    </span>\n    <span ng-if=\"CaptchaForm.submittingSignup\">\n      <div class=\"Loader Loader--small\"></div>\n    </span>\n  </button>\n</div>\n";

var flCaptchaForm = function () {
  function flCaptchaForm(Cdn, UserData) {
    _classCallCheck(this, flCaptchaForm);

    this.UserData = UserData;
    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.showError = false;
    this.isSubmitting = false;
    this.verifiedCaptcha = false;
  }

  _createClass(flCaptchaForm, [{
    key: 'onExpiredCaptcha',
    value: function onExpiredCaptcha() {
      this.verifiedCaptcha = false;
      this.UserData.user.captcha.response = '';
    }
  }, {
    key: 'onVerifyCaptcha',
    value: function onVerifyCaptcha(response) {
      if (!response) {
        return;
      }
      this.verifiedCaptcha = true;
      this.showError = false;
      this.UserData.user.captcha.response = response;
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      this.isSubmitting = true;
      if (this.verifiedCaptcha !== true) {
        this.showError = true;
        this.isSubmitting = false;
        return;
      }
      this.showError = false;
      this.onComplete();
    }
  }, {
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flCaptchaForm;
}();

flCaptchaForm.$inject = ['Cdn', 'UserData'];

var flCaptchaForm$1 = flComponent$1(flCaptchaForm, {
  selector: 'fl-captcha-form',
  template: captchaFormTemplate,
  bindings: {
    onCancel: '&',
    onComplete: '&',
    submittingSignup: '=',
    showAsModal: '=',
    closeModal: '&'
  },
  providers: [UserData$1, CdnProvider, flIconProvider, flRecaptcha$1]
});

var signupSuccessTemplate = "<div class=\"Modal-header\">\n  <div class=\"ModalLoginSignup-header\">\n    <button class=\"Modal-close\" ng-click=\"SignupSuccess.closeModal($event)\" type=\"button\" data-modal-hide aria-label=\"Close this modal window\"\n      ng-if=\"SignupSuccess.loginSignupConfig.isModal()\">\n      <span class=\"Icon Icon--small\">\n        <fl-icon name=\"ui-close\"></fl-icon>\n      </span>\n    </button>\n    <div id=\"fl-logo\" class=\"ModalLoginSignup-header-logo\">\n      <img ng-src=\"{[{SignupSuccess.headerImageUrl}]}\" alt=\"Freelancer logo\" />\n    </div>\n  </div>\n</div>\n<div class=\"Modal-body\" fl-analytics-section=\"Signup\">\n  <div class=\"ModalLoginSignup-signupSuccess\">\n    <h2 class=\"ModalLoginSignup-body-title\">Signup Success!</h2>\n    <div ng-if=\"SignupSuccess.loginSignupConfig.getSignupSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">{{SignupSuccess.loginSignupConfig.getSignupSuccessMessage()}}</p>\n    </div>\n    <div ng-if=\"!SignupSuccess.loginSignupConfig.getSignupSuccessMessage()\">\n      <p class=\"ModalLoginSignup-body-subtitle\">Please wait while we redirect you...</p>\n    </div>\n    <div class=\"ModalLoginSignup-signupSuccess-spinner\">\n      <div class=\"Loader Loader--large\"></div>\n    </div>\n  </div>\n</div>\n";

var flSignupSuccess = function () {
  function flSignupSuccess(Cdn, UserData, LoginSignupConfig) {
    _classCallCheck(this, flSignupSuccess);

    this.headerImageUrl = Cdn.getCdnUrl('/static/img/freelancer-logo.svg');
    this.UserData = UserData;
    this.loginSignupConfig = LoginSignupConfig;
  }

  _createClass(flSignupSuccess, [{
    key: 'closeModal',
    value: function closeModal($event) {
      this.closeModal({ $event: $event });
    }
  }]);

  return flSignupSuccess;
}();

flSignupSuccess.$inject = ['Cdn', 'UserData', 'LoginSignupConfig'];

var flSignupSuccess$1 = flComponent$1(flSignupSuccess, {
  selector: 'fl-signup-success',
  template: signupSuccessTemplate,
  bindings: { closeModal: '&' },
  providers: [CdnProvider, UserData$1, LoginSignupConfigProvider]
});

var signupTemplate = "<fl-signup-base-form\n  ng-if=\"Signup.currentStep === Signup.steps.BASE_STEP\"\n  on-complete=\"Signup.onCompleteBaseForm()\"\n  facebook-connect=\"Signup.facebookConnect()\"\n  facebook-errors=\"Signup.error.facebook\"\n  show-login-form=\"Signup.gotoLogin()\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-signup-base-form>\n<fl-username-input\n  ng-if=\"Signup.currentStep === Signup.steps.USERNAME_STEP\"\n  username-suggestions=\"Signup.usernameSuggestions\"\n  on-cancel=\"Signup.currentStep = Signup.steps.BASE_STEP\"\n  on-complete=\"Signup.onCompleteUsernameStep()\"\n  show-as-modal=\"Signup.showAsModal\"\n  is-submitting=Signup.isSubmitting\n  close-modal=\"Signup.closeModal($event)\">\n</fl-username-input>\n<fl-account-type-selector\n  ng-if=\"Signup.currentStep === Signup.steps.ACCOUNT_TYPE_STEP\"\n  on-cancel=\"Signup.currentStep = Signup.steps.USERNAME_STEP\"\n  on-complete=\"Signup.onCompleteAccountTypeStep()\"\n  submitting-signup=\"Signup.isSubmitting\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-account-type-selector>\n<fl-privacy-consent-form\n  ng-if=\"Signup.currentStep === Signup.steps.PRIVACY_CONSENT_STEP\"\n  on-cancel=\"Signup.currentStep = Signup.steps.ACCOUNT_TYPE_STEP\"\n  on-complete=\"Signup.onCompletePrivacyStep()\"\n  submitting-signup=\"Signup.isSubmitting\">\n</fl-privacy-consent-form>\n<fl-captcha-form\n  ng-if=\"Signup.currentStep === Signup.steps.CAPTCHA_STEP\"\n  on-complete=\"Signup.onCompleteCaptchaStep(response)\"\n  submitting-signup=\"Signup.isSubmitting\"\n  show-as-modal=\"Signup.showAsModal\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-captcha-form>\n<fl-signup-success\n  ng-if=\"Signup.currentStep === Signup.steps.SUCCESS_STEP\"\n  close-modal=\"Signup.closeModal($event)\">\n</fl-signup-success>\n<div class=\"Modal-footer\">\n  <div ng-messages=\"Signup.error\">\n    <div ng-message=\"accessDenied\" class=\"alert alert-error\">\n      There was a problem logging in with your account. Please contact <a href=\"https://www.freelancer.com/support\">support</a>.\n    </div>\n    <div ng-message=\"internalError\" class=\"alert alert-error\">\n      Something went wrong. Please try again.\n    </div>\n  </div>\n  <div ng-if=\"Signup.loginSignupConfig.showLoginOption() && Signup.currentStep === Signup.steps.BASE_STEP\"\n    class=\"ModalLoginSignup-switchLoginSignupType\">\n    Already have an account?\n    <a ng-click=\"Signup.gotoLogin()\" class=\"ModalLoginSignup--switchToLogin-link\">\n      Log In\n    </a>\n  </div>\n</div>\n";

/**
 * @ngdoc controller
 * @name LoginSignupApp.flSignup
 * @description
 * Handles the Signup Flow which consists of several steps:
 * 1. Email and Password Step (signup-base-form)
 * 2. Username Step (username-input)
 * 3. Account Type Step (account-type-selector)
 */

var flSignup = function () {
  function flSignup($window, $rootScope, Auth, Analytics, Cdn, CookieStore, Facebook, LoginSignupConfig, UserData, Users, UsersService) {
    var _this = this;

    _classCallCheck(this, flSignup);

    this.$window = $window;
    this.$rootScope = $rootScope;
    this.isSubmitting = false;
    this.Auth = Auth;
    this.Users = Users;
    this.UserData = UserData;
    this.UsersService = UsersService;
    this.Facebook = Facebook;
    this.Analytics = Analytics;
    this.Cdn = Cdn;
    this.CookieStore = CookieStore;
    this.loginSignupConfig = LoginSignupConfig;
    // Form
    this.error = {};
    this.steps = SIGNUP_STEPS;
    this.currentStep = this.steps.BASE_STEP;
    this.usernameSuggestions = [];
    this.referralSignupCookieKey = REFERRAL_SIGNUP_COOKIE_KEY;

    // Initialise User Object
    this.UserData.user.isNewUser = true;

    // Watch for Signup/Login switches, and auto connect facebook
    this.watchShowSignup = $rootScope.$watch(function () {
      return _this.loginSignupConfig.options.showSignup;
    }, function (newValue) {
      // If Show Signup was set to true, try auto connect facebook
      if (newValue === true && _this.UserData.isFacebookConnected()) {
        _this.facebookConnect(true, false);
      }
    });
  }

  /**
   * @ngdoc method
   * @name LoginSignupApp.flSignup#gotoLogin
   * @methodOf LoginSignupApp.flSignup
   * @description
   * Switches to Login funnel by:
   * Setting the rootscope variable to false in order for flLogin to be displayed.
   */

  _createClass(flSignup, [{
    key: 'gotoLogin',
    value: function gotoLogin() {
      // Clear Errors
      this.clearErrors();
      // Disconnect Facebook if Connected (stops Login from auto logging same
      // facebook account, and redirecting back to signup if it is a new account)
      this.UserData.setFacebookConnected(false);
      this.loginSignupConfig.switchToLogin();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteBaseForm
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the base form.
     * Generates suggested usernames and activates to step 2, which is username input.
     */

  }, {
    key: 'onCompleteBaseForm',
    value: function onCompleteBaseForm() {
      this.clearErrors();
      this.generateSuggestedUsernames();
      this.currentStep = this.steps.USERNAME_STEP;
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteUsernameStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the username input step.
     * Activates step 3 which is account type selector.
     */

  }, {
    key: 'onCompleteUsernameStep',
    value: function onCompleteUsernameStep() {
      this.clearErrors();
      // Check whether we can skip the Select Account Type Step.
      if (this.loginSignupConfig.getForcedAccountType() === USER_TYPE_FREELANCER) {
        this.UserData.user.role = USER_TYPE_FREELANCER;
        this.onCompleteAccountTypeStep();
      } else if (this.loginSignupConfig.getForcedAccountType() === USER_TYPE_EMPLOYER) {
        this.UserData.user.role = USER_TYPE_EMPLOYER;
        this.onCompleteAccountTypeStep();
      } else {
        this.currentStep = this.steps.ACCOUNT_TYPE_STEP;
      }
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteAccountTypeStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the account type selector step.
     *
     * Show Privacy Consent Form as next step for EU Users.
     * Default Privacy Consent to true for Non EU Users.
     */

  }, {
    key: 'onCompleteAccountTypeStep',
    value: function onCompleteAccountTypeStep() {
      this.clearErrors();

      var fromEU = this.CookieStore.get(IS_FROM_EU_COOKIE_KEY);
      if (fromEU === 'true') {
        this.UserData.user.isFromEU = true;
        this.UserData.user.privacyConsent = false;
      } else {
        this.UserData.user.isFromEU = false;
        this.UserData.user.privacyConsent = true;
      }
      // If User is from EU, show Privacy Step.
      if (this.UserData.user.isFromEU) {
        this.currentStep = this.steps.PRIVACY_CONSENT_STEP;
        return;
      }

      // Otherwise: Normal Signup Flow (default Privacy Consent to true)
      this.UserData.user.privacyConsent = true;
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompletePrivacyStep
     * @description
     * Call back for when user successfully completes the privacy step.
     */

  }, {
    key: 'onCompletePrivacyStep',
    value: function onCompletePrivacyStep() {
      this.clearErrors();
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onCompleteCaptchaStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Call back for when the user successfully completes the captcha step.
     */

  }, {
    key: 'onCompleteCaptchaStep',
    value: function onCompleteCaptchaStep() {
      this.clearErrors();
      if (this.UserData.isFacebookConnected()) {
        this.tryFacebookSignup();
        return;
      }
      this.tryUserSignup();
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onSignupSuccessStep
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Show Message whilst satisfying any redirects and callbacks.
     */

  }, {
    key: 'onSignupSuccessStep',
    value: function onSignupSuccessStep() {
      var source = this.UserData.isFacebookConnected() ? 'facebook' : 'normal';
      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'OnSignup',
        name: 'success',
        value: source
      });

      this.clearErrors();
      // If Redirect is not disabled, show success step while user is being
      // redirected. Otherwise, keep window open until signup is successful.
      if (!this.loginSignupConfig.isRedirectDisabled()) {
        this.currentStep = this.steps.SUCCESS_STEP;
      }
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#facebookConnect
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Connects to the User's Facebook Account, and stores the user's facebook profile
     * information in UserData.
     */

  }, {
    key: 'facebookConnect',
    value: function facebookConnect(skipLogin, retry) {
      var _this2 = this;

      // Clear Errors and define facebook error
      this.clearErrors();
      this.error.facebook = {};
      var authParamsPromise = void 0;
      // 1. Get Facebook auth params
      // If we come from Facebook login, we need to skip the login
      // step otherwise the popup will be blocked!
      if (!skipLogin) {
        authParamsPromise = this.Facebook.login();
      } else {
        authParamsPromise = this.Facebook.checkConnected().catch(function () {});
      }
      authParamsPromise.then(function (facebookAuthParams) {
        // 2. Get Facebook user infos
        _this2.UserData.setFacebookUserId(facebookAuthParams.userID);
        _this2.UserData.setFacebookAccessToken(facebookAuthParams.accessToken);
        _this2.UserData.user.facebookSignedRequest = facebookAuthParams.signedRequest;
        return _this2.Facebook.getUser();
      }).then(function (facebookUser) {
        _this2.UserData.setFacebookEmail(facebookUser.email);
        _this2.UserData.setFacebookName(facebookUser.first_name);

        // 3. Try to login to see if the facebook account is linked
        _this2.UsersService.loginWithFacebook(_this2.UserData.user).then(function (response) {
          if (response.data) {
            _this2.error.facebook.facebookLinked = true;
            _this2.Analytics.trackAction('facebook', 'login', 'SUCCESS');
            _this2.loginSuccess = true;
            _this2.$window.requestAnimationFrame(function () {
              _this2.onLoginSuccess({
                rememberLogin: false
              });
            });
          }
        }).catch(function () {
          if (_this2.loginSuccess) {
            return;
          }
          // 3. Check if user is registered
          _this2.Users.check({ email: _this2.UserData.user.facebookEmail }).then(function () {
            // User's Email is not taken. Must be new user.
            _this2.UserData.user.isNewUser = false;
            var url = _this2.Facebook.getUserPictureUrl(60, 60);
            if (url) {
              return url;
            }
            return _this2.Cdn.getCdnUrl('/img/unknown.png');
          }).then(function (facebookPictureUrl) {
            // 5. Display relevant form to continue facebook signup
            _this2.UserData.user.email = _this2.UserData.getFacebookEmail();
            _this2.UserData.setFacebookPictureUrl(facebookPictureUrl);
            _this2.UserData.setFacebookConnected(true);
            // Show Base Step
            _this2.currentStep = _this2.steps.BASE_STEP;
          }).catch(function (error) {
            if (error.code === 'EMAIL_TAKEN') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.emailTaken = true;
            } else if (error.code === 'EMAIL_BLOCKED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.emailBlocked = true;
            } else if (error.code === 'NOT_AUTHORISED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.notAuthorized = true;
            } else if (error.code === 'ACCESS_DENIED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              _this2.error.facebook.accessDenied = true;
            } else if (error.code === 'NOT_CONNECTED') {
              _this2.Analytics.trackAction('facebook', 'signup', error.code);
              if (retry) {
                _this2.facebookConnect();
              } else {
                _this2.error.facebook.notConnected = true;
              }
            } else {
              _this2.Analytics.trackError('facebook', 'signup', error.code, error.data);
              _this2.error.facebook.unknownError = true;
            }
          });
        });
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#tryFacebookSignup
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Attempts to Signup User through Facebook, using info stored in UserData.user
     */

  }, {
    key: 'tryFacebookSignup',
    value: function tryFacebookSignup() {
      var _this3 = this;

      if (this.isSubmitting === true) {
        return;
      }
      this.error = {};
      this.isSubmitting = true;
      this.Users.createWithFacebook(this.UserData.user, {
        userID: this.UserData.getFacebookUserId(),
        accessToken: this.UserData.getFacebookAccessToken()
      }, this.getAllExtraData()).then(function () {
        _this3.Analytics.trackAction('facebook', 'signup', 'SUCCESS');
        _this3.onSignupSuccessStep();
        _this3.removeExtraDataFromCookie();
        _this3.UsersService.setExtraCookies();
      }).then(function () {
        return _this3.UsersService.crossDomainSSO({
          data: {
            token: _this3.Auth.getAccessToken(),
            user: _this3.Auth.getUserId()
          }
        }, true);
      }).then(function () {
        return new Promise(function (resolve) {
          // Resolve LoginSignupConfig Callback first, before resolving then
          // going through any redirects.
          if (_this3.UserData.user.role === USER_TYPE_FREELANCER) {
            _this3.loginSignupConfig.resolveAuth(_this3.loginSignupConfig.authMessages.SIGNUP_FREELANCER);
          } else {
            _this3.loginSignupConfig.resolveAuth(_this3.loginSignupConfig.authMessages.SIGNUP_EMPLOYER);
          }
          resolve();
        }).then(function () {
          _this3.onSignupSuccessRedirect();
        });
      }).catch(function (error) {
        if (error.code === 'ACCESS_DENIED') {
          _this3.error.accessDenied = true;
        } else {
          _this3.error.internalError = true;
        }
        qtsp.push({
          section: _this3.loginSignupConfig.getPageName(),
          sub_section: 'LoginSignup',
          label: 'OnSignup',
          name: 'facebook_failure',
          value: error.code
        });

        _this3.isSubmitting = false;
      });
    }
  }, {
    key: 'removeExtraDataFromCookie',
    value: function removeExtraDataFromCookie() {
      this.CookieStore.remove(this.referralSignupCookieKey);
    }
  }, {
    key: 'getAllExtraData',
    value: function getAllExtraData() {
      var extraData = {};

      // Referral Signup
      var cookieData = this.CookieStore.get(REFERRAL_SIGNUP_COOKIE_KEY);
      if (cookieData) {
        extraData[REFERRAL_SIGNUP_COOKIE_KEY] = cookieData;
      }

      // Privacy Consent
      extraData[PRIVACY_CONSENT_KEY] = this.UserData.user.privacyConsent ? 'true' : 'false';

      // VAT Business/Individual User, only set the business_user if the option
      // is shown to the user.
      if (this.UserData.user.privateUser !== null) {
        extraData[BUSINESS_USER_KEY] = !this.UserData.user.privateUser ? 'true' : 'false';
      }

      if (this.loginSignupConfig.getProjectCollaborationInvitation() !== '') {
        extraData[PROJECT_COLLABORATION_INVITATION_KEY] = this.loginSignupConfig.getProjectCollaborationInvitation();
      }

      if (this.loginSignupConfig.getContestCollaborationInvitation() !== '') {
        extraData[CONTEST_COLLABORATION_INVITATION_KEY] = this.loginSignupConfig.getContestCollaborationInvitation();
      }

      return extraData;
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#tryUserSignup
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Attempts to Signup the user, using info stored in UserData.user
     */

  }, {
    key: 'tryUserSignup',
    value: function tryUserSignup() {
      var _this4 = this;

      if (this.isSubmitting === true) {
        return;
      }
      this.isSubmitting = true;
      this.error = {};
      this.Users.create(this.UserData.user, this.UserData.user.password, this.UserData.user.captcha, this.getAllExtraData()).then(function () {
        _this4.Analytics.trackAction('user', 'signup', 'SUCCESS');
        _this4.onSignupSuccessStep();
        _this4.removeExtraDataFromCookie();
        _this4.UsersService.setExtraCookies();
      }).then(function () {
        return _this4.UsersService.crossDomainSSO({
          data: {
            token: _this4.Auth.getAccessToken(),
            user: _this4.Auth.getUserId()
          }
        }, true);
      }).then(function () {
        return new Promise(function (resolve) {
          // Resolve LoginSignupConfig Callback first, before resolving then
          // going through any redirects.
          if (_this4.UserData.user.role === USER_TYPE_FREELANCER) {
            _this4.loginSignupConfig.resolveAuth(_this4.loginSignupConfig.authMessages.SIGNUP_FREELANCER);
          } else {
            _this4.loginSignupConfig.resolveAuth(_this4.loginSignupConfig.authMessages.SIGNUP_EMPLOYER);
          }
          resolve();
        }).then(function () {
          _this4.onSignupSuccessRedirect();

          // Close the modal only if there is no redirects
          if (_this4.loginSignupConfig.isRedirectDisabled()) {
            _this4.closeModal();
          }
        });
      }).catch(function (error) {
        if (error.code === 'CAPTCHA_REQUIRED') {
          _this4.UserData.user.captcha.challenge = error.data.request_id;
          _this4.currentStep = _this4.steps.CAPTCHA_STEP;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        } else if (error.code === 'ACCESS_DENIED') {
          _this4.error.accessDenied = true;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        } else {
          _this4.error.internalError = true;
          _this4.Analytics.trackAction('user', 'signup', error.code);
        }
        qtsp.push({
          section: _this4.loginSignupConfig.getPageName(),
          sub_section: 'LoginSignup',
          label: 'OnSignup',
          name: 'failure',
          value: error.code
        });

        _this4.isSubmitting = false;
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#onSignupSuccessRedirect
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Handles redirects on signup success (for both normal and facebook)
     * Currently happens after the Auth Promise has been resolved, and any call
     * backs related to Auth Promise (LoginSignupConfig) has been called.
     */

  }, {
    key: 'onSignupSuccessRedirect',
    value: function onSignupSuccessRedirect() {
      var _this5 = this;

      this.UsersService.getSignupRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl(), this.loginSignupConfig.getProjectCollaborationInvitation(), this.loginSignupConfig.getContestCollaborationInvitation()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;

          if (redirectUrl === 'reload') {
            _this5.$window.location.reload();
          } else if (redirectUrl !== '') {
            if (!redirectUrl.includes('?')) {
              redirectUrl = redirectUrl + '?';
            }

            _this5.$window.location.href = redirectUrl + '&new_signup=true';
          }
        }
      }).catch(function () {
        if (_this5.UserData.user.role === USER_TYPE_FREELANCER) {
          _this5.$window.location.href = '/new-freelancer';
        } else {
          _this5.$window.location.href = '/post-project?onboard=true';
        }
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#generateSuggestedUsernames
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Gets suggested usernames for the current email stored in UserData.
     * Is linked to the username-input component where it is then displayed.
     */

  }, {
    key: 'generateSuggestedUsernames',
    value: function generateSuggestedUsernames() {
      var _this6 = this;

      this.Users.check({ email: this.UserData.user.email }, { recommend_name: true }).then(function (result) {
        _this6.usernameSuggestions = [];
        _this6.usernameSuggestions.push(result.recommended_name);
        _this6.usernameSuggestions = _this6.usernameSuggestions.concat(result.alternate_names);
      }).catch(function (error) {
        _this6.Analytics.trackError('suggestUsernames', 'signup', error.error_code);
      });
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#clearErrors
     * @methodOf LoginSignupApp
     * @description
     * Clears all errors.
     */

  }, {
    key: 'clearErrors',
    value: function clearErrors() {
      this.error = {};
    }

    /**
     * @ngdoc method
     * @name LoginSignupApp.flSignup#clearErrors
     * @methodOf LoginSignupApp.flSignup
     * @description
     * Gets any errors currently set.
     */

  }, {
    key: 'getErrors',
    value: function getErrors() {
      return this.error;
    }
  }]);

  return flSignup;
}();

flSignup.$inject = ['$window', '$rootScope', 'Auth', 'Analytics', 'Cdn', 'CookieStore', 'Facebook', 'LoginSignupConfig', 'UserData', 'Users', 'UsersService'];

var flSignup$1 = flComponent$1(flSignup, {
  selector: 'fl-signup',
  template: signupTemplate,
  bindings: {
    showAsModal: '=',
    closeModal: '&',
    onLoginSuccess: '&'
  },
  providers: [AuthModule, UserData$1, UsersProvider$1, UsersProvider, CookieStoreProvider$1, FacebookProvider$1, AnalyticsModule, flCaptchaForm$1, flSignupSuccess$1, flUsernameInput$1, flSignupBaseForm$1, flPrivacyConsentForm$1, flAccountTypeSelector$1, flIconProvider, flPasswordCheck, flBlockedEmailCheck, CdnProvider, LoginSignupConfigProvider]
});

var template$4 = "<div ng-if=\"!LoginSignupModal.loginSignupConfig.isModal()\" class=\"Modal Modal--small\">\n  <div class=\"Modal-inner ModalLoginSignup-inner ModalLoginSignup--asPage\"\n    aria-hidden=\"false\" data-keyboard=\"false\" data-backdrop=\"static\">\n    <div class=\"Modal-dialog\" role=\"dialog\">\n      <div class=\"Modal-content Card\" role=\"document\">\n        <fl-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\" show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n          on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\">\n        </fl-signup>\n        <fl-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\" show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n          on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\"\n          current-step=\"LoginSignupModal.currentLoginStep\">\n        </fl-login>\n      </div>\n      <fl-app-links\n        ng-if=\"LoginSignupModal.loginSignupConfig.showAppLinks() && !LoginSignupModal.loginSignupConfig.options.showSignup\">\n      </fl-app-links>\n    </div>\n  </div>\n</div>\n\n<div ng-if=\"LoginSignupModal.loginSignupConfig.isModal()\">\n  <fl-signup ng-if=\"LoginSignupModal.loginSignupConfig.options.showSignup\" show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n    close-modal=\"LoginSignupModal.closeModal()\" on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\">\n  </fl-signup>\n  <fl-login ng-if=\"!LoginSignupModal.loginSignupConfig.options.showSignup\" show-as-modal=\"LoginSignupModal.loginSignupConfig.isModal()\"\n    close-modal=\"LoginSignupModal.closeModal()\" on-login-success=\"LoginSignupModal.onLoginSuccess(rememberLogin, forceRedirectUrl)\"\n    current-step=\"LoginSignupModal.currentLoginStep\">\n  </fl-login>\n</div>\n";

var LoginSignupModal = function () {
  function LoginSignupModal($rootScope, $window, CorporateService, LoginSignupConfig, UsersService) {
    _classCallCheck(this, LoginSignupModal);

    this.$rootScope = $rootScope;
    this.$window = $window;
    this.Corporate = CorporateService;
    this.UsersService = UsersService;
    this.loginSignupConfig = LoginSignupConfig;
    this.loginSteps = LOGIN_STEPS;
    this.currentLoginStep = LOGIN_STEPS.LOGIN_FORM;
  }

  _createClass(LoginSignupModal, [{
    key: 'loginUrlRedirect',
    value: function loginUrlRedirect(forceRedirectUrl) {
      var _this = this;

      if (forceRedirectUrl) {
        this.$window.location.href = forceRedirectUrl;
        return;
      }

      this.UsersService.getLoginRedirectUrl(this.loginSignupConfig.isRedirectDisabled(), this.loginSignupConfig.isModal(), this.loginSignupConfig.getRedirectUrl()).then(function (response) {
        if (response.data) {
          var redirectUrl = response.data.redirect_url;
          if (redirectUrl === 'reload') {
            _this.$window.location.reload();
          } else if (redirectUrl !== '') {
            _this.$window.location.href = redirectUrl;
          }
        }
      }).catch(function () {
        _this.$window.location.href = '/dashboard/';
      });
    }

    /**
     * @ngdoc method
     * @description
     * Resolves the Auth Promise in LoginSignupConfig, waits for any code linked
     * to that to complete, then resolves and deals with redirects.
     *
     * Not placed in flLogin.js because flSignup.js also needs access to this,
     * as it is possible to login via facebook on the Signup module.
     */

  }, {
    key: 'onLoginSuccess',
    value: function onLoginSuccess(rememberLogin, forceRedirectUrl) {
      var _this2 = this;

      qtsp.push({
        section: this.loginSignupConfig.getPageName(),
        sub_section: 'LoginSignup',
        label: 'OnLogin',
        name: 'success'
      });

      // Set Login Step as Success Step
      // This is done here instead of flLogin because flSignup can call this too.
      if (this.loginSignupConfig.isRedirectDisabled()) {
        this.loginSignupConfig.hide();
      } else {
        this.currentLoginStep = this.loginSteps.LOGIN_SUCCESS;
      }

      return new Promise(function (resolve) {
        // Login Signup Config Callbacks
        _this2.loginSignupConfig.resolveAuth(_this2.loginSignupConfig.authMessages.LOGIN_SUCCESS);
        resolve();
      }).then(function () {
        if (!_this2.Corporate.checkCorporate()) {
          _this2.loginUrlRedirect(forceRedirectUrl);
          return;
        }
        _this2.Corporate.swapAccount(rememberLogin).then(_this2.loginUrlRedirect(forceRedirectUrl));
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.loginSignupConfig.hide();
    }
  }]);

  return LoginSignupModal;
}();

LoginSignupModal.$inject = ['$rootScope', '$window', 'CorporateService', 'LoginSignupConfig', 'UsersService'];

var flLoginSignupModal = flComponent$1(LoginSignupModal, {
  selector: 'fl-login-signup-modal',
  template: template$4,
  providers: [ngRoute, flLogin$1, flSignup$1, flAppLinks$1, flIconProvider, UsersProvider$1, UsersProvider$1, CorporateProvider, UserData$1, LoginSignupConfigProvider]
});

var template$5 = "<fl-login-signup-modal ng-if=\"!LoginSignupAngular.loginSignupConfig.isModal()\"\n></fl-login-signup-modal>\n\n<fl-ui-modal ng-if=\"LoginSignupAngular.loginSignupConfig.options.showAppLinks && LoginSignupAngular.loginSignupConfig.isModal() && LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-selector=\"'fl-login-signup-modal'\"\n    modal-visible=\"LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-props=\"{ classes: 'Modal--small', disableBackdropClose: LoginSignupAngular.loginSignupConfig.isDisableBackdropClose() }\"\n    modal-shadow-footer-selector=\"'fl-app-links'\"\n    class=\"pinky-template\"\n></fl-ui-modal>\n\n<fl-ui-modal ng-if=\"!LoginSignupAngular.loginSignupConfig.options.showAppLinks && LoginSignupAngular.loginSignupConfig.isModal() && LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-selector=\"'fl-login-signup-modal'\"\n    modal-visible=\"LoginSignupAngular.loginSignupConfig.options.visible\"\n    modal-props=\"{ classes: 'Modal--small', disableBackdropClose: LoginSignupAngular.loginSignupConfig.isDisableBackdropClose() }\"\n    class=\"pinky-template\"\n></fl-ui-modal>\n\n\n<a ng-if=\"LoginSignupAngular.showLoginButton\"\n    ng-click=\"LoginSignupAngular.showLoginModal($event)\"\n    class=\"LoginSection-btn\" href=\"/login\"\n    data-uitest-target=\"login-button\"\n    data-qtsb-section=\"NavBar\"\n    data-qtsb-label=\"ShowLoginSplash\">Log In</a>\n\n<a ng-if=\"LoginSignupAngular.showSignupButton\"\n    ng-click=\"LoginSignupAngular.showSignupModal($event)\"\n    class=\"LoginSection-btn\" href=\"/signup\"\n    data-uitest-target=\"signup-button\"\n    data-qtsb-section=\"NavBar\"\n    data-qtsb-label=\"ShowHireSignupSplash\">Sign Up</a>\n";

var LoginSignupApp = function () {
  function LoginSignupApp(LoginSignupConfig) {
    _classCallCheck(this, LoginSignupApp);

    this.loginSignupConfig = LoginSignupConfig;
    this.modalProps = {
      classes: 'Modal--small',
      disableBackdropClose: this.loginSignupConfig.isDisableBackdropClose()
    };
  }

  _createClass(LoginSignupApp, [{
    key: 'showSignupModal',
    value: function showSignupModal($event) {
      $event.preventDefault();
      this.loginSignupConfig.showSignup().catch(function () {});
    }
  }, {
    key: 'showLoginModal',
    value: function showLoginModal($event) {
      $event.preventDefault();
      this.loginSignupConfig.showLogin().catch(function () {});
    }
  }]);

  return LoginSignupApp;
}();

LoginSignupApp.$inject = ['LoginSignupConfig'];
LoginSignupApp.$inject = ['LoginSignupConfig'];

function getUrlParameter(param) {
  var pageURL = decodeURIComponent(window.location.search.substring(1));
  var urlVariables = pageURL.split('&');
  var parameterName = void 0;
  var i = void 0;
  for (i = 0; i < urlVariables.length; i++) {
    parameterName = urlVariables[i].split('=');

    if (parameterName[0] === param) {
      return parameterName[1];
    }
  }
}

var skipCaptchaHash = typeof getUrlParameter('secured_connection') !== 'undefined' ? getUrlParameter('secured_connection') : '';

/**
 * Component for Angular Apps
 * Import with LoginSignupConfigProvider, for example usage see flWizardForm
 */
var LoginSignupComponent = flComponent$1(LoginSignupApp, {
  selector: 'fl-login-signup-angular',
  template: template$5,
  bindings: {
    showLoginButton: '=',
    showSignupButton: '='
  },
  providers: [
  // Component
  flLoginSignupModal, flIconProvider, flUiModalProvider, flAppLinks$1,

  // Service
  UsersProvider$1, UserData$1, AuthModule, LoginSignupConfigProvider]
});

/**
 * Initialise Login Signup Angular for non Angular code
 */
function init() {
  return new Promise(function (resolve) {
    var app = flApp('fl-login-signup-angular', [LoginSignupComponent], LoginSignupApp);

    // If app has already been initialised:
    var el = angular.element(document.querySelector('fl-login-signup-angular'));
    if (el.injector()) {
      var config = el.injector().get('LoginSignupConfig');
      config.options.skipCaptchaHash = skipCaptchaHash;
      resolve(config);
    }

    // Else wait on app.run
    app.run(function () {
      setTimeout(function () {
        var el = angular.element(document.querySelector('fl-login-signup-angular'));
        if (el.injector()) {
          var _config = el.injector().get('LoginSignupConfig');
          _config.options.skipCaptchaHash = skipCaptchaHash;
          resolve(_config);
        }
      });
    });
  });
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function assignInDefaults(objValue, srcValue, key, object) {
  if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
    return srcValue;
  }
  return objValue;
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    object[key] = value;
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto$2.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Reflect = root.Reflect;

/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Built-in value references. */
var enumerate = Reflect ? Reflect.enumerate : undefined,
    propertyIsEnumerable = objectProto$3.propertyIsEnumerable;

/**
 * The base implementation of `_.keysIn` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  object = object == null ? object : Object(object);

  var result = [];
  for (var key in object) {
    result.push(key);
  }
  return result;
}

// Fallback for IE < 9 with es6-shim.
if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
  baseKeysIn = function baseKeysIn(object) {
    return iteratorToArray(enumerate(object));
  };
}

var baseKeysIn$1 = baseKeysIn;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$4.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty$2.call(value, 'callee') && (!propertyIsEnumerable$1.call(value, 'callee') || objectToString$1.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$5.toString;

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString$2.call(value) == stringTag;
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) && (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$6;

  return value === proto;
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  var index = -1,
      isProto = isPrototype(object),
      props = baseKeysIn$1(object),
      propsLength = props.length,
      indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  while (++index < propsLength) {
    var key = props[index];
    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) && !(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

/** `Object#toString` result references. */
var errorTag = '[object Error]';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$3 = objectProto$8.toString;

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object,
 *  else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  return objectToString$3.call(value) == errorTag || typeof value.message == 'string' && typeof value.name == 'string';
}

/**
 * Attempts to invoke `func`, returning either the result or the caught error
 * object. Any additional arguments are provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {Function} func The function to attempt.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {*} Returns the `func` result or error object.
 * @example
 *
 * // Avoid throwing errors for invalid selectors.
 * var elements = _.attempt(function(selector) {
 *   return document.querySelectorAll(selector);
 * }, '>_>');
 *
 * if (_.isError(elements)) {
 *   elements = [];
 * }
 */
var attempt = baseRest(function (func, args) {
  try {
    return apply(func, undefined, args);
  } catch (e) {
    return isError(e) ? e : new Error(e);
  }
});

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function (key) {
    return object[key];
  });
}

/** Used to escape characters for inclusion in compiled string literals. */
var stringEscapes = {
  '\\': '\\',
  "'": "'",
  '\n': 'n',
  '\r': 'r',
  '\u2028': 'u2028',
  '\u2029': 'u2029'
};

/**
 * Used by `_.template` to escape characters for inclusion in compiled string literals.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
function escapeStringChar(chr) {
  return '\\' + stringEscapes[chr];
}

/**
 * Creates a function that invokes `func` with its first argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf;

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
var getPrototype = overArg(nativeGetPrototype, Object);

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return object != null && (hasOwnProperty$4.call(object, key) || typeof object == 'object' && key in object && getPrototype(object) === null);
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object.keys;

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
var baseKeys = overArg(nativeKeys, Object);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) && !(skipIndexes && (key == 'length' || isIndex(key, length))) && !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function (key) {
    return object == null ? undefined : object[key];
  };
}

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Built-in value references. */
var Symbol = root.Symbol;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto$10 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$4 = objectProto$10.toString;

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && objectToString$4.call(value) == symbolTag;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape$1(string) {
    string = toString(string);
    return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
}

/** Used to match template delimiters. */
var reEscape = /<%-([\s\S]+?)%>/g;

/** Used to match template delimiters. */
var reEvaluate = /<%([\s\S]+?)%>/g;

/**
 * By default, the template delimiters used by lodash are like those in
 * embedded Ruby (ERB). Change the following template settings to use
 * alternative delimiters.
 *
 * @static
 * @memberOf _
 * @type {Object}
 */
var templateSettings = {

  /**
   * Used to detect `data` property values to be HTML-escaped.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'escape': reEscape,

  /**
   * Used to detect code to be evaluated.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'evaluate': reEvaluate,

  /**
   * Used to detect `data` property values to inject.
   *
   * @memberOf _.templateSettings
   * @type {RegExp}
   */
  'interpolate': reInterpolate,

  /**
   * Used to reference the data object in the template text.
   *
   * @memberOf _.templateSettings
   * @type {string}
   */
  'variable': '',

  /**
   * Used to import variables into the compiled template.
   *
   * @memberOf _.templateSettings
   * @type {Object}
   */
  'imports': {

    /**
     * A reference to the `lodash` function.
     *
     * @memberOf _.templateSettings.imports
     * @type {Function}
     */
    '_': { 'escape': escape$1 }
  }
};

/** Used to match empty string literals in compiled template source. */
var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

/**
 * Used to match
 * [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components).
 */
var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

/** Used to ensure capturing order of template delimiters. */
var reNoMatch = /($^)/;

/** Used to match unescaped characters in compiled string literals. */
var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

/**
 * Creates a compiled template function that can interpolate data properties
 * in "interpolate" delimiters, HTML-escape interpolated data properties in
 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
 * properties may be accessed as free variables in the template. If a setting
 * object is given, it takes precedence over `_.templateSettings` values.
 *
 * **Note:** In the development build `_.template` utilizes
 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
 * for easier debugging.
 *
 * For more information on precompiling templates see
 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
 *
 * For more information on Chrome extension sandboxes see
 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The template string.
 * @param {Object} [options={}] The options object.
 * @param {RegExp} [options.escape=_.templateSettings.escape]
 *  The HTML "escape" delimiter.
 * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
 *  The "evaluate" delimiter.
 * @param {Object} [options.imports=_.templateSettings.imports]
 *  An object to import into the template as free variables.
 * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
 *  The "interpolate" delimiter.
 * @param {string} [options.sourceURL='templateSources[n]']
 *  The sourceURL of the compiled template.
 * @param {string} [options.variable='obj']
 *  The data object variable name.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the compiled template function.
 * @example
 *
 * // Use the "interpolate" delimiter to create a compiled template.
 * var compiled = _.template('hello <%= user %>!');
 * compiled({ 'user': 'fred' });
 * // => 'hello fred!'
 *
 * // Use the HTML "escape" delimiter to escape data property values.
 * var compiled = _.template('<b><%- value %></b>');
 * compiled({ 'value': '<script>' });
 * // => '<b>&lt;script&gt;</b>'
 *
 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the internal `print` function in "evaluate" delimiters.
 * var compiled = _.template('<% print("hello " + user); %>!');
 * compiled({ 'user': 'barney' });
 * // => 'hello barney!'
 *
 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
 * var compiled = _.template('hello ${ user }!');
 * compiled({ 'user': 'pebbles' });
 * // => 'hello pebbles!'
 *
 * // Use backslashes to treat delimiters as plain text.
 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
 * compiled({ 'value': 'ignored' });
 * // => '<%- value %>'
 *
 * // Use the `imports` option to import `jQuery` as `jq`.
 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
 * compiled({ 'users': ['fred', 'barney'] });
 * // => '<li>fred</li><li>barney</li>'
 *
 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
 * compiled(data);
 * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
 *
 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
 * compiled.source;
 * // => function(data) {
 * //   var __t, __p = '';
 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
 * //   return __p;
 * // }
 *
 * // Use custom template delimiters.
 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
 * var compiled = _.template('hello {{ user }}!');
 * compiled({ 'user': 'mustache' });
 * // => 'hello mustache!'
 *
 * // Use the `source` property to inline compiled templates for meaningful
 * // line numbers in error messages and stack traces.
 * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
 *   var JST = {\
 *     "main": ' + _.template(mainText).source + '\
 *   };\
 * ');
 */
function template$6(string, options, guard) {
  // Based on John Resig's `tmpl` implementation
  // (http://ejohn.org/blog/javascript-micro-templating/)
  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
  var settings = templateSettings.imports._.templateSettings || templateSettings;

  if (guard && isIterateeCall(string, options, guard)) {
    options = undefined;
  }
  string = toString(string);
  options = assignInWith({}, options, settings, assignInDefaults);

  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
      importsKeys = keys(imports),
      importsValues = baseValues(imports, importsKeys);

  var isEscaping,
      isEvaluating,
      index = 0,
      interpolate = options.interpolate || reNoMatch,
      source = "__p += '";

  // Compile the regexp to match each delimiter.
  var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

  // Use a sourceURL for easier debugging.
  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';

  string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
    interpolateValue || (interpolateValue = esTemplateValue);

    // Escape characters that can't be included in string literals.
    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

    // Replace delimiters with snippets.
    if (escapeValue) {
      isEscaping = true;
      source += "' +\n__e(" + escapeValue + ") +\n'";
    }
    if (evaluateValue) {
      isEvaluating = true;
      source += "';\n" + evaluateValue + ";\n__p += '";
    }
    if (interpolateValue) {
      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
    }
    index = offset + match.length;

    // The JS engine embedded in Adobe products needs `match` returned in
    // order to produce the correct `offset` value.
    return match;
  });

  source += "';\n";

  // If `variable` is not specified wrap a with-statement around the generated
  // code to add the data object to the top of the scope chain.
  var variable = options.variable;
  if (!variable) {
    source = 'with (obj) {\n' + source + '\n}\n';
  }
  // Cleanup code by stripping empty strings.
  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

  // Frame code as the function body.
  source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';

  var result = attempt(function () {
    return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
  });

  // Provide the compiled function's source by its `toString` method or
  // the `source` property as a convenience for inlining compiled templates.
  result.source = source;
  if (isError(result)) {
    throw result;
  }
  return result;
}

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto$11 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$5 = objectProto$11.toString;

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' || isObjectLike(value) && objectToString$5.call(value) == numberTag;
}

var TRANSLATE_MODE_COOKIE = cookieBase + '_TRANSLATE_MODE';

var isTranslateModeEnabled = function isTranslateModeEnabled() {
  return getCookie(TRANSLATE_MODE_COOKIE) === '1';
};

var getTokenizedMessage = function getTokenizedMessage(id, message) {
  return isTranslateModeEnabled() ? '~=[' + id + '|^|' + message + ']=~' : message;
};

var translate = function translate(first) {
  for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  switch (true) {
    case isString(first):
      {
        var text = first;
        var vars = rest[0];
        if (typeof vars === 'undefined' || !vars) {
          return text;
        }
        var result = template$6(text, {
          evaluate: /<\[([\s\S]+?)\]>/g,
          interpolate: /<\[=([\s\S]+?)\]>/g,
          escape: /<\[-([\s\S]+?)\]>/g
        })(vars);
        result = template$6(result)(vars);
        return result;
      }
    case isArray(first):
      {
        return oneLine([translate.raw.apply(translate, [first].concat(rest))]);
      }
    case isNumber(first):
      {
        var _ret = function () {
          var sourceTextId = first;
          return {
            v: function v() {
              return getTokenizedMessage(sourceTextId, translate.apply(undefined, arguments));
            }
          };
        }();

        if (typeof _ret === "object") return _ret.v;
      }
    default:
      {
        throw new TypeError('Invalid argument types');
      }
  }
};

translate.raw = function rawT(literals) {
  for (var _len2 = arguments.length, placeholders = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    placeholders[_key2 - 1] = arguments[_key2];
  }

  return literals.raw.reduce(function (str, current, index) {
    var temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

GoogleMapsLoader.KEY = 'AIzaSyAWB_zZMjdwNlu8-9xZ8RyNRbCERQTWSR8';
GoogleMapsLoader.LIBRARIES = ['places'];
GoogleMapsLoader.LANGUAGE = 'en';

var gmapPromise = new Promise(function (resolve) {
  GoogleMapsLoader.load(resolve);
});

/**
 * Sets a Google map.
 * @param {String} opts The object containing the configuration for the map.
 * @param {String} opts.mapElement The id of the input field that will house the map.
 */

var LocalMap = function LocalMap(opts) {
  var _this = this;

  _classCallCheck(this, LocalMap);

  this.config = opts;
  gmapPromise.then(function (google) {
    _this.gmap = google.maps;
    _this.mapCenter = new _this.gmap.LatLng(_this.config.latitude, _this.config.longitude);

    _this.localMap = new _this.gmap.Map(document.getElementById(_this.config.mapElement), {
      center: _this.mapCenter,
      zoom: 15
    });

    _this.centerMarker = new _this.gmap.Marker({
      position: _this.mapCenter,
      icon: '/static/css/images/localjobs/track-point-current-2.png',
      map: _this.localMap
    });
  });
};

/**
 * Factory method to create LocalMap class
 */

function createLocalMap(opts) {
  return new LocalMap(opts);
}

var fixedBannerEl = document.getElementById('fixed-banner');
var fixedBannerCloseEl = document.getElementById('fixed-banner-close');
var localMapEl = document.getElementById('local-map');
var repostBtnEl = document.querySelector('[data-repost-btn]');
var postBtnEl = document.querySelector('[data-post-btn]');
var fixedBannerInputEl = document.getElementById('fixed-banner-form-input');
var freelancerProfileLnkEls = Array.from(document.querySelectorAll('[data-freelancer-profile-lnk]'));

var signupButtonEls = Array.from(document.getElementsByClassName('pvp-logged-out-signup-button'));

var signupEmailEls = Array.from(document.getElementsByClassName('pvp-logged-out-signup-email'));

var moreLessEls = Array.from(document.getElementsByClassName('FreelancerInfo-about-moreLink'));

var bidInputEls = Array.from(document.querySelectorAll('[data-signup-bid]'));
var projectStateEls = document.querySelector('[data-project-state]');

bindEvents();

function bindEvents() {
  if (localMapEl) {
    createLocalMap({
      mapElement: 'local-map',
      latitude: localMapEl.dataset.localMapLatitude,
      longitude: localMapEl.dataset.localMapLongitude });
  }

  if (fixedBannerCloseEl && fixedBannerEl) {
    fixedBannerCloseEl.addEventListener('click', function () {
      fixedBannerEl.classList.add('is-hidden');
    });
  }

  if (repostBtnEl) {
    repostBtnEl.addEventListener('click', function () {
      addQTS('repost', repostBtnEl.dataset.repostBtn);
    });
  }

  if (postBtnEl) {
    postBtnEl.addEventListener('click', function () {
      addQTS('post', fixedBannerInputEl.value);
    });
  }

  if (freelancerProfileLnkEls) {
    freelancerProfileLnkEls.forEach(function (el) {
      el.addEventListener('click', function () {
        addQTS('profile-lnk', el.dataset.freelancerProfileLnk);
      });
    });
  }

  if (signupButtonEls) {
    signupButtonEls.forEach(function (buttonEl) {
      buttonEl.addEventListener('click', function (e) {
        e.preventDefault();
        var signupOptions = { isEmployer: false };
        var emailAddress = null;
        var bidAmount = null;
        signupEmailEls.some(function (emailEl) {
          if (emailEl.value) {
            emailAddress = emailEl.value;
            signupOptions.emailAddress = emailEl.value;
            bidInputEls.some(function (bidInputEl) {
              if (bidInputEl.value) {
                bidAmount = bidInputEl.value;
                return true;
              }
              return false;
            });
            return true;
          }
          return false;
        });
        addQTS(buttonEl.dataset.subsection, 'email:' + emailAddress + ',bid:' + bidAmount);

        initializeLoginSignup(signupOptions);
        return true;
      });
    });
  }

  if (moreLessEls) {
    moreLessEls.forEach(function (moreLessEl) {
      moreLessEl.addEventListener('click', function (e) {
        e.preventDefault();
        var descrEl = moreLessEl.parentNode.querySelector('.bid-descr');
        if (moreLessEl.classList.contains('more')) {
          descrEl.textContent = moreLessEl.parentNode.dataset.descrFull;
          descrEl.parentNode.classList.add('is-FreelancerInfo-about-detailed');
          moreLessEl.classList.remove('more');
          moreLessEl.classList.add('less');
          moreLessEl.textContent = translate('Ít hơn');
        } else {
          descrEl.textContent = moreLessEl.parentNode.dataset.descrShort;
          descrEl.parentNode.classList.remove('is-FreelancerInfo-about-detailed');

          moreLessEl.classList.remove('less');
          moreLessEl.classList.add('more');
          moreLessEl.textContent = translate('Nhiều hơn');
        }
      });
    });
  }
}

function initializeLoginSignup(signupOptions) {
  init().then(function (LoginSignup) {
    LoginSignup.showSignup(signupOptions).catch(function () {});
  });
}

function addQTS(subsection, label) {
  qtsp.push({
    eventName: 'user_action',
    section: 's3-logged-out-pvp',
    subsection: subsection,
    label: label,
    action: 'click',
    name: projectStateEls.dataset.projectState });
}
